var nscs;
(function (nscs) {
    class App extends Phaser.Game {
        constructor() {
            let config = {
                type: nscs.util.Functions.DetectPhaserRenderMode(),
                width: App.CANVAS_WIDTH,
                height: App.CANVAS_HEIGHT,
                physics: {
                    default: 'arcade',
                    arcade: {
                        gravity: { y: nscs.gameplay.Gameplay.gravity0 }
                    }
                },
                scale: {
                    mode: FitScaleManager.detectBestScaleMode(),
                    autoCenter: Phaser.Scale.CENTER_BOTH
                },
                transparent: false,
                scene: {
                    create: () => {
                        this.scene.add('Boot', nscs.scene.Boot, true);
                    }
                }
            };
            super(config);
        }
    }
    App.CANVAS_WIDTH = 480;
    App.CANVAS_HEIGHT = 320;
    nscs.App = App;
})(nscs || (nscs = {}));
function toGlobal(object, point) {
    let pos = point ? { x: point.x, y: point.y } : { x: 0, y: 0 };
    let parentContainer = object;
    while (parentContainer) {
        pos.x *= parentContainer.scaleX;
        pos.y *= parentContainer.scaleY;
        pos.x += parentContainer.x;
        pos.y += parentContainer.y;
        parentContainer = parentContainer.parentContainer;
    }
    return pos;
}
let game;
window.onload = () => {
    nscs.util.Functions.rewriteWordWrapping();
    game = new nscs.App();
};
/**
 * @author Roman Parada
 * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
 * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
 *
 * How to use:
 * Just call the code line below in Boot scene's init() method of your project:
 * new FitScaleManager(this.game).setup();
 */
class FitScaleManager {
    constructor(game) {
        this.doResize = () => {
            let scale = this.calculateScale();
            let newCanvasWidth = this.phaserScaleManager.width * scale;
            let newCanvasHeight = this.phaserScaleManager.height * scale;
            this.canvasStyle.width = newCanvasWidth + 'px';
            this.canvasStyle.height = newCanvasHeight + 'px';
            this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
            this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
        };
        this.game = game;
        this.canvasStyle = this.game.canvas.style;
        this.phaserScaleManager = this.game.scale;
    }
    static detectBestScaleMode() {
        let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
        let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
        return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
    }
    ;
    /**
     * Just call this method once in Boot scene's init() method
     */
    setup() {
        this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
        this.overridePhaserTransformMethods();
        this.onResize();
    }
    calculateScale() {
        if (game.scale.scaleMode == Phaser.Scale.NONE)
            return 1;
        return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
    }
    overridePhaserTransformMethods() {
        this.game.scale.transformX = (pageX) => {
            return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
        };
        this.game.scale.transformY = (pageY) => {
            return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
        };
    }
    onResize() {
        setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
    }
}
FitScaleManager.RESIZE_DELAY = 500;
var nscs;
(function (nscs) {
    var character;
    (function (character) {
        class Boss extends Phaser.GameObjects.Container {
            constructor(scene) {
                super(scene, 0, 0);
                this.lives = 4;
                this.player = null;
                this.currAnimComplete = true;
                this.currAnim = null;
                this.currTween = null;
                this.currAction = null;
                this.nextAction = (nextAction = null) => {
                    if (this.lives <= 0) {
                        return;
                    }
                    if (typeof nextAction != "string") {
                        let rnd = Math.random();
                        /*if (rnd <= 0.1) {
                            nextAction = 'y-idle';
                        } else */ if (rnd <= 0.7) {
                            nextAction = 'follow-player';
                        }
                        else if (rnd <= 1) {
                            nextAction = 'attack-down';
                        }
                    }
                    this.doAction(nextAction);
                };
                this.isPlayerEnteredBattle = false;
                this.ticker = 0;
                this.shacklerXMC = nscs.scene.MainScene.instance.physics.add.sprite(0, 0, 'boss-atlas', 'shacklerXMC' + '0000');
                this.shacklerXMC.setOrigin(0.5, 0);
                this.shacklerXMC.setBounce(0);
                this.shacklerXMC.setCollideWorldBounds(false);
                this.shacklerXMC.setImmovable(true);
                this.shacklerXMC.body["setAllowGravity"](false);
                this.shacklerXMC.body.setSize(105, 65);
                this.shacklerXMC.body.setOffset(30, 60);
                this.add(this.shacklerXMC);
                this.greenLeft_mc = new Phaser.GameObjects.Image(this.scene, -39, 87, 'boss-atlas', 'greenLeft_mc' + '0000');
                this.add(this.greenLeft_mc);
                this.greenRight_mc = new Phaser.GameObjects.Image(this.scene, 39, 87, 'boss-atlas', 'greenLeft_mc' + '0000');
                this.add(this.greenRight_mc);
                this.redLeft_mc = new Phaser.GameObjects.Image(this.scene, -39, 87, 'boss-atlas', 'redLeft_mc' + '0000');
                this.add(this.redLeft_mc);
                this.redRight_mc = new Phaser.GameObjects.Image(this.scene, 39, 87, 'boss-atlas', 'redLeft_mc' + '0000');
                this.add(this.redRight_mc);
                let shacklerXMC_animations = {
                    'showTenons': { 'start': 0, 'end': 61, 'showTenons': 120 },
                    'idle': { 'start': 61, 'end': 61, 'showTenons': 60 },
                    'hit': { 'start': 62, 'end': 227, 'showTenons': 60 },
                    'stomp': { 'start': 228, 'end': 279, 'showTenons': 60 }
                };
                for (let k in shacklerXMC_animations) {
                    let anim = nscs.gameplay.Factory.createAnimName(k, 'shacklerXMC');
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(this.shacklerXMC.texture.key, {
                                start: shacklerXMC_animations[k]['start'], end: shacklerXMC_animations[k]['end'], zeroPad: 4,
                                prefix: 'shacklerXMC', suffix: ''
                            }),
                            frameRate: shacklerXMC_animations[k]['showTenons']
                        });
                    }
                }
                this.shacklerXMC.on('animationcomplete', () => { this.currAnimComplete = true; });
                this.ronald_mc = nscs.scene.MainScene.instance.factory.createRonaldSprite();
                this.ronald_mc.setOrigin(0.57, 0.2);
                this.ronald_mc.setPosition(0, 0);
                this.add(this.ronald_mc);
                this.visible = false;
            }
            setup(player, minX, maxX, topY, bottomY, onDieCallback, onAttackCallback) {
                this.player = player;
                this.minX = minX;
                this.maxX = maxX;
                this.topY = topY;
                this.bottomY = bottomY;
                this.onDieCallback = onDieCallback;
                this.onAttackCallback = onAttackCallback;
                this.underScreenPositionY = this.bottomY + 300;
            }
            playAnimation(anim) {
                if (anim != this.currAnim) {
                    this.shacklerXMC.anims.stop();
                }
                this.currAnim = anim;
                this.currAnimComplete = false;
                this.shacklerXMC.anims.play(nscs.gameplay.Factory.createAnimName(anim, 'shacklerXMC'), true);
            }
            doAction(action) {
                // console.log(action);
                this.destroyCurrTween();
                this.currAction = action;
                if (action == 'y-idle') {
                    this.currTween = this.scene.tweens.add({
                        targets: this,
                        y: this.topY + (Math.random() * 0.1 + 0.1) * (this.bottomY - this.topY),
                        duration: (250 + Math.random() * 250) * 0.75,
                        repeat: 1,
                        yoyo: true,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: () => this.nextAction(),
                        onRepeat: () => {
                            if (this.ronald_mc.anims.getCurrentKey() == 'disappear') {
                                this.ronald_mc.play('appear');
                            }
                        }
                    });
                    this.playAnimation('idle');
                    if (Math.random() > 0.5) {
                        this.ronald_mc.play('disappear');
                    }
                    else {
                        this.ronald_mc.play('midLaugh');
                        nscs.sound.SoundManager.getInstance().playSound(Phaser.Utils.Array.GetRandom(['laugh1SND', 'laugh2SND', 'laugh3SND']));
                    }
                }
                else if (action == 'follow-player') {
                    let x = this.player.sprite.x + (Math.random() - 0.5) * 60;
                    if (x > this.maxX - this.shacklerXMC.width / 2) {
                        x = this.maxX - this.shacklerXMC.width / 2;
                    }
                    else if (x < this.minX + this.shacklerXMC.width / 2) {
                        x = this.minX + this.shacklerXMC.width / 2;
                    }
                    let rnd = Math.random();
                    let nextAnim = 'attack-down';
                    /*if (rnd < 0.1) {
                        nextAnim = 'y-idle';
                    } else */ if (rnd < 0.5 || Math.abs(this.player.sprite.x - this.x) > 100) {
                        nextAnim = 'follow-player';
                    }
                    else {
                        nextAnim = 'attack-down';
                    }
                    this.currTween = this.scene.tweens.add({
                        targets: this,
                        x: x,
                        y: Math.random() > 0.5 || nextAnim == 'attack-down' ? this.topY : this.y,
                        duration: 2000 + Math.random() * 1000,
                        ease: Phaser.Utils.Array.GetRandom([Phaser.Math.Easing.Sine.Out, Phaser.Math.Easing.Back.In, Phaser.Math.Easing.Back.Out]),
                        onComplete: () => this.nextAction(nextAnim)
                    });
                    this.playAnimation('idle');
                    this.ronald_mc.play('laugh');
                    nscs.sound.SoundManager.getInstance().playSound(Phaser.Utils.Array.GetRandom(['laugh1SND', 'laugh2SND', 'laugh3SND']));
                    nscs.sound.SoundManager.getInstance().playSound('bossMoveSND');
                }
                else if (action == 'attack-down') {
                    this.currTween = this.scene.tweens.add({
                        targets: this,
                        y: this.bottomY,
                        duration: 250,
                        delay: (1000 + Math.random() * 500) * 0.75,
                        ease: Phaser.Math.Easing.Sine.In,
                        onComplete: () => {
                            this.currTween = this.scene.tweens.add({
                                targets: this,
                                y: this.bottomY - 4,
                                duration: (3000) * 0.75,
                                onComplete: () => {
                                    this.nextAction(Math.random() > 0.5 ? 'move-up' : 'follow-player');
                                }
                            });
                            this.ronald_mc.play('appear');
                            nscs.sound.SoundManager.getInstance().playSound('bossStompSND');
                        },
                        onStart: () => {
                            this.playAnimation('stomp');
                        }
                    });
                    this.ronald_mc.play('disappear');
                    nscs.sound.SoundManager.getInstance().playSound('bossPowerSND');
                    nscs.sound.SoundManager.getInstance().playSound('bossHomingSND');
                }
                else if (action == 'move-up') {
                    this.currTween = this.scene.tweens.add({
                        targets: this,
                        y: this.topY,
                        duration: (1500) * 0.75,
                        ease: Phaser.Math.Easing.Back.Out,
                        onComplete: () => this.nextAction('y-idle')
                    });
                    this.playAnimation('showTenons');
                    if (this.ronald_mc.anims.getCurrentKey() != 'appear') {
                        this.ronald_mc.play('appear');
                    }
                    nscs.sound.SoundManager.getInstance().playSound('bossRiseSND');
                    nscs.sound.SoundManager.getInstance().playSound('bossSpikesSND');
                }
                else if (action == 'hide-under-screen') {
                    this.currTween = this.scene.tweens.add({
                        targets: this,
                        y: this.underScreenPositionY,
                        duration: (1500) * 0.75,
                        delay: (1500) * 0.75,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onStart: () => this.ronald_mc.play('disappear')
                    });
                    this.playAnimation('hit');
                    this.ronald_mc.play('disappear');
                    nscs.sound.SoundManager.getInstance().playSound('bossBaffSND');
                }
                else if (action == 'hit') {
                    this.currTween = this.scene.tweens.add({
                        targets: this,
                        y: this.y,
                        duration: (500 + Math.random() * 2000) * 0.75,
                        ease: Phaser.Math.Easing.Linear,
                        onComplete: () => this.nextAction()
                    });
                    this.playAnimation('hit');
                    this.ronald_mc.play('hit');
                    nscs.sound.SoundManager.getInstance().playSound('bossBaffSND');
                }
            }
            showUp() {
                this.visible = true;
                this.y = this.underScreenPositionY;
                this.nextAction('move-up');
            }
            destroyCurrTween() {
                if (this.currTween) {
                    this.scene.tweens.remove(this.currTween);
                    this.currTween = null;
                }
            }
            hideDown() {
                this.destroyCurrTween();
                this.nextAction('hide-under-screen');
            }
            hit() {
                if (this.lives <= 0)
                    return;
                this.lives--;
                if (this.lives == 0) {
                    this.doAction('hide-under-screen');
                    this.onDieCallback();
                }
                else {
                    this.doAction('hit');
                }
                nscs.sound.SoundManager.getInstance().playSound('hairballHitSND');
            }
            updateBoss() {
                if (!this.isPlayerEnteredBattle) {
                    if (this.player.sprite.y > this.topY) {
                        this.isPlayerEnteredBattle = true;
                        this.showUp();
                    }
                    return;
                }
                this.ronald_mc.scaleX = this.player.sprite.x > this.x ? -1 : 1;
                let overlaps = this.scene.physics.world.collide(this.player.sprite, this.shacklerXMC);
                if (overlaps) {
                    if (this.shacklerXMC.body.touching.up) {
                        if (this.currAnim != 'hit' && this.currAnim != 'hide-under-screen') {
                            this.hit();
                        }
                        this.player.doJump(1);
                        this.player.doSideJump(this.player.sprite.x < this.x ? -3 : 3);
                    }
                    else {
                        if (!((this.shacklerXMC.body.touching.right || this.shacklerXMC.body.touching.left) && this.currAnim == 'stomp')) {
                            this.onAttackCallback();
                            this.player.onRespawn = () => {
                                this.isPlayerEnteredBattle = false;
                                this.visible = false;
                            };
                            nscs.sound.SoundManager.getInstance().playSound('thumpSND');
                        }
                        this.player.doSideJump(this.player.sprite.x < this.x ? -2 : 2);
                    }
                }
                this.updateLights();
                this.ticker++;
            }
            updateLights() {
                this.redLeft_mc.visible = this.redRight_mc.visible = this.greenLeft_mc.visible = this.greenRight_mc.visible = false;
                if (this.currAnim != 'stomp' && this.currAction == 'attack-down') {
                    this.redLeft_mc.visible = this.redRight_mc.visible = this.ticker % 20 > 10;
                }
                else {
                    if (this.currAnim == 'follow-player' || this.currAnim == 'idle') {
                        this.greenLeft_mc.visible = this.ticker % 45 > 25;
                        this.greenRight_mc.visible = this.ticker % 60 > 30;
                    }
                }
            }
            destroy(fromScene) {
                this.destroyCurrTween();
                super.destroy(fromScene);
            }
        }
        character.Boss = Boss;
    })(character = nscs.character || (nscs.character = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var character;
    (function (character) {
        class Player {
            constructor() {
                this.frameName = null;
                this.immortalBlinkingTicker = 0;
                this.pounceLanding = false;
                this.isFlagReached = false;
                this.offsetsData = {
                    "flipped": {
                        'chickette_small': { x: 14, y: 7 },
                        'chickette_big': { x: 14, y: 4 },
                        'nugget_small': { x: 16, y: 7 },
                        'nugget_big': { x: 16, y: 4 },
                        'pam_small': { x: 17, y: 7 },
                        'pam_big': { x: 17, y: 4 }
                    },
                    "normal": {
                        'chickette_small': { x: 14, y: 31 },
                        'chickette_big': { x: 14, y: 16 },
                        'nugget_small': { x: 16, y: 30 },
                        'nugget_big': { x: 16, y: 18 },
                        'pam_small': { x: 17, y: 34 },
                        'pam_big': { x: 17, y: 12 }
                    }
                };
                this.tempDead = false;
                this.onRespawn = null;
                this.topPriorityAnimations = ['grow', 'seaKittenise', 'pounceLand'];
                this.currAnimComplete = true;
                this.currAnim = null;
                this.sideJumpTicker = 0;
                this.notContactingDownTicker = 0;
                this.fallenBelowTheWorld = false;
                this.contactLeftWithStaticObject = false;
                this.contactRightWithStaticObject = false;
                this.contactDownWithStaticObject = false;
                this.pipeGoing = false;
                this.isPlayerLadding = false;
                this.fanUp = false;
                this.fanDown = false;
                this.fanLeft = false;
                this.fanRight = false;
                this.spaceDownTicker = 0;
                this.jumpForceTicker = 10;
                this.xVelocityOnJumpMoment = 0;
                this.sideJumpVelocity = 0;
                this.doingBounceJumpTicker = 0;
                this.gameplay = nscs.scene.MainScene.instance.gameplay;
                this.sprite = nscs.scene.MainScene.instance.physics.add.sprite(0, 0, 'objects-atlas');
                this.sprite.setOrigin(0.5, 0);
                this.sprite.setBounce(0);
                this.sprite.setCollideWorldBounds(true);
                this.seaKitten_mc = nscs.scene.MainScene.instance.add.sprite(0, 0, 'objects-atlas');
                this.seaKitten_mc.setOrigin(0.5, 1);
                this.seaKitten_mc['-offsets-'] = {
                    'chickette_big': { x: 0, y: 4 },
                    'nugget_big': { x: 0, y: 4 },
                    'pam_big': { x: 0, y: -6 }
                };
                this.seaKitten_mc['-offsets-flipped-'] = {
                    'chickette_big': { x: 0, y: 15 },
                    'nugget_big': { x: 0, y: 15 },
                    'pam_big': { x: 0, y: 25 }
                };
                this.sprite.on('animationcomplete', () => { this.currAnimComplete = true; });
                this.setup();
            }
            setup() {
                this.setCharSize(this.gameplay.charSize);
                this.setSeaKittenise(this.gameplay.seaKitten);
            }
            remakeFrameName() {
                this.frameName = this.gameplay.character + "_" + this.gameplay.charSize;
            }
            updateBodySize() {
                let bodySizes = {
                    'chickette_small': { w: 20, h: 32 },
                    'chickette_big': { w: 21, h: 56 },
                    'nugget_small': { w: 21, h: 32 },
                    'nugget_big': { w: 20, h: 52 },
                    'pam_small': { w: 16, h: 35 },
                    'pam_big': { w: 16, h: 60 }
                };
                this.sprite.body.setSize(bodySizes[this.frameName].w, bodySizes[this.frameName].h);
            }
            updateBodyFlipY() {
                this.sprite.flipY = this.gameplay.isGravityFlipped();
                this.sprite.y += (this.offsetsData["flipped"][this.frameName].y - this.offsetsData["normal"][this.frameName].y) * this.gameplay.gravityDir;
            }
            updateBodyOffset() {
                let offsets = this.offsetsData[this.gameplay.isGravityFlipped() ? "flipped" : "normal"];
                this.sprite.body.setOffset(offsets[this.frameName].x, offsets[this.frameName].y);
            }
            setCharSize(charSize, playAnimation = true) {
                let prevCharSize = this.gameplay.charSize;
                this.gameplay.charSize = charSize;
                this.remakeFrameName();
                if (this.gameplay.charSize == "small") {
                    this.setSeaKittenise(false);
                }
                this.updateBodyFlipY();
                this.updateBodySize();
                this.updateBodyOffset();
                if (playAnimation) {
                    if (prevCharSize != this.gameplay.charSize) {
                        this.playGrowAnimation();
                    }
                    else {
                        this.playIdleAnimation();
                    }
                }
            }
            fullyActive() {
                return this.immortalBlinkingTicker == 0 && !this.tempDead && !this.isFlagReached;
            }
            playPounceAnimation() {
                this.playAnimation('pounce');
                nscs.sound.SoundManager.getInstance().playSound('whiskSND');
            }
            playPounceLandAnimation() {
                if (this.fallenBelowTheWorld)
                    return;
                this.playAnimation('pounceLand');
                nscs.scene.MainScene.instance.gameplay.gameScreen.showDustMC(this.sprite.x, this.getFootsWorldY(), this.gameplay.charSize == "big" ? 0.7 : 0.4, this.gameplay.isGravityFlipped() ? 180 : 0);
                nscs.sound.SoundManager.getInstance().playSound('stompThudSND');
            }
            playWalkAnimation() {
                this.playAnimation('walk');
            }
            playIdleAnimation() {
                this.playAnimation('idle');
            }
            playFlyAnimation() {
                this.playAnimation('fly');
            }
            playForcedFlyAnimation() {
                this.playAnimation('fly', true);
            }
            playClimbingAnimation() {
                this.playAnimation('climbing');
            }
            playDeathAnimation(sizeWhenOnDeath) {
                if (sizeWhenOnDeath == 'small') {
                    this.playForcedFlyAnimation();
                }
                else {
                    this.playGrowAnimation();
                }
            }
            playGrowAnimation() {
                this.playAnimation('grow');
            }
            setSeaKittenise(active) {
                this.gameplay.setSeaKitten(active);
                if (this.gameplay.seaKitten) {
                    this.playAnimation('seaKittenise');
                }
            }
            updateSeaKitten() {
                if (this.gameplay.charSize == 'big') {
                    this.seaKitten_mc.visible = this.gameplay.seaKitten && this.sprite.visible;
                    if (this.seaKitten_mc.visible) {
                        this.seaKitten_mc.setFrame(this.sprite.frame.name.replace(this.frameName, 'seaKitten_mc'));
                        this.seaKitten_mc.flipX = this.sprite.flipX;
                        this.seaKitten_mc.flipY = this.sprite.flipY;
                        this.seaKitten_mc.scaleX = this.sprite.scaleX;
                        this.seaKitten_mc.scaleY = this.sprite.scaleY;
                        let _offsets_ = this.seaKitten_mc[this.gameplay.isGravityFlipped() ? '-offsets-flipped-' : '-offsets-'];
                        this.seaKitten_mc.x = this.sprite.x + _offsets_[this.frameName].x;
                        this.seaKitten_mc.y = this.sprite.y + _offsets_[this.frameName].y + this.sprite.height;
                        if (this.currAnim == 'pounce') {
                            this.seaKitten_mc.y -= 10;
                        }
                        if (this.seaKitten_mc.parentContainer != this.sprite.parentContainer
                            ||
                                this.seaKitten_mc.parentContainer.getIndex(this.seaKitten_mc) <= this.sprite.parentContainer.getIndex(this.sprite)) {
                            if (this.seaKitten_mc.parentContainer)
                                this.seaKitten_mc.parentContainer.remove(this.seaKitten_mc, false);
                            this.sprite.parentContainer.addAt(this.seaKitten_mc, this.sprite.parentContainer.getIndex(this.sprite) + 1);
                        }
                    }
                }
                else {
                    this.seaKitten_mc.visible = false;
                }
            }
            setTempDead(tempDead) {
                this.tempDead = tempDead;
                this.sprite.body.enable = !tempDead;
                this.sprite.setVelocity(0, 0);
            }
            resetVariables() {
                this.sideJumpTicker = 0;
                this.pounceLanding = false;
                this.notContactingDownTicker = 0;
                this.fallenBelowTheWorld = false;
                this.contactLeftWithStaticObject = false;
                this.contactRightWithStaticObject = false;
                this.contactDownWithStaticObject = false;
                this.isPlayerLadding = false;
                this.onRespawn = null;
                this.resetFans();
            }
            minusOneLife() {
                let prevCharSize = this.gameplay.charSize;
                this.setCharSize("small", false);
                this.playDeathAnimation(prevCharSize);
                this.setTempDead(true);
                this.resetVariables();
            }
            getFootsWorldY() {
                return this.gameplay.isGravityFlipped() ? this.sprite.y : this.sprite.y + this.sprite.height;
            }
            setWorldPosition(worldX, worldY) {
                this.sprite.setPosition(worldX, worldY - this.sprite.height);
            }
            respawn(atX, atY) {
                this.setWorldPosition(atX, atY);
                this.setTempDead(false);
                this.setImmortalBlinking();
                if (this.onRespawn) {
                    this.onRespawn();
                    this.onRespawn = null;
                }
            }
            playAnimation(anim, forced = false) {
                if (!forced) {
                    if (!this.currAnimComplete) {
                        if (this.topPriorityAnimations.indexOf(this.currAnim) >= 0 || this.topPriorityAnimations.indexOf(anim) >= 0)
                            return;
                    }
                }
                if (anim != this.currAnim) {
                    this.sprite.anims.stop();
                }
                this.currAnim = anim;
                this.currAnimComplete = false;
                this.sprite.anims.play(nscs.gameplay.Factory.createAnimName(anim, this.frameName), true);
            }
            setImmortalBlinking() {
                this.immortalBlinkingTicker = 125;
            }
            goInOutPipe(direction, dSize, onComplete) {
                let dx = 0;
                let dy = 0;
                if (direction == "left")
                    dx = -dSize;
                else if (direction == "right")
                    dx = dSize;
                else if (direction == "down")
                    dy = dSize;
                else if (direction == "up")
                    dy = -dSize;
                this.pipeGoing = true;
                this.sprite.body.enable = false;
                this.sprite.setVelocity(0, 0);
                this.sprite.flipX = direction == "left";
                nscs.scene.MainScene.instance.tweens.add({
                    targets: this.sprite,
                    x: this.sprite.x + dx,
                    y: this.sprite.y + dy,
                    duration: 500,
                    onComplete: () => {
                        if (onComplete)
                            onComplete();
                    }
                });
                if (direction == "left" || direction == "right")
                    this.playWalkAnimation();
                else if (direction == "down" || direction == "up")
                    this.playIdleAnimation();
            }
            resetPipeGoing() {
                this.pipeGoing = false;
                this.sprite.body.enable = true;
            }
            resetFans() {
                this.fanUp = this.fanDown = this.fanRight = this.fanLeft = false;
            }
            update() {
                if (this.pipeGoing) {
                    return;
                }
                this.fallenBelowTheWorld = this.sprite.y + this.sprite.height >= nscs.scene.MainScene.instance.gameplay.worldHeight;
                if (this.immortalBlinkingTicker > 0) {
                    this.immortalBlinkingTicker--;
                    this.sprite.alpha = 1 - (this.immortalBlinkingTicker % 25) / 25;
                }
                let inputController = nscs.scene.MainScene.instance.inputController;
                let contactDownAnything = this.gameplay.isGravityFlipped() ?
                    this.sprite.body.blocked.up || this.sprite.body.touching.up :
                    this.sprite.body.blocked.down || this.sprite.body.touching.down;
                let contactDown = contactDownAnything && this.contactDownWithStaticObject;
                let contactLeft = (this.sprite.body.blocked.left || this.sprite.body.touching.left) && this.contactLeftWithStaticObject;
                let contactRight = (this.sprite.body.blocked.right || this.sprite.body.touching.right) && this.contactRightWithStaticObject;
                if (contactDown) {
                    this.notContactingDownTicker = 0;
                }
                else {
                    this.notContactingDownTicker++;
                }
                let antiGravitySpeedY = -18 * this.gameplay.gravityDir;
                if (this.doingBounceJumpTicker > 0) {
                    if (this.doingBounceJumpTicker > 1 && contactDownAnything) {
                        this.doingBounceJumpTicker = 0;
                    }
                    else {
                        this.doingBounceJumpTicker++;
                    }
                }
                if (this.sideJumpTicker == 0) {
                    let speedX = 0;
                    if (contactDown) {
                        let c = 8;
                        if (inputController.cursorKeys.left.isDown || nscs.input.InputManager.instance.isDown('LEFT')) {
                            speedX = this.sprite.body.velocity.x + ((-this.gameplay.xSpeed) - this.sprite.body.velocity.x) / c;
                            this.sprite.flipX = true; // flip the sprite to the left
                        }
                        else if (inputController.cursorKeys.right.isDown || nscs.input.InputManager.instance.isDown('RIGHT')) {
                            speedX = this.sprite.body.velocity.x + (this.gameplay.xSpeed - this.sprite.body.velocity.x) / c;
                            this.sprite.flipX = false; // use the original sprite looking to the right
                        }
                        else {
                            speedX = this.sprite.body.velocity.x * 0.9;
                            if (speedX < 1 && speedX > -1)
                                speedX = 0;
                        }
                    }
                    else {
                        let newSpd = 0;
                        if (!this.pounceLanding) {
                            newSpd = this.sprite.body.velocity.x;
                            let vx = this.sprite.body.velocity.x;
                            let targetVxModule = Math.abs(this.xVelocityOnJumpMoment) < this.gameplay.xSpeed * 0.75 ? this.gameplay.xSpeed * 0.75 : Math.abs(this.xVelocityOnJumpMoment);
                            if (this.doingBounceJumpTicker > 1) {
                                targetVxModule = this.gameplay.xSpeed * 1.37;
                            }
                            let div = 20;
                            if (inputController.cursorKeys.left.isDown || nscs.input.InputManager.instance.isDown('LEFT')) {
                                speedX = vx + (-targetVxModule - vx) / div;
                                this.sprite.flipX = true; // flip the sprite to the left
                            }
                            else if (inputController.cursorKeys.right.isDown || nscs.input.InputManager.instance.isDown('RIGHT')) {
                                speedX = vx + (targetVxModule - vx) / div;
                                this.sprite.flipX = false; // use the original sprite looking to the right
                            }
                            else {
                                speedX = newSpd * 0.95;
                            }
                        }
                    }
                    this.sprite.setVelocityX(speedX);
                }
                else {
                    this.sideJumpTicker--;
                    this.sprite.setVelocityX(this.sprite.body.velocity.x * 0.99);
                }
                if (this.isPlayerLadding) {
                    if (inputController.cursorKeys.up.isDown || nscs.input.InputManager.instance.isDown('UP')) {
                        this.sprite.setVelocityY(-this.gameplay.ladderSpeed);
                        this.playClimbingAnimation();
                        this.sprite.setVelocityX(this.sprite.body.velocity.x * 0.5);
                    }
                    else if (inputController.cursorKeys.down.isDown || nscs.input.InputManager.instance.isDown('DOWN')) {
                        this.sprite.setVelocityY(this.gameplay.ladderSpeed);
                        this.playClimbingAnimation();
                        this.sprite.setVelocityX(this.sprite.body.velocity.x * 0.5);
                    }
                    else {
                        this.sprite.setVelocityY(antiGravitySpeedY);
                        this.sprite.setVelocityX(this.sprite.body.velocity.x * 1.1);
                    }
                    return;
                }
                if (inputController.spaceObj.isDown || nscs.input.InputManager.instance.isDown("UP")) {
                    if (this.spaceDownTicker != 0 && this.spaceDownTicker < this.jumpForceTicker * 0.5) {
                        this.doJump(Math.min((this.spaceDownTicker + this.jumpForceTicker * 0.5) / this.jumpForceTicker, 1));
                        this.spaceDownTicker++;
                    }
                    else {
                        this.spaceDownTicker = 0;
                    }
                    if ((inputController.spacePressedDownAndReleased() || nscs.input.InputManager.instance.upPressedDownAndReleased()) && contactDown) {
                        inputController.spacePressUsed();
                        nscs.input.InputManager.instance.upPressUsed();
                        this.spaceDownTicker = 1;
                        nscs.sound.SoundManager.getInstance().playSound(this.gameplay.inWater ? 'waterjumpSND' : 'jumpSND');
                        this.xVelocityOnJumpMoment = this.sprite.body.velocity.x;
                    }
                }
                else {
                    this.spaceDownTicker = 0;
                }
                // jump
                if (inputController.spacePressedDownAndReleased() || nscs.input.InputManager.instance.upPressedDownAndReleased()) {
                    if (this.gameplay.seaKitten && this.gameplay.inWater && (this.gameplay.isGravityFlipped() ? this.sprite.body.velocity.y < 0 : this.sprite.body.velocity.y > 0)) {
                        this.doJump(0.5);
                        inputController.spacePressUsed();
                        nscs.input.InputManager.instance.upPressUsed();
                        nscs.sound.SoundManager.getInstance().playSound('waterjumpSND');
                    }
                    else if (contactLeft || contactRight) {
                        if (this.notContactingDownTicker > 8) {
                            this.doJump(0.75);
                            inputController.spacePressUsed();
                            nscs.input.InputManager.instance.upPressUsed();
                            this.sprite.setVelocityX((contactLeft ? 1 : -1) * this.gameplay.xSpeed * 1.5);
                            this.sprite.flipX = !contactLeft;
                            this.sideJumpTicker = 10;
                            nscs.scene.MainScene.instance.gameplay.gameScreen.showDustMC(this.sprite.x + (contactLeft ? -1 : 1) * 10, this.sprite.y + this.sprite.height / 2, this.gameplay.charSize == "big" ? 0.7 : 0.4, (contactLeft ? 1 : -1) * 90);
                            nscs.sound.SoundManager.getInstance().playSound('wallJumpSND');
                        }
                    }
                }
                if (contactDown) {
                    if (this.pounceLanding || this.currAnim == 'pounce') {
                        this.playPounceLandAnimation();
                        this.pounceLanding = false;
                    }
                    if (Math.abs(this.sprite.body.velocity.x) < 35) {
                        this.playIdleAnimation();
                    }
                    else {
                        this.playWalkAnimation();
                    }
                }
                else {
                    if ((inputController.keyDownPressedDownAndReleased() || nscs.input.InputManager.instance.downPressedDownAndReleased()) && (this.gameplay.isGravityFlipped() ? this.sprite.body.velocity.y < this.gameplay.jumpHeight * 0.75 : this.sprite.body.velocity.y > -this.gameplay.jumpHeight * 0.75)) {
                        if (!(this.gameplay.seaKitten && this.gameplay.inWater)) {
                            this.doJump(0.4);
                            nscs.util.Functions.delayedCall(250, () => {
                                if (this.pounceLanding && this.sprite.parentContainer)
                                    this.doJump(-1.75);
                            });
                            inputController.keyDownPressUsed();
                            nscs.input.InputManager.instance.downPressUsed();
                            if (!this.pounceLanding) {
                                this.playPounceAnimation();
                                this.pounceLanding = true;
                            }
                        }
                    }
                    else {
                        if (!contactDownAnything) {
                            if (!this.pounceLanding) {
                                if (!this.gameplay.isGravityFlipped() && this.sprite.body.velocity.y > 0 ||
                                    this.gameplay.isGravityFlipped() && this.sprite.body.velocity.y < 0) {
                                    if (Math.abs(this.sprite.body.velocity.x) < 35) {
                                        this.playAnimation('idle', true);
                                    }
                                    else {
                                        this.playAnimation('walk', true);
                                    }
                                }
                                else {
                                    this.playFlyAnimation();
                                }
                            }
                        }
                    }
                }
                if (this.currAnim == 'pounceLand' || this.currAnim == 'pounce') {
                    this.sprite.setVelocityX(0);
                }
                if (Math.abs(this.sideJumpVelocity) > 1) {
                    this.sprite.setVelocityX(this.sideJumpVelocity);
                    this.sideJumpVelocity += (0 - this.sideJumpVelocity) / 10;
                }
                else {
                    this.sideJumpVelocity = 0;
                }
                if (this.fanUp) {
                    if (this.pounceLanding) {
                        this.sprite.setVelocityY(this.sprite.body.velocity.y);
                    }
                    else {
                        let spdY = (-200 * this.gameplay.gravityDir) * this.gameplay.getFanWaterCoefficient();
                        if (this.gameplay.isGravityFlipped() ?
                            this.sprite.body.velocity.y < antiGravitySpeedY && this.sprite.body.velocity.y < spdY :
                            this.sprite.body.velocity.y > antiGravitySpeedY && this.sprite.body.velocity.y > spdY) {
                            this.sprite.setVelocityY(this.sprite.body.velocity.y + (spdY - this.sprite.body.velocity.y) * 0.1);
                        }
                    }
                }
                if (this.fanLeft) {
                    if (!this.pounceLanding) {
                        let spdX = -this.gameplay.xSpeed * 0.1 * this.gameplay.getFanWaterCoefficient();
                        if (this.sprite.body.velocity.x > spdX) {
                            this.sprite.setVelocityX(this.sprite.body.velocity.x + (spdX - this.sprite.body.velocity.x) * 0.5);
                        }
                    }
                }
                if (this.fanRight) {
                    if (!this.pounceLanding) {
                        let spdX = this.gameplay.xSpeed * 0.1 * this.gameplay.getFanWaterCoefficient();
                        if (this.sprite.body.velocity.x < spdX) {
                            this.sprite.setVelocityX(this.sprite.body.velocity.x + (spdX - this.sprite.body.velocity.x) * 0.5);
                        }
                    }
                }
                this.resetFans();
                this.contactLeftWithStaticObject = this.contactRightWithStaticObject = this.contactDownWithStaticObject = false;
            }
            doJump(powerCoef = 1) {
                this.sprite.setVelocityY(-this.gameplay.jumpHeight * powerCoef * this.gameplay.gravityDir);
            }
            doSideJump(powerCoef = 1) {
                this.sideJumpVelocity = this.gameplay.xSpeed * powerCoef;
            }
            doAfterJumpOverEnemy() {
                this.pounceLanding = false;
                this.doJump(1);
            }
            doBounceJump() {
                this.doingBounceJumpTicker = 1;
                this.pounceLanding = false;
                this.doJump(1.55);
            }
        }
        character.Player = Player;
    })(character = nscs.character || (nscs.character = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var gameplay;
    (function (gameplay) {
        class Factory {
            constructor(scene) {
                this.scene = scene;
                this.createAnimations();
            }
            createAnimations() {
                for (let k in Factory.ANIM) {
                    let textureAtlas = 'objects-atlas';
                    let data = Factory.ANIM[k];
                    for (let animKey in data) {
                        let anim = Factory.createAnimName(animKey, k);
                        if (!this.scene.anims.exists(anim)) {
                            let animData = data[animKey];
                            let frames;
                            let genFrm = (_data) => {
                                return this.scene.anims.generateFrameNames(textureAtlas, {
                                    start: _data['start'], end: _data['end'], zeroPad: 4,
                                    prefix: k, suffix: ''
                                });
                            };
                            if (animData.hasOwnProperty("length")) {
                                frames = [];
                                for (let ad of animData) {
                                    let _frames = genFrm(ad);
                                    frames = frames.concat(_frames);
                                }
                            }
                            else {
                                frames = genFrm(animData);
                            }
                            this.scene.anims.create({
                                key: anim,
                                frames: frames,
                                frameRate: 60
                            });
                        }
                    }
                }
            }
            static createAnimName(animKey, frameName) {
                return animKey + "_" + frameName;
            }
            createDecorSprite(libId) {
                let mapOrigins = {
                    'decor112MC': { 'x': 16 / 841, 'y': 6 / 130 },
                    'decor113MC': { 'x': 59 / 151, 'y': 12 / 155 },
                    'decor92MC': { 'x': 0 / 148, 'y': 3 / 233 },
                    'decor91MC': { 'x': 0, 'y': 0 },
                    'decor77MC': { 'x': 29 / 144, 'y': 3 / 147 },
                    'decor82MC': { 'x': 48 / 96, 'y': -15 / 96 },
                    'decor4MC': { 'x': 0, 'y': 0 },
                    'decor100MC': { 'x': 17 / 135, 'y': 250 / 329 },
                    'decor109MC': { 'x': 74 / 148, 'y': 47 / 80 },
                    'decor101MC': { 'x': 87 / 178, 'y': -21 / 91 },
                    'decor115MC': { 'x': 0, 'y': 0 },
                    'decor108MC': { 'x': 75 / 150, 'y': 47 / 80 },
                    'decor84MC': { 'x': 51 / 102, 'y': -25 / 22 },
                    'decor83MC': { 'x': 50 / 102, 'y': -15 / 23 },
                    'decor79MC': { 'x': 31 / 96, 'y': 0 / 111 },
                    'decor81MC': { 'x': 21 / 22, 'y': 3 / 115 },
                    'decor78MC': { 'x': 31 / 160, 'y': 3 / 117 },
                    'decor64MC': { 'x': 0, 'y': 0 },
                    'decor63MC': { 'x': 0, 'y': 0 },
                    'decor65MC': { 'x': 0, 'y': 0 },
                    'decor62MC': { 'x': 0, 'y': 0 },
                    'decor73MC': { 'x': 0, 'y': 0 },
                    'decor10MC': { 'x': 0.5, 'y': 1 },
                    'decor26MC': { 'x': 0.5, 'y': 1 },
                    'decor86MC': { 'x': 0, 'y': 0 },
                    'decor98MC': { 'x': 62 / 126, 'y': 39 / 68 },
                    'decor99MC': { 'x': 82 / 126, 'y': 39 / 68 },
                    'decor97MC': { 'x': 38 / 57, 'y': 0.6 },
                    'decor95MC': { 'x': 54 / 111, 'y': 35 / 112 },
                    'decor94MC': { 'x': 54 / 111, 'y': 35 / 112 },
                    'decor93MC': { 'x': 54 / 111, 'y': 35 / 112 },
                    'decor80MC': { 'x': 31 / 23, 'y': 3 / 113 },
                    'decor76MC': { 'x': 51 / 147, 'y': 3 / 146 },
                    'decor12MC': { 'x': 0 / 96, 'y': 5 / 69 },
                    'decor69MC': { 'x': 25 / 307, 'y': 0 / 135 },
                    'decor15MC': { 'x': 0, 'y': 0 },
                    'decor16MC': { 'x': 0.12, 'y': 0.77 },
                    'decor68MC': { 'x': -5 / 58, 'y': 1 / 79 },
                    'decor19MC': { 'x': 0, 'y': 0 },
                    'decor13MC': { 'x': 0, 'y': 0 },
                    'decor17MC': { 'x': 0, 'y': 0 },
                    'decor18MC': { 'x': 0, 'y': 0 },
                    'decor14MC': { 'x': 0, 'y': 0 },
                    'decor20MC': { 'x': 0, 'y': 0 },
                    'decor107MC': { 'x': 77 / 154, 'y': 47 / 80 },
                    'decor106MC': { 'x': 80 / 160, 'y': 47 / 82 },
                    'decor105MC': { 'x': 74 / 148, 'y': 47 / 81 },
                    'decor104MC': { 'x': 71 / 142, 'y': 47 / 81 },
                    'decor103MC': { 'x': 75 / 150, 'y': 47 / 81 },
                    'decor102MC': { 'x': 75 / 150, 'y': 47 / 81 },
                    'decor71MC': { 'x': 23 / 78, 'y': 28 / 76 },
                    'decor70MC': { 'x': 23 / 78, 'y': 15 / 76 },
                    'decor72MC': { 'x': 0, 'y': 0 },
                    'decor67MC': { 'x': 0, 'y': 0 },
                    'decor74MC': { 'x': 8 / 56, 'y': 1 / 37 },
                    'decor75MC': { 'x': 8 / 56, 'y': 1 / 37 },
                    'decor110MC': { 'x': 22 / 47, 'y': 0 / 21 },
                    'decor31MC': { 'x': 22 / 45, 'y': 21 / 21 },
                    'decor37MC': { 'x': 0.5, 'y': 1 },
                    'decor66MC': { 'x': 0, 'y': 0 },
                    'decor96MC': { 'x': 45 / 57, 'y': 1 },
                    'decor7MC': { 'x': 0, 'y': 0 },
                    'decor36MC': { 'x': 0.5, 'y': 1 },
                    'decor61MC': { 'x': 16 / 96, 'y': 32 / 64 },
                    'decor59MC': { 'x': 0.5, 'y': 1 },
                    'decor114MC': { 'x': 0, 'y': 0 },
                    'decor6MC': { 'x': 0, 'y': 0 },
                    'decor8MC': { 'x': 0, 'y': 0 },
                    'decor111MC': { 'x': 0, 'y': 0 },
                    'decor90MC': { 'x': 0, 'y': 0 },
                    'decor89MC': { 'x': 0, 'y': 0 },
                    'decor88MC': { 'x': 0, 'y': 0 },
                    'decor87MC': { 'x': 0, 'y': 0 },
                };
                let animations = {
                    'decor95MC': { 'start': 0, 'end': 93, 'autoplay': true },
                    'decor94MC': { 'start': 0, 'end': 93, 'autoplay': true },
                    'decor93MC': { 'start': 0, 'end': 93, 'autoplay': true },
                    'decor37MC': { 'start': 0, 'end': 82, 'autoplay': true },
                    'decor36MC': { 'start': 0, 'end': 82, 'autoplay': true },
                    'decor71MC': { 'start': 0, 'end': 29, 'autoplay': true },
                    'decor70MC': { 'start': 0, 'end': 29, 'autoplay': true },
                    'decor110MC': { 'start': 0, 'end': 21, 'autoplay': false },
                    'decor31MC': { 'start': 0, 'end': 21, 'autoplay': false },
                    'decor99MC': { 'start': 0, 'end': 73, 'autoplay': true },
                    'decor98MC': { 'start': 0, 'end': 53, 'autoplay': true },
                    'decor96MC': { 'start': 0, 'end': 59, 'autoplay': true },
                    'decor97MC': { 'start': 0, 'end': 73, 'autoplay': true },
                    'decor26MC': { 'start': 0, 'end': 89, 'autoplay': true },
                    'decor10MC': { 'start': 0, 'end': 89, 'autoplay': true },
                };
                let bodySize = {
                    'decor95MC': { x: 0, y: 55, yFlipped: 6, w: 110, h: 46 },
                    'decor94MC': { x: 0, y: 55, yFlipped: 6, w: 110, h: 46 },
                    'decor93MC': { x: 0, y: 55, yFlipped: 6, w: 110, h: 46 },
                    'decor71MC': { x: 12, y: -17, w: 59, h: 56 },
                    'decor70MC': { x: 12, y: 41, w: 59, h: 56 },
                    'decor110MC': { x: 0, y: 0, w: 44, h: 10 },
                    'decor31MC': { x: 0, y: 11, w: 44, h: 12 },
                    'decor37MC': { x: -18, y: -36, w: 36, h: 36 },
                    'decor107MC': { x: 0, y: 31, w: 154, h: 78 },
                    'decor109MC': { x: 0, y: 31, w: 154, h: 78 },
                    'decor104MC': { x: 0, y: 31, w: 142, h: 78 },
                    'decor105MC': { x: 0, y: 31, w: 148, h: 78 },
                    'decor106MC': { x: 0, y: 31, w: 160, h: 78 },
                    'decor103MC': { x: 0, y: 31, w: 150, h: 78 },
                    'decor102MC': { x: 0, y: 31, w: 150, h: 78 },
                    'decor108MC': { x: 0, y: 31, w: 150, h: 78 },
                    'decor99MC': { x: 30, y: 10, w: 57, h: 37 },
                    'decor97MC': { x: 35, y: 20, w: 57, h: 37 },
                    'decor98MC': { x: 20, y: 10, w: 57, h: 37 },
                    'decor12MC': { x: 28, y: 0, w: 36, h: 64 },
                    'decor15MC': { x: 0, y: 3, w: 96, h: 64 },
                    'decor16MC': { x: 45, y: 246, w: 38, h: 62 },
                    'decor17MC': { x: 28, y: 6, w: 38, h: 64 },
                    'decor18MC': { x: -10, y: 45, w: 96, h: 38 },
                    'decor14MC': { x: -9, y: 45, w: 96, h: 38 },
                    'decor13MC': { x: 11, y: 45, w: 50, h: 38 },
                    'decor19MC': { x: 10, y: 45, w: 58, h: 38 },
                    'decor100MC': { x: 0, y: 50, w: 135, h: 329 },
                    'decor69MC': { x: -234, y: -5, w: 253, h: 135 },
                    'decor68MC': { x: 78, y: -6, w: 188, h: 135 },
                    'decor101MC': { x: 1, y: 10, w: 178, h: 78 },
                    'decor59MC': { x: 0, y: 0, w: 23, h: 63 }
                };
                let mapLookingLeft = {
                    'decor99MC': false,
                    'decor98MC': false,
                    'decor96MC': false,
                    'decor97MC': false,
                    'decor108MC': true,
                    'decor105MC': true,
                    'decor106MC': true,
                    'decor102MC': true,
                    'decor103MC': true
                };
                let decor;
                if (bodySize.hasOwnProperty(libId)) {
                    decor = this.scene.physics.add.sprite(0, 0, 'decor-atlas', libId + '0000');
                    decor.setCollideWorldBounds(false);
                    decor.body.setSize(bodySize[libId]['w'], bodySize[libId]['h']);
                    decor.body.setOffset(bodySize[libId]['x'], bodySize[libId]['y']);
                    if (bodySize[libId].hasOwnProperty('yFlipped')) {
                        decor.body.offset['-y-'] = bodySize[libId]['y'];
                        decor.body.offset['-yFlipped-'] = bodySize[libId]['yFlipped'];
                    }
                    else {
                        decor.setImmovable(true);
                    }
                    decor.body["setAllowGravity"](false);
                }
                else {
                    let frame = libId + '0000';
                    decor = this.scene.add.sprite(0, 0, 'decor-atlas', frame);
                    if (!decor.texture.frames.hasOwnProperty(frame)) {
                        decor.visible = false;
                    }
                }
                if (mapLookingLeft.hasOwnProperty(libId)) {
                    decor['lookingLeft'] = mapLookingLeft[libId];
                }
                if (mapOrigins[libId]) {
                    decor.setOrigin(mapOrigins[libId]['x'], mapOrigins[libId]['y']);
                }
                else {
                    decor.setOrigin(0.5, 0.5);
                }
                if (animations[libId]) {
                    let anim = libId + "_" + "playingAnimName";
                    decor["playingAnimName"] = anim;
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(decor.texture.key, {
                                start: animations[libId]['start'], end: animations[libId]['end'], zeroPad: 4,
                                prefix: libId, suffix: ''
                            }),
                            frameRate: 60,
                            repeat: animations[libId]['autoplay'] ? -1 : 0
                        });
                    }
                    if (animations[libId]['autoplay']) {
                        decor.play(decor["playingAnimName"]);
                    }
                }
                return decor;
            }
            createEnemySprite(libId) {
                let enemy4MC_Origin = { 'x': 0.5, 'y': 0.5 };
                let mapOrigins = {
                    'enemy4MC_kid1': enemy4MC_Origin,
                    'enemy4MC_kid2': enemy4MC_Origin,
                    'enemy4MC_kid3': enemy4MC_Origin,
                    'enemy3MC': { 'x': 5 / 26, 'y': 26 / 57 },
                    'enemy5MC': { 'x': 1 / 138, 'y': 38 / 241 },
                    'hazard6MC': { 'x': -14 / 34, 'y': 0 },
                    'hazard4MC': { 'x': -16 / 34, 'y': 25 / 25 },
                    'hazard5MC': { 'x': -6 / 52, 'y': 64 / 61 },
                    'hazard3MC': { 'x': -6 / 52, 'y': 61 / 61 }
                };
                let enemy4MC_animations = {
                    'idle': { 'start': 0, 'end': 12, 'repeat': 0 },
                    'bounce': { 'start': 13, 'end': 30, 'repeat': 0 },
                    'attack': { 'start': 13, 'end': 30, 'repeat': 0 },
                    'bounceSide': { 'start': 31, 'end': 51, 'repeat': 0 },
                    'hit': { 'start': 31, 'end': 51, 'repeat': 0 },
                    'die': { 'start': 52, 'end': 79, 'repeat': 0 }
                };
                let animations = {
                    'enemy4MC_kid1': enemy4MC_animations,
                    'enemy4MC_kid2': enemy4MC_animations,
                    'enemy4MC_kid3': enemy4MC_animations,
                    'enemy3MC': {
                        'idle': { 'start': 0, 'end': 19, 'repeat': 0 },
                        'attack': { 'start': 91, 'end': 146, 'repeat': 0 },
                        'die': { 'start': 148, 'end': 169, 'repeat': 0 },
                        'hit': { 'start': 23, 'end': 23, 'repeat': 0 },
                    },
                    'enemy5MC': {
                        'idle': { 'start': 0, 'end': 8, 'repeat': 0 },
                        'appear': { 'start': 9, 'end': 69, 'repeat': 0 },
                        'appeared': { 'start': 70, 'end': 80, 'repeat': 0 },
                        'attack': { 'start': 81, 'end': 183, 'repeat': 0 },
                        'hit': { 'start': 225, 'end': 230, 'repeat': 0 },
                        'disappear': { 'start': 184, 'end': 266, 'repeat': 0 },
                        'die': { 'start': 267, 'end': 324 /*317*/, 'repeat': 0 },
                        'dead': { 'start': 267, 'end': 324, 'repeat': 0 }
                    }
                };
                let enemy4MC_bodySize = { x: 24, y: 24, w: 14, h: 14 };
                let bodySize = {
                    'enemy4MC_kid1': enemy4MC_bodySize,
                    'enemy4MC_kid2': enemy4MC_bodySize,
                    'enemy4MC_kid3': enemy4MC_bodySize,
                    'enemy3MC': { x: 15, y: 45, yFlipped: 3, w: 26, h: 22 },
                    'enemy5MC': { x: 43, y: 70, w: 60, h: 55 },
                    'hazard6MC': { x: 10, y: 5, w: 24, h: 15 },
                    'hazard4MC': { x: 12, y: 4, w: 12, h: 15 },
                    'hazard5MC': { x: 4, y: 21, w: 46, h: 33 },
                    'hazard3MC': { x: 12, y: 4, w: 27, h: 23 },
                };
                let enemy = this.scene.physics.add.sprite(0, 0, 'enemies-atlas', libId + '0000');
                enemy.setOrigin(mapOrigins[libId]['x'], mapOrigins[libId]['y']);
                enemy.setCollideWorldBounds(false);
                enemy.body.setSize(bodySize[libId]['w'], bodySize[libId]['h']);
                enemy.body.setOffset(bodySize[libId]['x'], bodySize[libId]['y']);
                if (bodySize[libId].hasOwnProperty('yFlipped')) {
                    enemy.body.offset['-y-'] = bodySize[libId]['y'];
                    enemy.body.offset['-yFlipped-'] = bodySize[libId]['yFlipped'];
                }
                else {
                    enemy.setImmovable(true);
                }
                enemy.body["setAllowGravity"](false);
                if (animations[libId]) {
                    for (let k in animations[libId]) {
                        let anim = libId + "_" + k;
                        if (!this.scene.anims.exists(anim)) {
                            this.scene.anims.create({
                                key: anim,
                                frames: this.scene.anims.generateFrameNames(enemy.texture.key, {
                                    start: animations[libId][k]['start'], end: animations[libId][k]['end'], zeroPad: 4,
                                    prefix: libId, suffix: ''
                                }),
                                frameRate: 60,
                                repeat: animations[libId][k]['repeat']
                            });
                        }
                    }
                }
                return enemy;
            }
            createOtherSprite(libId) {
                let mapOrigins = {
                    'bblock1MC': { 'x': 0.5, 'y': 1 }
                };
                if (!mapOrigins.hasOwnProperty(libId))
                    return null;
                let bodySize = {
                    'bblock1MC': { x: 0, y: 32 / 2 - 4, w: 32, h: 32 }
                };
                let animations = {
                    'bblock1MC': {
                        'masked': { 'start': 7, 'end': 7, 'repeat': 0 },
                        'wobble': { 'start': 55, 'end': 72, 'repeat': 0 },
                        'question-wobble': { 'start': 74, 'end': 91, 'repeat': 0 },
                        'break': { 'start': 93, 'end': 98, 'repeat': 0 },
                        'hidden': { 'start': 100, 'end': 107, 'repeat': 0 },
                        'makeSolid': { 'start': 108, 'end': 124, 'repeat': 0 },
                        'maskToSolid': { 'start': 125, 'end': 141, 'repeat': 0 },
                        'hiddenToSolid': { 'start': 143, 'end': 158, 'repeat': 0 },
                        'solid': { 'start': 159, 'end': 159, 'repeat': 0 },
                        'question': { 'start': 167, 'end': 174, 'repeat': 0 }
                    }
                };
                let sprite = this.scene.physics.add.sprite(0, 0, 'objects-atlas', libId + '0000');
                sprite.setOrigin(mapOrigins[libId]['x'], mapOrigins[libId]['y']);
                sprite.setCollideWorldBounds(false);
                sprite.body.setSize(bodySize[libId]['w'], bodySize[libId]['h']);
                sprite.body.setOffset(bodySize[libId]['x'], bodySize[libId]['y']);
                sprite.setImmovable(true);
                sprite.body["setAllowGravity"](false);
                for (let k in animations[libId]) {
                    let anim = libId + "_" + k;
                    if (!this.scene.anims.exists(anim)) {
                        this.scene.anims.create({
                            key: anim,
                            frames: this.scene.anims.generateFrameNames(sprite.texture.key, {
                                start: animations[libId][k]['start'], end: animations[libId][k]['end'], zeroPad: 4,
                                prefix: libId, suffix: ''
                            }),
                            frameRate: 60,
                            repeat: animations[libId][k]['repeat']
                        });
                    }
                }
                return sprite;
            }
            createSprite(spriteInfo
            /*
            spriteInfo[0] = sprite id
            spriteInfo[1] = x
            spriteInfo[2] = y
            spriteInfo[3] = libId
            spriteInfo[4] = options
            */
            ) {
                let libId = spriteInfo[3];
                if (libId == "enemy4MC")
                    libId = "enemy4MC" + "_kid" + (Math.ceil(Math.random() * 3));
                let sprite_mc = this.createConstructedObject(libId);
                if (!sprite_mc) {
                    if (spriteInfo[3].indexOf("decor") == 0) {
                        sprite_mc = this.createDecorSprite(libId);
                    }
                    else if (spriteInfo[3].indexOf("enemy") == 0 || spriteInfo[3].indexOf("hazard") == 0) {
                        sprite_mc = this.createEnemySprite(libId);
                    }
                    else {
                        sprite_mc = this.createOtherSprite(libId);
                        if (!sprite_mc) {
                            sprite_mc = this.scene.add.sprite(0, 0, 'objects-atlas', libId + '0000');
                        }
                    }
                }
                sprite_mc.setPosition(Number(spriteInfo[1]), Number(spriteInfo[2]));
                sprite_mc["libId"] = libId;
                let spriteId = sprite_mc["spriteId"] = spriteInfo[0];
                // extract options
                let options = spriteInfo[4].split('_');
                let spriteType = sprite_mc["spriteType"] = options[0];
                if (spriteType == 'E') {
                    // enemy
                    // define enemy hits required
                    sprite_mc["hitsToKill"] = Number(options[1]);
                    // pixel range
                    sprite_mc["enemyType"] = options[3];
                    //sprite_mc.dx = sprite_mc.xSpeed;
                    sprite_mc["dy"] = 0;
                    sprite_mc["dead"] = false;
                }
                else if (spriteType == 'H') {
                    // hazard
                    // define hazard strength
                    sprite_mc["strength"] = options[1];
                }
                else if (spriteType == 'C') {
                    // chick / collectable
                    // orientate?
                    if (Math.random() > 0.5)
                        sprite_mc.scaleX = -1;
                    sprite_mc["points"] = Number(options[1]);
                    // flap at random:
                    // sprite_mc.gotoAndStop(Math.ceil(Math.random()*15));
                }
                else if (spriteType == 'D') {
                    // decor
                    sprite_mc["decorType"] = options[1];
                    sprite_mc["speech"] = options[2];
                    if (sprite_mc["decorType"] == 'protestor' && sprite_mc["speech"]) {
                        sprite_mc["speaking"] = false;
                        sprite_mc["dy"] = 0;
                    }
                    else if ((sprite_mc["decorType"] == 'pipeDown' || sprite_mc["decorType"] == 'pipeSide' || sprite_mc["decorType"] == 'pipeUp') && sprite_mc["speech"]) {
                        // rename correctly:
                        sprite_mc["pipeRoute"] = sprite_mc["speech"];
                    }
                    else if (sprite_mc["decorType"] == 'bounce' || sprite_mc["decorType"] == 'uberBounce') {
                    }
                    else if (sprite_mc["decorType"] && sprite_mc["decorType"].substr(0, 3) == 'fan') {
                        if (sprite_mc["decorType"] == 'fanUp') {
                            sprite_mc["fanDir"] = (sprite_mc["decorType"] == 'fanUp') ? -1 : 1;
                        }
                        else {
                            sprite_mc["fanDir"] = (sprite_mc["decorType"] == 'fanLeft') ? -1 : 1;
                        }
                    }
                    else if (sprite_mc["decorType"] == 'recovery') {
                        // recovery point
                        sprite_mc['-active-'] = false;
                    }
                    else if (sprite_mc["decorType"] == 'switch') {
                        // flip switch
                        sprite_mc["switchType"] = options[3];
                    }
                    if (sprite_mc["decorType"] == 'above') {
                        // send to front
                        // water object
                        if (sprite_mc["hitSpace_mc"]) {
                        }
                    }
                }
                else if (spriteType == 'B') {
                    // B (Blocks): [hitsToDestroy]-[playLabel]-[points/value]
                    sprite_mc["hitsLeft"] = Number(options[1]);
                    sprite_mc["playLabel"] = options[2];
                    sprite_mc["points"] = Number(options[3]);
                    sprite_mc["displayType"] = options[4];
                    // value block?
                    if (sprite_mc["playLabel"]) {
                        if (!sprite_mc["displayType"])
                            sprite_mc["displayType"] = 'question';
                        this.gotoAndPlay(sprite_mc, sprite_mc["displayType"]);
                    }
                }
                return sprite_mc;
            }
            createConstructedObject(libId) {
                let object = null;
                if (libId == "bossMC") {
                    object = new nscs.character.Boss(this.scene);
                }
                else if (libId == "flagPoleMC") {
                    object = this.scene.add.container(0, 0);
                    let flagPoleMC = this.scene.physics.add.sprite(0, 0, 'objects-atlas', 'flagPoleMC0000');
                    flagPoleMC.setOrigin(0.5, 1);
                    flagPoleMC.setCollideWorldBounds(false);
                    flagPoleMC.body.setSize(9, 181);
                    flagPoleMC.setImmovable(true);
                    flagPoleMC.body["setAllowGravity"](false);
                    object.add(flagPoleMC);
                    object["flagPoleMC"] = flagPoleMC;
                    let flag_kfc_MC = new Phaser.GameObjects.Image(this.scene, 0, -185, 'objects-atlas', 'flag_kfc_MC0000');
                    flag_kfc_MC.setOrigin(1, 0);
                    object.add(flag_kfc_MC);
                    object["flag_kfc_MC"] = flag_kfc_MC;
                }
                else if (libId == "tinyChickMC") {
                    object = this.scene.physics.add.sprite(0, 0, 'objects-atlas');
                    object.setOrigin(12 / 24, 25 / 24);
                    object.setCollideWorldBounds(false);
                    object.body.setSize(24, 24);
                    object.setImmovable(true);
                    object.body["setAllowGravity"](false);
                    let chick_mc_anim = 'tinyChickMC-anim';
                    if (!this.scene.anims.exists(chick_mc_anim)) {
                        this.scene.anims.create({
                            key: chick_mc_anim,
                            frames: this.scene.anims.generateFrameNames('objects-atlas', {
                                start: 0, end: 15, zeroPad: 4,
                                prefix: 'tinyChickMC', suffix: ''
                            }),
                            frameRate: 60,
                            repeat: -1
                        });
                    }
                    object.play(chick_mc_anim);
                }
                return object;
            }
            playAnimation(object, animName = null) {
                if (object["libId"] == "flagPoleMC") {
                    let fn = (d) => {
                        nscs.util.Functions.delayedCall(d, () => {
                            let flag_peta_MC = new Phaser.GameObjects.Image(this.scene, 0, 0, 'objects-atlas', 'flag_peta_MC0000');
                            flag_peta_MC.setOrigin(0, 0);
                            flag_peta_MC.scaleX = 1;
                            flag_peta_MC.scaleY = 0;
                            this.scene.tweens.add({
                                targets: flag_peta_MC,
                                duration: 500,
                                y: -185,
                                scaleY: 1,
                                ease: Phaser.Math.Easing.Sine.Out
                            });
                            object.add(flag_peta_MC);
                        });
                    };
                    if (animName == "normal-flag-reached") {
                        this.scene.tweens.add({
                            targets: object["flagPoleMC"],
                            duration: 500,
                            alpha: 1,
                            ease: Phaser.Math.Easing.Back.Out
                        });
                        this.scene.tweens.add({
                            targets: object["flag_kfc_MC"],
                            duration: 500,
                            y: 0,
                            scaleY: 0,
                            ease: Phaser.Math.Easing.Sine.Out,
                            onComplete: () => { if (object["flag_kfc_MC"].parentContainer)
                                object["flag_kfc_MC"].parentContainer.remove(object["flag_kfc_MC"]); }
                        });
                        fn(500);
                    }
                    else if (animName == "boss-flag-reached") {
                        object["flagPoleMC"].alpha = 0;
                        this.scene.tweens.add({
                            targets: object["flagPoleMC"],
                            duration: 500,
                            alpha: 1,
                            ease: Phaser.Math.Easing.Back.Out
                        });
                        let flag_kfc_MC = object["flag_kfc_MC"].setPosition(0, -185);
                        this.scene.tweens.add({
                            targets: flag_kfc_MC,
                            duration: 500,
                            y: 0,
                            scaleY: 0,
                            ease: Phaser.Math.Easing.Sine.Out,
                            onComplete: () => { if (flag_kfc_MC.parentContainer)
                                flag_kfc_MC.parentContainer.remove(flag_kfc_MC); }
                        });
                        fn(1000);
                    }
                    else if (animName == "boss-flag-appear") {
                        object.y = object.y - 250;
                        object.setScale(1, 0.5);
                        object.alpha = 0;
                        this.scene.tweens.add({
                            targets: object,
                            duration: 500,
                            scaleY: 1,
                            y: object.y + 250,
                            alpha: 1,
                            ease: Phaser.Math.Easing.Back.Out
                        });
                        let flag_kfc_MC = object["flag_kfc_MC"].setPosition(0, -50);
                        flag_kfc_MC.scaleY = 0;
                        this.scene.tweens.add({
                            targets: flag_kfc_MC,
                            duration: 500,
                            y: -185,
                            scaleY: 1,
                            ease: Phaser.Math.Easing.Sine.Out
                        });
                        object.add(flag_kfc_MC);
                    }
                }
                else if (object["playingAnimName"]) {
                    object.play(object["playingAnimName"]);
                }
            }
            gotoAndPlay(sprite, label) {
                let animName = sprite["libId"] + "_" + label;
                sprite['_animationComplete_'] = false;
                sprite['_animationToComplete_'] = animName;
                if (!sprite["_animationComplete_listener_"]) {
                    sprite["_animationComplete_listener_"] = true;
                    sprite.on('animationcomplete', () => {
                        if (sprite.anims.getCurrentKey() == sprite['_animationToComplete_']) {
                            sprite['_animationComplete_'] = true;
                        }
                    });
                }
                sprite.anims.stop();
                sprite.play(animName);
            }
            isAnimationComplete(sprite) {
                return !sprite.hasOwnProperty('_animationComplete_') || sprite['_animationComplete_'];
            }
            createRonaldSprite() {
                let ronald_mc = this.scene.add.sprite(335, 115, 'ui-atlas', 'ronald_mc0000');
                let ronald_mc_anims = {
                    'appear': { start: 0, end: 37 },
                    'disappear': { start: 38, end: 70 },
                    'disappeared': { start: 71, end: 83 },
                    'hit': { start: 84, end: 255 },
                    'idle': { start: 256, end: 798 },
                    'laugh': { start: 799, end: 884 },
                    'midLaugh': { start: 826, end: 884 }
                };
                for (let an in ronald_mc_anims) {
                    if (!this.scene.anims.exists(an)) {
                        this.scene.anims.create({
                            key: an,
                            frames: this.scene.anims.generateFrameNames('ui-atlas', {
                                start: ronald_mc_anims[an]['start'], end: ronald_mc_anims[an]['end'], zeroPad: 4,
                                prefix: 'ronald_mc', suffix: ''
                            }),
                            frameRate: 60
                        });
                    }
                }
                return ronald_mc;
            }
        }
        Factory.ANIM = {
            'chickette_small': {
                'walk': { 'start': 0, 'end': 17 },
                'idle': { 'start': 0, 'end': 5 },
                'fly': { 'start': 6, 'end': 6 },
                'squat': { 'start': 18, 'end': 18 },
                'pounceLand': { 'start': 19, 'end': 35 },
                'pounce': { 'start': 36, 'end': 66 },
                'climbing': { 'start': 67, 'end': 83 },
                'grow': { 'start': 84, 'end': 115 }
            },
            'chickette_big': {
                'walk': { 'start': 0, 'end': 17 },
                'idle': { 'start': 0, 'end': 5 },
                'fly': { 'start': 6, 'end': 6 },
                'pounceLand': { 'start': 18, 'end': 34 },
                'pounce': { 'start': 35, 'end': 49 },
                'climbing': { 'start': 50, 'end': 66 },
                'grow': { 'start': 67, 'end': 98 },
                'seaKittenise': { 'start': 99, 'end': 133 }
            },
            'nugget_small': {
                'walk': { 'start': 0, 'end': 17 },
                'idle': { 'start': 0, 'end': 5 },
                'fly': { 'start': 6, 'end': 6 },
                'pounceLand': { 'start': 18, 'end': 34 },
                'pounce': { 'start': 35, 'end': 59 },
                'climbing': { 'start': 60, 'end': 76 },
                'grow': { 'start': 77, 'end': 108 }
            },
            'nugget_big': {
                'walk': { 'start': 0, 'end': 17 },
                'idle': { 'start': 0, 'end': 5 },
                'fly': { 'start': 6, 'end': 6 },
                'pounceLand': { 'start': 18, 'end': 34 },
                'pounce': { 'start': 35, 'end': 49 },
                'climbing': { 'start': 50, 'end': 66 },
                'grow': { 'start': 67, 'end': 98 },
                'seaKittenise': { 'start': 99, 'end': 133 }
            },
            'pam_small': {
                'walk': { 'start': 0, 'end': 17 },
                'idle': { 'start': 0, 'end': 5 },
                'fly': { 'start': 6, 'end': 6 },
                'pounceLand': { 'start': 18, 'end': 34 },
                'pounce': { 'start': 35, 'end': 64 },
                'climbing': { 'start': 65, 'end': 81 },
                'grow': { 'start': 82, 'end': 113 }
            },
            'pam_big': {
                'walk': { 'start': 0, 'end': 17 },
                'idle': { 'start': 0, 'end': 5 },
                'fly': { 'start': 6, 'end': 6 },
                'pounceLand': { 'start': 18, 'end': 34 },
                'pounce': { 'start': 35, 'end': 49 },
                'climbing': { 'start': 50, 'end': 66 },
                'grow': { 'start': 67, 'end': 98 },
                'seaKittenise': { 'start': 99, 'end': 133 }
            }
        };
        gameplay.Factory = Factory;
    })(gameplay = nscs.gameplay || (nscs.gameplay = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var gameplay;
    (function (gameplay) {
        class Gameplay {
            constructor() {
                this.character = Gameplay.characters[0];
                this.worlds = [
                    ['1', '_LEVEL1DATA', 400, 160, 1420, NaN],
                    ['2', '_LEVEL2DATA', 400, 230, 1150, [1195, { p1: { x: 400, y: 360 }, p2: { x: 1050, y: 360 }, p3: { x: 1050, y: 560 }, p4: { x: 400, y: 560 } }]],
                    ['2.1', '_LEVEL2_1DATA', 500, 94, 846, -10],
                    ['2.2', '_LEVEL2_2DATA', 100, 1244, 1275, 1322],
                    ['3', '_LEVEL3DATA', 600, 70, 1320, NaN],
                    ['4', '_LEVEL4DATA', 600, 60, 1230, NaN],
                    ['4.1', '_LEVEL4_1DATA', 200, 1370, 180, 1292],
                    ['5', '_LEVEL5DATA', 900, 128, 833, NaN],
                    ['5.1', '_LEVEL5_1DATA', 350, 1214, 847, NaN]
                ];
                this.thisWorldId = 0;
                this.lives = 3;
                // player physics:
                this.charSize = 'small';
                this.ammo = 0; // int representing appropriate bullet MC frame (0: no ammo)
                this.seaKitten = false;
                this.xSpeed0 = 180; // 1 - 10
                this.xSpeed = this.xSpeed0; // 1 - 10
                this.ladderSpeed0 = 125; // 1 - 10
                this.jumpHeight0 = 600; // 1 - 10
                this.jumpHeight = this.jumpHeight0;
                this.gravity = Gameplay.gravity0; // 1 - 10
                this.gravityDir = 1; // 1 is upright -1 is upside down
                // init
                this.inWater = false;
                this.waterLevel = NaN;
                this.waterRects = null;
                this.ladderSpeed = this.ladderSpeed0;
                // world dimensions
                this.tileWidth = 32;
                this.tileHeight = 32;
                this.worldTilesX = 90;
                this.worldTilesY = 47;
                this.levelComplete = false;
                this.gameScreen = null;
                this.gameScreensInCache = [];
                /////////////////// SCORING ////////////////////
                this.score = 0;
                this.scoreUps = 10;
                this.milestone = 0;
                this.chicks = 0;
            }
            static setText(textField, stringsType, updateTextFieldPosition = true) {
                let str = this.strings[stringsType][Gameplay.languages.indexOf(Gameplay.currentLanguage)];
                if (updateTextFieldPosition) {
                    nscs.util.Functions.updateTextFieldPosition(textField, str);
                }
                else {
                    textField.setText(str);
                }
            }
            static getText(stringsType) {
                let str = this.strings[stringsType][Gameplay.languages.indexOf(Gameplay.currentLanguage)];
                let substr = '%PLAYER%';
                while (str.indexOf(substr) >= 0) {
                    str = str.replace('%PLAYER%', nscs.util.Functions.capitalise(nscs.scene.MainScene.instance.gameplay ?
                        nscs.scene.MainScene.instance.gameplay.character : Gameplay.characters[0]));
                }
                return str;
            }
            isGravityFlipped() {
                return this.gravityDir < 0;
            }
            calculateGravity() {
                return this.gravity * this.gravityDir;
            }
            getFanWaterCoefficient() {
                return this.inWater ? 1 : 1 / 1.5;
            }
            loadWorld(worldId, transitionFlag = true, destroyPreviousWorlds = true, takeFromCache = false) {
                this.grid = null;
                this.levelComplete = false;
                this.worldWidth = this.tileWidth * this.worldTilesX;
                this.worldHeight = this.tileHeight * this.worldTilesY;
                nscs.scene.MainScene.instance.physics.world.bounds.width = this.worldWidth;
                nscs.scene.MainScene.instance.physics.world.bounds.height = this.worldHeight;
                if (typeof worldId === "string") {
                    for (let i = 0; i < this.worlds.length; i++) {
                        if (this.worlds[i][0] == worldId) {
                            worldId = i;
                            break;
                        }
                    }
                }
                this.thisWorldId = worldId;
                // gather world information
                let world = this.worlds[this.thisWorldId];
                this.newX = Number(world[3]);
                this.newY = Number(world[4]);
                let waterRects = [];
                if (typeof world[5] == "number") {
                    this.waterLevel = Number(world[5]);
                }
                else {
                    for (let elemet of world[5]) {
                        if (typeof elemet == "number") {
                            this.waterLevel = Number(elemet);
                        }
                        else {
                            waterRects.push(elemet);
                        }
                    }
                }
                if (waterRects.length > 0)
                    this.waterRects = waterRects;
                else
                    this.waterRects = null;
                this.timer0 = this.timer = Number(world[2]);
                this.loadLevel(String(world[1]));
                let prevGameScreen = this.gameScreen;
                this.gameScreen = null;
                let takenFromCache = false;
                if (takeFromCache) {
                    for (let i = this.gameScreensInCache.length - 1; i >= 0; i--) {
                        if (this.gameScreensInCache[i].worldIdName == world[0]) {
                            this.gameScreen = this.gameScreensInCache[i];
                            this.gameScreensInCache.splice(i, 1);
                            takenFromCache = true;
                            break;
                        }
                    }
                }
                if (destroyPreviousWorlds) {
                    this.destroyPreviousWorlds();
                    this.gravityDir = 1;
                }
                else {
                    if (prevGameScreen) {
                        let notExistSameNamedGameScreenAlready = true;
                        for (let i = this.gameScreensInCache.length - 1; i >= 0; i--) {
                            if (this.gameScreensInCache[i].worldIdName == prevGameScreen.worldIdName) {
                                notExistSameNamedGameScreenAlready = false;
                                break;
                            }
                        }
                        if (notExistSameNamedGameScreenAlready) {
                            this.gameScreensInCache.push(prevGameScreen);
                        }
                    }
                }
                if (!takenFromCache) {
                    this.gameScreen = new nscs.screen.GameScreen(nscs.scene.MainScene.instance, world[0]);
                    this.loadSprites();
                    this.gameScreen.fetchRecoveryPoints();
                }
                nscs.scene.MainScene.instance.switchScreen(this.gameScreen, transitionFlag, destroyPreviousWorlds);
                nscs.util.Functions.updateTextFieldPosition(this.gameScreen.inGameUI.world_txt, String(world[0].split(".")[0]));
                nscs.util.Functions.updateTextFieldPosition(this.gameScreen.inGameUI.timer_txt, String(this.timer));
                this.gameScreen.inGameUI.setCharacterName(nscs.util.Functions.capitalise(this.character), this.lives);
                this.gameScreen.inGameUI.setScore(this.score);
                this.startTimer();
            }
            destroyPreviousWorlds() {
                for (let i = this.gameScreensInCache.length - 1; i >= 0; i--) {
                    this.gameScreensInCache[i].destroy(true);
                    this.gameScreensInCache.splice(i, 1);
                }
            }
            startTimer() {
                this.destroyTimer();
                this.timerEvent = nscs.scene.MainScene.instance.time.addEvent({ delay: 1000, repeat: this.timer0 });
                this.timerEvent.callback = () => {
                    this.timer = this.timerEvent.repeatCount;
                    nscs.util.Functions.updateTextFieldPosition(this.gameScreen.inGameUI.timer_txt, String(this.timer));
                    if (this.timer == 0) {
                        this.gameScreen.onTimeout();
                    }
                };
            }
            pause() {
                this.timerEvent.paused = true;
            }
            resume() {
                this.timerEvent.paused = false;
            }
            destroyTimer() {
                if (!this.timerEvent)
                    return;
                this.timerEvent.paused = true;
                this.timerEvent.destroy();
            }
            destroy() {
                this.destroyPreviousWorlds();
                this.destroyTimer();
            }
            loadLevel(worldFile) {
                let data = nscs.scene.MainScene.instance.cache.json.get('data');
                let levelDataRaw = data[worldFile];
                this.levelData = new Object();
                let levelDataVars = levelDataRaw.split('&');
                for (let ldv = 0; ldv < levelDataVars.length; ldv++) {
                    let dataBits = levelDataVars[ldv].split('=');
                    let varName = dataBits[0];
                    let varValue = dataBits[1];
                    this.levelData[varName] = varValue;
                }
                var dats = this.levelData["ldat"].split(",");
                var cnt = 0;
                this.grid = new Array(this.worldTilesY);
                for (var i = 0; i < this.worldTilesY; i++) {
                    this.grid[i] = new Array(this.worldTilesX);
                    for (var j = 0; j < this.worldTilesX; j++) {
                        this.grid[i][j] = Number(dats[cnt++]);
                    }
                }
                this.solid_array = this.levelData['sol'].split(",");
                this.ladder_array = this.levelData['lad'].split(",");
                this.spriteList = this.levelData['sprites'].split(',');
                this.updateWaterPhysics();
            }
            loadSprites() {
                let spriteCount = 0;
                for (let sp = 0; sp < this.spriteList.length; sp++) {
                    spriteCount++;
                    let spriteInfo = this.spriteList[sp].split('|');
                    /*
                    spriteInfo[0] = sprite id
                    spriteInfo[1] = x
                    spriteInfo[2] = y
                    spriteInfo[3] = libId
                    spriteInfo[4] = options
                    */
                    let sprite_mc = nscs.scene.MainScene.instance.factory.createSprite(spriteInfo);
                    sprite_mc["spriteNumber"] = spriteCount;
                    this.gameScreen.addSprite(sprite_mc);
                }
                this.gameScreen.onSpritesAdded();
            }
            addLife() {
                this.lives++;
                this.gameScreen.showTextPopUp('1UP');
                this.gameScreen.inGameUI.setCharacterName(nscs.util.Functions.capitalise(this.character), this.lives);
            }
            minusLife() {
                this.lives--;
                this.gameScreen.inGameUI.setCharacterName(nscs.util.Functions.capitalise(this.character), this.lives);
                this.setSeaKitten(false);
            }
            addToScore(scoreToAdd) {
                this.score += scoreToAdd;
                this.gameScreen.inGameUI.setScore(this.score);
            }
            scoreUp(scoreBit) {
                this.gameScreen.scoreUp(scoreBit);
                // play scoreUp animation:
                this.addToScore(scoreBit);
                this.scoreUps++;
            }
            addChick() {
                this.chicks++;
                this.gameScreen.inGameUI.setChicks(this.chicks);
                if (Math.floor(this.chicks / 100) > this.milestone) {
                    this.milestone = Math.floor(this.chicks / 100);
                    this.addLife();
                }
            }
            getNextWorldNumber() {
                let thisWorldId = this.thisWorldId;
                if (typeof thisWorldId == "number") {
                    thisWorldId = this.worlds[this.thisWorldId][0];
                }
                let thisWorldsNumber = Math.floor(parseFloat(thisWorldId));
                return thisWorldsNumber + 1;
            }
            loadNextWorld() {
            }
            setSeaKitten(active) {
                this.seaKitten = active;
            }
            updateWaterPhysics() {
                if (this.inWater) {
                    this.gravity = Gameplay.gravity0 * 0.19;
                    if (this.seaKitten) {
                        this.xSpeed = this.xSpeed0 * 0.65;
                        this.jumpHeight = this.jumpHeight0 * 0.4;
                    }
                    else {
                        this.xSpeed = this.xSpeed0 * 0.7;
                        this.jumpHeight = this.jumpHeight0 * 0.41;
                    }
                }
                else {
                    // revert
                    this.gravity = Gameplay.gravity0;
                    this.xSpeed = this.xSpeed0;
                    this.jumpHeight = this.jumpHeight0;
                }
            }
            calculateTotalScore() {
                this.score += this.timer * 100;
                if (this.thisWorldId == 5) {
                    this.score += this.lives * 1500;
                }
            }
        }
        Gameplay.isPamLocked = true;
        Gameplay.languages = ["EN", "NL", "ES", "SK", "JA", "DE"];
        Gameplay.currentLanguage = "EN";
        Gameplay.strings = {
            NewGameBtn: ["New Game", "Nieuwe game", "Juego nuevo", "Nová hra", "新しいゲームへ", "Neues Spiel"],
            StartKidFriendlyGameBtn: ["Start Kid-Friendly Game", "Start dit kindvriendelijke spel", "Iniciar juego apropiado para niños", "Hra začiatočného stupňa vhodná pre deti", "子ども用ゲームをスタート", "Kinderfreundliches Spiel starten"],
            NextBtn: ["Next", "Volgende", "Siguiente", "Ďalší", "次", " Zunächst "],
            EnterCodeBtn: ["Enter Code", "Entercode", "Introduce código", "Zadaj kód", "コード入力", "Code eingeben"],
            EnterCodePrompt: ["Enter code to play as Pamela Anderson:", "Klik op de entercode en speel als Pamela:", "Introduce el código para jugar como Pamela Anderson:", "Zadaj kód, aby si mohol hrať ako Pamela Andersonová:", "パメラ・アンダーソンとしてプレーするためにコードを入力", "Gib den Code ein, um als Pamela zu spielen:"],
            OKBtn: ["OK", "OK", "Aceptar", "OK", "OK", "OK"],
            CancelBtn: ["Cancel", "Annuleer", "Cancelar", "Zruš", "キャンセル", "Löschen "],
            HighScoresBtn: ["High Scores", "Hoge scores", "Puntuación alta", "Vysoké skóre", "ハイスコア", "High Score"],
            Instruct1: ["Princess Pamela Anderson has been captured by evil Ronald McDonald, who plans on making her a part of his unhappy meals along with the chickens who are tortured for McDonald\'s restaurants. Help free Princess Pam and save the chickens from McDonald\'s cruelty!", "Prinses Pamela Anderson is gevangengenomen door de boosaardige Ronald McDonald, die van plan is haar te gebruiken voor zijn unhappy meals, samen met de kippen die levend worden verbrand voor de McDonald\'s restaurants. Help Prinses Pam te bevrijden en red de kippen van McDonald\'s wreedheid!", " La Princesa Pamela Anderson ha sido capturado por el malvado Ronald McDonald, quien planea transformarla en una pieza de su \'Cajita infeliz\' junto con los pollos quienes son escaldados vivos para McDonald\'s. ¡Ayuda a liberar Princesa Pam y salva los pollos de la crueldad de McDonald\'s! ", "Zlý Ronald McDonald zajal princeznu Pamelu Andersonovú. Tá bude spolu s kuriatkami zaparenými za živa súčasťou \'unhappy meals\' pre reštaurácie McDonald. Pomôž oslobodiť princeznu Pam a zachráň kuriatka pred krutým McDonaldom!", "パメラ・アンダーソン姫が悪者ロナルド・マクドナルドにとらわれました。マクドナルドはパメラ姫を「アンハッピー・ミール」に入れてしまうつもりです。マクドナルドのアンハッピー・ミールに使われるニワトリは、生きたままゆでられてしまいます。パメラ姫を助け、残酷なマクドナルドからニワトリたちを助けてください!", "Prinzessin Pamela Anderson wurde vom bösen Ronald McDonald entführt. Dieser plant sie zu einem Teil für eines seiner Unhappy-Meals zu verarbeiten. Zusammen mit den Hühnern, die bei lebendigem Leib für McDonald\'s Restaurants in den USA verbrüht werden! Hilf Prinzessin Pam zu befreien und die Hühner vor McDonald\'s Grausamkeit zu retten."],
            StartGameBtn: ["Start Game", "Start game", "Iniciar juego", "Spustiť hru", "ゲーム開始", "Spiel starten"],
            Instruct2: ["Use the arrow keys to move. Press Spacebar to jump and break blocks. Defeat enemies by jumping on their heads. Press Escape to pause the game.", "Gebruik de pijltjestoetsen om te bewegen. Gebruik de spatiebalk om te springen en de blokkades te breken. Versla je vijanden door op hun hoofd te springen. Toets \'Excape\' voor pauze.", " Utiliza las flechas para moverse. Utiliza la flecha \'arriba\' para saltar, subir, y romper bloques. Presiona \'Esc\' para poner en pausa el juego. Derrota a los enemigos por saltar en sus cabezas.", "Na navigáciu použi klávesy so šípkami. Stlač medzerník, ak chceš preskočiť a prerušiť bloky. Skákaním na hlavy nepriateľov ich porazíš. Stlač «Escape» (Únik), ak chceš prerušiť hru.", "移動するには矢印キーを使ってください。スペースバーを押すと、飛び上がってブロックを割ることができます。敵の頭の上に飛び乗ると相手を倒せます。Escキーを押すとゲームを一時停止できます", "Benutze die Pfeiltasten, um Dich zu bewegen. Drücke die Leertaste, um zu springen und Steine zu zertrümmern. Besiege Deine Feinde, indem Du ihnen auf den Kopf springst. Drücke Die \'Escape\'-Taste um das Spiel zu pausieren."],
            ChooseChar: ["Choose Your Character!", "Kies je personage!", "¡Elige su personaje!", "Zvoľ si svoju postavičku!", "キャラクターを選んでください", "Wähle Deine Figur!"],
            Nugget: ["Nugget", "Goudhaantje", "Nugget", "Nugget", "ナゲット", "Nugget"],
            Chickette: ["Chickette", "Kippie", "Chickette", "Chickette", "チッケット", "Chickette"],
            Pam: ["Pam", "Pam", "Pam", "Pam", "パメラ・アンダーソン", "Pam"],
            PamLong: ["Pamela Anderson", "Pamela Anderson", "Pamela Anderson", "Pamela Andersonová", "パメラ・アンダーソン", "Pamela Anderson"],
            Locked: ["Locked", "Gesloten", "Cerrado", "Zamknutý", "ロックされています", "Gesperrt"],
            World: ["World", "Wereld", "Mundo", "Svet", "ワールド", "Welt"],
            Time: ["Time", "Tijd", "Tiempo", "Čas", "時間", "Zeit"],
            Paused: ["Game Paused", "Spel afgebroken", "Juego en pausa", "Hra je prerušená", "ゲーム一時停止", "Pause"],
            QuitBtn: ["Quit", "Stoppen", "Abandonar", "Skončiť", "終了", "Ende"],
            ResumeBtn: ["Resume", "Terug", "Continuar", "Obnoviť", "再開", "Weiterspielen"],
            TimeOver: ["Time Over!", "Tijd verlopen!", "¡Tiempo muerto!", "Koniec vymedzeného času!", "時間切れです！", "Zeit zuende!"],
            activist1: ["Hi, %PLAYER%! Did you know that McDonald\'s is one of the biggest sellers of chicken flesh? And that they use an outdated method of slaughter that leads to extreme suffering for birds! Please help us now!", "Hi, %PLAYER%! Wist je dat McDonald\'s een van de grootste verkopers is van kippenvlees? En dat ze ouderwetse manieren van slachten gebruiken, waardoor de kippen extreem ernstig moeten lijden! Help ons alsjeblieft nu!", "¡Hola, %PLAYER%! ¿Sabías que McDonald\'s es uno de los vendedores más grandes de la carne del pollo? ¡Y que utilizan un método anticuado de matanza que causa sufrimiento extremo para los pájaros! ¡Ayúdanos ahora por favor!", "Ahoj, %PLAYER%!  Vedeli ste, že McDonald je jeden z najväčších predajcov kuracieho mäsa? A že používajú zastaralý spôsob zabíjania, ktorého dôsledok je extrémne trpenie vtáctva. Prosím, pomôžte nám teraz!", "こんにちは,%PLAYER%! マクドナルドは鶏肉（とりにく）の売上では世界有数の企業です。しかも、ニワトリがとても苦しむ時代遅れのやり方でニワトリを殺しています。早く助けてください！ ", " Hi, %PLAYER%! Wusstest Du, dass McDonald\'s in den USA einer der größten Verkäufer von Hühnerfleisch ist? Und dass sie in den USA veraltete Schlacht-Methoden anwenden, die dazu führen, dass die Vögel extrem leiden? Bitte hilf uns!"],
            activist2: ["Chickens who are killed by McDonald\'s suppliers have their throats cut while they are still conscious. You must save them from this cruelty!", "Bij de kippen die de leveranciers van McDonald\'s slachten, wordt de keel doorgesneden terwijl ze nog bij bewustzijn zijn. Je moet ze redden van deze wreedheid!", " Los pollos que son matados por los surtidores de McDonald\'s tienen sus gargantas cortadas mientras que son todavía conscientes. ¡Debes salvarles de esta crueldad!", "Kurčatá, ktoré sú zabité dodávateľmi pre McDonald, majú krky podrezané kým sú ešte pri vedomí. Musíte ich zachrániť pred tou krutosťou!", "マクドナルドに鶏肉を売る業者は、まだ意識のあるニワトリののどを切って殺すんです。こんな残酷な運命からニワトリたちを救ってください！", "Hühner die von McDonald’s-Zulieferern in den USA getötet werden, werden die Hälse durchgeschnitten, während sie noch bei Bewusstsein sind. Du musst sie vor diesen Grausamkeiten retten!"],
            activist3: ["There is a less cruel slaughter method that would eliminate these abuses, and it is available today. Help rescue the princess and convince McDonald\'s to use the less cruel method!", "Er bestaat een betere manier van slachten zonder al deze martelingen en dat zou al vanaf vandaag kunnen. Help de prinses te bevrijden en overtuig McDonald\'s ervan om deze minder wrede manier te gebruiken!", " Hay un método menos cruel de la matanza que eliminaría estos abusos, y está disponible hoy. ¡Ayuda salvar a la princesa y convencer McDonald\'s utilizar el método menos cruel!", "Existuje menej krutý spôsob zabitia, ktorý je k dispozícii dnes a ktorý sa zbaví tohto týrania. Pomôž zachrániť princeznu a presvedč McDonalda, aby použil menej krutý spôsob!", "ニワトリを殺すにしても、こんなに残酷でない方法があるんです。パメラ姫を助けてください。そして、マクドナルドにニワトリの虐待をやめさせてください！ ", " Es gibt bereits heute anwendbare weniger grausame Schlacht-Methode, die diese Leiden reduzieren würde. Hilf uns die Prinzessin zu retten und McDonald\'s USA davon zu überzeugen, die weniger grausame Schlacht-Methode zu benutzen!"],
            activist4: ["Save the princess, save the chickens!", "Red de prinses, red de kippen!", "¡Salva a la princesa, salva los pollos!", "Zachráň princeznu, zachráň kurčatá!", "パメラ姫を助けてください！ニワトリを助けてください！", "Rette die Prinzessin, rette die Hühner!"],
            activist5: ["I thought sea kittens had it bad until I heard about how chickens are killed for McDonald\'s. You have to hurry!", "Ik dacht dat zeekittens het slecht hadden, tot ik hoorde hoe de kippen voor McDonald\'s worden doodgemaakt. Je moet opschieten!", "Pensé que los gatitos del mar lo tenían malo hasta que oí cómo los pollos son matados por McDonald\'s. ¡Tienes que apresurarte!", "Myslel som si, že morské mačiatka to mali zlé dokiaľ som nepočul ako sa zabíjajú kurčatá pre McDonald. Musíš sa ponáhľať!", "海の子猫もかわいそうだけれど、マクドナルドに殺されるニワトリたちはもっとひどい目に合っています。急いでください！", "Ich dachte schon Wasser-Kätzchen hätten es schlecht, bis ich davon gehört habe, wie Hühner für McDonald’s USA getötet werden. Du musst Dich beeilen! "],
            activist6: ["In the slaughterhouses of McDonald\'s chicken suppliers, birds are dumped out of their transport crates with no regard for their pain or well-being. Ouch!", "In de slachthuizen van McDonald\'s kippenleveranciers worden de dieren uit hun transportkratten gesmeten zonder rekening te houden met hun pijn en welzijn. Au!", " En los mataderos de los surtidores del pollo de McDonald\'s, los pájaros se descargan fuera de sus cajones del transporte sin consideración por su dolor o bienestar. ¡Qué dolor!", "V jatkách dodávateľov kurčiat pre McDonald sú vtáci vysypaní z prepraviek, bez ohľadu na ich bolesť či stav.", "マクドナルドに鶏肉を売る業者の屠殺場では、ニワトリの痛みや苦しみにはおかまいなく、ニワトリを輸送用の箱から乱暴に放り出します", " In den Schlachthäusern der McDonald’s USA-Zulieferer werden die Vögel einfach aus ihren Käfigen herausgeschüttelt ohne dabei auf ihre Schmerzen und ihr Wohlergehen zu achten. Aua!"],
            activist7: ["McDonald\'s refuses to require its U.S. and Canadian suppliers to switch to a less cruel method of slaughtering birds, even though one is available. It\'s called controlled atmosphere killing, or CAK. Help save chickens from the cruel slaughter!", "McDonald\'s weigert van zijn Amerikaanse en Canadese leveranciers te eisen dat ze overstappen op een minder wrede manier van kippen slachten, terwijl er al zo\'n manier is. Dit heet \'gecontroleerde atmosfeer doding\' (GAD). Help om de kippen te redden van het wrede slachten!", "McDonald\'s se niega requerir los surtidores estadounidenses y canadienses cambiar a un método menos cruel de matar pájaros, aunque uno ya está disponible. Se llama \'matanza en atmósfera controlada\', o CAK. ¡Ayuda a salvar los pollos de la matanza cruel!", "McDonald odmieta požadovať od svojich amerických a kanadských dodávateľov menej krutý spôsob zabíjania vtákov, aj keď ten je k dispozícii. Nazýva sa \'kontrolované atmosferické zabíjanie\', alebo CAK. Pomôž zachrániť kurčatá pred krutým zabíjaním.", "CAKという、もっと残酷でない屠殺の方法があるのに、マクドナルドは、アメリカとカナダの業者に、方法を変えさせようとしません。残酷な屠殺からニワトリを助けてください！", "McDonald\'s USA weigert sich, seine amerikanischen und kanadischen Zulieferer aufzufordern, eine weniger grausame Schlachtungsmethode anzuwenden, obwohl diese Methode bereits existiert. Diese Methode nennt sich \'CAK\' (Controlled Atmosphere Killing). Hilf dabei, die Hühner vor der grausamen Schlachtung zu retten!"],
            activist8: ["%PLAYER%! Is that really you? Chickens are being hung upside down in metal shackles right now. This can lead to broken bones, extreme bruising, and hemorrhaging. Help!", "%PLAYER%! Heb dat echt waar? Kippen worden gewoon ondersteboven opgehangen aan ijzeren haken. Dit zorgt vaak voor gebroken botten, ernstige kneuzingen en bloeduitstortingen. Help!", "¡%PLAYER%! ¿El realmente usted? Los pollos se están colgando patas arriba en grillos del metal ahora mismo. Esto puede resultar en los huesos quebrados, la contusión extrema, y la hemorragia. ¡Ayuda!", "%PLAYER%!  Si to naozaj ty? Kurčatá teraz visia hlavou nadol v kovových putách. To môže spôsobiť zlomeniny kostí, mimoriadné podliatiny a krvácanie. Pomoc!", "%PLAYER%!本当に君なの？ニワトリは金属製の足かせをはめられて、逆さ吊りにされています。そのために、骨が折れたり、ひどいあざになったり、出血したりします。助けてください！", "%PLAYER%! Bist Du es wirklich? Genau jetzt hängen Hühner kopfüber an Fussfesseln. Dies kann zu gebrochenen Knochen, tiefen Verletzungen und starken Blutungen führen."],
            activist9: ["The future is dim for chickens who are raised by McDonald\'s suppliers. In slaughterhouses, many birds are immersed in tanks of scalding-hot water while they are still alive and able to feel pain!", "Voor de kippen die de leveranciers fokken voor McDonald\'s ziet de toekomst er somber uit. In slachthuizen worden veel kippen ondergedompeld in tanks met kokendheet water, terwijl ze nog leven en pijn kunnen voelen!", "El futuro es oscuro para los pollos que son criados por los surtidores de McDonald\'s. ¡En los mataderos, muchos pájaros se sumergen en los tanques de agua hirviendo mientras que están vivos todavía y sienten dolor!", "Budúcnosť vyzerá hmlisto pre kurčatá chované dodávateľmi pre McDonald. Mnohí vtáci sú ponorení do nádoby s horúcou vodou ešte za živa a sú schopní cítiť bolesť.", "マクドナルドの業者に飼われているニワトリの運命は悲惨です。屠殺場では、たくさんのニワトリが、まだ生きていて痛みを感じられるうちに、熱湯につけられるんです！", "Die Zukunft sieht trübe aus für die Hühner die bei den McDonald\'s USA Zulieferern aufgezogen werden. In diesen Schlachthäusern werden viele der Vögel in siedend heiße Wasserbecken geworfen, während sie noch lebendig sind und Schmerz empfinden!"],
            activist10: ["Hurry! McDonald\'s is painfully slaughtering chickens for unhappy meals right now!", "Opschieten! McDonald\'s is nu zeer pijnlijk kippen aan het slachten voor unhappy meals!", "¡Date prisa! ¡McDonald\'s está matando dolorosamente los pollos para las \'comidas infelices\' ahora mismo!", "Ponáhľaj sa! McDonald teraz bolestivo zabíja kurčatá na unhappy meal!", "急がないと！今この瞬間にも、マクドナルドはアンハッピー・ミールのためにニワトリを苦しめて殺しています！", "Beeil Dich! McDonald\'s USA tötet in diesem Moment auf grausame Weise Hühner für ihre Unhappy Meals!"],
            activist11: ["I might be a veggie burger, but I still have to help McDonald\'s chickens. CAK (an alternative to McDonald\'s method of slaughter) would eliminate the worst abuses currently suffered by chickens who are killed for McDonald\'s by gently putting the birds to sleep before they are slaughtered.", "Ik mag dan een vegaburger zijn, maar ik moet nog wel de kippen van McDonald\'s helpen. GAD (een alternatief voor de manier van slachten van McDonald\'s) zou de ergste mishandelingen verminderen, die de kippen die worden doodgemaakt voor McDonald\'s nu nog ondergaan. Gewoon door de kippen zachtjes te laten inslapen voordat ze worden gedood.", "Puede ser que sea una hamburguesa vegetariana, pero todavía tengo que ayudar a los pollos de McDonald\'s. CAK (un alternativo al método de matanza de McDonald\'s) eliminaría los abusos peores sufridos actualmente por los pollos que son matados para McDonald\'s por hacerles dormir suavemente antes de que les maten. ", "Aj keď som len zeleninový burger, musím pomôcť McDonaldovým kurčatám. CAK (alternatíva pre McDonaldov spôsob zabíjania) by odstránil najhoršie týranie, ktoré trpia kurčatá zabíjané pre McDonalda. Uspali by sa pred tým než by boli zabité.", "私はベジー・バーガーだけど、マクドナルドのニワトリを助けたい。マクドナルドが使うニワトリは、残酷な方法で殺され、虐待に苦しんでいます。でも、CAKという屠殺方法は、麻酔を使うので、ニワトリが苦しみません", " Ich bin zwar ein Veggie-Burger, aber ich muss den McDonald’s Hühnern trotzdem helfen. CAK (eine weniger grausame Schlacht-Alternative gegenüber der von McDonald’s USA) würde die schlimmsten Misshandlungen verhindern, die Hühner zurzeit wegen McDonald’s USA erleiden müssen, indem sie durch CAK betäubt werden würden, bevor man sie schlachtet."],
            activist12: ["A McDonald\'s study concluded that CAK is far better for animals than the current method of slaughter, yet McDonald\'s doesn\'t require all its suppliers to use CAK. Please, hurry and tell McDonald\'s to adopt this less cruel slaughter method!", "Een onderzoek van McDonald\'s toonde aan dat GAD veel beter is voor dieren dan de huidige manier van slachten. Toch eist McDonald\'s niet van zijn leveranciers dat ze GAD gebruiken. Maak alsjeblieft haast en vertel McDonald\'s om op deze minder wrede slachtmethode over te stappen!", " Un reportaje de McDonald\'s concluyó que CAK es mucho mejor para los animales que el método actual de matanza, pero McDonald\'s no requiere a todos sus surtidores utilizar CAK. ¡Por favor, apresúrate y di a McDonald\'s adoptar este método menos cruel de la matanza!", "Štúdia vypracovaná McDonaldom dospela k záveru, že CAK je omnoho lepšie pre zvieratá než súčasný spôsob zabíjania, avšak McDonald nevyžaduje od všetkých svojich dodávateľov použitie CAK. Prosím, poponáhľaj sa a povedz McDonaldovi, aby prijal tento menej krutý spôsob zabíjania!", "マクドナルドが行った研究によると、CAKは、今使われている方法より、動物にとって、はるかにすぐれています。なのに、マクドナルドは、すべての業者にCAKを使うようにさせていません。一刻も早く、マクドナルドに、もっと残酷でない方法を採用させてください！", " Eine McDonald’s-Studie kam zu dem Ergebnis, dass die CAK-Methode sehr viel besser für die Tiere ist als die aktuell verwendete Schlachtungsmethode. Trotzdem verlangt McDonald’s USA weiterhin nicht von allen seinen Zulieferern, die CAK-Methode auch anzuwenden. Bitte beeilt Euch und lass McDonald’s wissen, dass sie die CAK-Methode schnellstens einführen sollen!"],
            activist13: ["Yes, you might say I\'ve got fertilizer on the brain!", "Ja, je kunt zeggen dat ik kunstmest in m\'n hersens heb!", "¡Sí, podrías decir que tengo fertilizante en el cerebro!", "Áno, dá sa povedať, že som si prevetral mozog!", "頭に肥やしがかかったみたい！", "Ja, du könntest behaupten dass ich Dünger in meinem Gehirn habe!"],
            activist14: ["PETA investigations have revealed that cruelty to birds in slaughterhouses is not uncommon. I\'ll never eat an unhappy meal again!", "Onderzoekingen van PETA onthulden dat wreedheid tegen kippeen in slachthuizen niet ongewoon is. Ik eet nooit meer een unhappy meal!", "Las investigaciones de PETA han revelado que la crueldad a los pájaros en mataderos no es infrecuente. ¡Yo nunca comeré una cajita infeliz otra vez!", "Vyšetrovania PETA odhalili, ze kruté zaobchádzanie s vtákmi v jatkách nie je neobvyklé. Už nikdy viac nebudem jesť unhappy meal!", "PETAの調査によると、屠殺場でニワトリが虐待されるのは珍しいことではないんです。アンハッピー・ミールなんか絶対食べない！", "Untersuchungen von PETA USA haben ergeben, dass Grausamkeit gegenüber Vögeln in Schlachthäusern leider keine Seltenheit darstellt. Ich werde nie wieder ein Unhappy Meal essen!"],
            activist15: ["Please hurry to help chickens who are served as food under the Golden Arches!", "Schiet alsjeblieft op om de kippen te helpen, die als voedsel worden opgediend bij McDonald\'s!", "¡Apresúrate por favor para ayudar a los pollos que se sirven como alimento debajo de los Arcos de Oro!", "Prosím, ponáhľaj sa pomôcť kurčatám, ktoré sú podávané ako jedlo pod Zlatými Klenbami!", "ゴールデン・アーチの下で料理されるニワトリたちを早く助けて！", "Bitte beeilt Euch und helft den Hühnern, die unter dem McDonald\'s Logo als Essen verkauft werden!"],
            activist16: ["You\'re almost there! Please save Princess Pam from Ronald McDonald and his evil minions.", "Je bent er bijna! Bevrijd alsjeblieft Prinses Pam uit handen van Ronald McDonald en zijn boosaardige volgelingen.", "¡Estás cerca de llegar! Por favor rescata a Princesa Pam de Ronald McDonald y sus subordinados malvados.", "Takmer si už tam! Prosím Ťa, zachráň princeznu Pam pred Ronaldom McDonaldom a jeho zlomyseľnou misiou.", "もうすぐですよ！ロナルド・マクドナルドとその手先の悪者たちからパメラ姫を助けてください", "Du hast es fast geschafft! Bitte rette Prinzessin Pam aus den Klauen von Ronald McDonald und seinen bösen Helfern."],
            activist17: ["A little birdy told me that to get to those hard-to-reach places, you can try jumping off the walls. Give it a go!", "Een vogeltje vertelde me dat je op deze moeilijk bereikbare plekken kunt komen door van de muur te springen. Probeer het maar eens!", "Un pajarito me dijo que para ir a los lugares difíciles alcanzar, puedes intentar saltar de las paredes. ¡Pruébalo!", "Malý vtáčik mi povedal, že ak sa chceš dostať do tých ťažko prístupných miest, tak sa môžeš pokúsiť zoskočiť zo stien. Urob to!", "壁からジャンプすると、行きにくい場所にも行けるかもしれません。試してみてください！", "Ein kleiner Vogel hat mir erzählt, dass Du gegen Wände und von dort aus direkt nochmal springen kannst, um an schwer erreichbare Orte zu gelangen. Probier\'s mal!"],
            activist18: ["I heard that if you stomp on your enemies, you\'ll get more points! To stomp, press the down-arrow key when you are mid-jump.", "Ik hoorde dat je extra punten krijgt als je op je vijanden stampt! Om te stampen druk je op de Down-toets tijdens je sprong.", "¡Oí que si pisas fuerte en tus enemigos, vas a ganar más puntos! Para pisar fuerte, pulsa la tecla con la flecha para abajo mientras estás saltando.", "Počul som, že ak rozdrviš nepriateľov, získaš viac bodov! Aby si ich rozdrvil, stlač klávesu so šípkou smerujúcou dole vtedy, keď stredne vysoko skáčeš.", "敵を踏みつけると、得点が増えます！相手を踏みつけるには、飛び上がっている間に下向きアローを押してください", "Ich habe gehört, dass Du mehr Punkte sammeln kannst, wenn Du auf Deine Feinde draufstampfst! Um zu stampfen, drücke einfach die Nach-Unten Pfeiltaste während Du springst."],
            activist19: ["There\'s something funny going on with the gravity in this place. It changes with the flick of a switch! Speaking of switches, you can flick them on and off by stomping on them (press the down-arrow key when you are mid-jump).", "Er is hier iets raars aan de hand met de zwaartekracht. Die verandert in een wip. Je kunt dit aan en uit zetten door erop te stampen (druk op de Down-toets tijdens je sprong).", " Hay algo extraño con la gravedad en este lugar. ¡Cambia con un pulso de un interruptor! Hablando de interruptores, puedes pulsarlos por pisarlos fuerte (pulsa la tecla de la flecha abajo cuando estás saltando).", "Čosi podivné sa tu deje s gravitačnou silou. Tá sa mení prepnutím spínača. Hovoriac o spínačoch, môžeš ich zapnúť a vypnúť tak, že ich rozdrviš (stlač klávesu so šípkou smerujúcou dole vtedy, keď stredne vysoko skáčeš.)", "重力が変になっています。スイッチを踏むと変えられます。（飛び上がっている間に下向きアローを押してください）。", "Irgendetwas stimmt mit der Schwerkraft an diesem Ort nicht. Sie verändert sich im Handumdrehen! Du kannst sie manipulieren, indem Du die Schalter benutzt. Das funktioniert, in dem Du einfach auf die Schalter stampfst (Nach-Unten Pfeiltaste während des Sprungs)."],
            activist20: ["Sea kittens are amazing creatures, but did you know that they suffer from hair balls? They can be deadly, particularly to enemies! To cough one up, just press the \'Shift\' key.", "Zeekittens zijn wonderlijke wezens, maar wist je dat ze last hebben van haarballen? Die kunnen dodelijk zijn, vooral voor vijanden! Om er een op te hoesten, druk je op de Shift-toets.", "¿Los gatitos del mar son criaturas maravillosas, pero sabías que sufren de bolas de pelo? ¡Pueden ser mortales, particularmente a los enemigos! Para toser uno para arriba, presiona la llave \'Shift\'.", "Morské mačiatka sú úžasné bytosti, avšak vieš, že strácajú veľa chlpových klbiek? To môže byť smrteľné, obzvlášť pre nepriateľov! Stlač klávesu \'Shift\', ak chceš jedno vykašľať.", "かわいい海の子猫は、毛玉が悩みの種。でも、これで敵を倒すこともできます。毛玉を発射するには、Altキーを押してください", "Wasser-Kätzchen sind fantastische Wesen, aber wusstest Du, dass sie unter Haarbällen leiden? Sie können tödlich sein, vor allem für Feinde! Um ein Haarballen herauszuhusten, drücke einfach die \'Shift\'-Taste."],
            GameOver: ["Game Over!", "Game over!", "¡Juego terminado!", "Koniec hry!", "ゲーム終了！", "Game over!"],
            GameOverText: ["Learn more about McDonald\'s cruelty to prepare for your next game.", "Leer meer over de wreedheid van McDonald\'s om je op de volgende game voor te bereiden.", "Aprende más sobre la crueldad de McDonald\'s y te prepara para tu próximo juego.", "Dozveď sa viac o McDonaldovej krutosti a priprav sa na novú hru.", "次のゲームのために、マクドナルドによる虐待について、もっと見てください！ ", "Lerne mehr über die Grausamkeit bei McDonald’s USA."],
            PlayAgainBtn: ["Play Again", "Opnieuw spelen", "Jugar otra vez", "Znovu hraj", "もう１度ゲームをする ", "Nochmal spielen"],
            HighScoresTitle: ["High Scores!", "Hoge scores", "Puntuación alta", "Vysoké skóre", "ハイスコア", "High Scores"],
            HighScoresConnecting: ["Connecting to high score server...", "Ga naar de hoge score server ...", "Conectando al servidor de puntuación alta…", "Pripájanie sa na server vysokého skóre…", "ハイスコア・サーバーに接続中・・・", "Verbindung zum High Score Server wird hergestellt"],
            HighScoresUnreachable: ["The high score server cannot be reached! Please check your Internet connection and try again...", "De server is niet te bereiken. Controleer je internetverbinding en probeer het opnieuw.", "¡El servidor de puntuación alta no puede ser encontrado! Por favor checa tu conexión del Internet e inténtalo otra vez…", "Server vysokého skóre sa nedá dosiahnuť! Skontroluj internetové spojenie a znovu sa pokús…", "ハイスコア・サーバーに接続できません！インターネット接続を確認して、もう１度試してください・・・", "Der High Score Server kann nicht verbunden werden. Bitte kontrolliere Deine Internetverbindung und versuche es noch einmal..."],
            RetryBtn: ["Retry", "Herstart", "Reintentar", "Opakovať", "再試行", "Wiederholen"],
            AllTimeBtn: ["All Time", "Top Score", "Sin precedentes", "Rekordný", "過去最高", "Alle"],
            RecentBtn: ["Recent", "Recent", "Reciente", "Aktuálny", "最近", "Letzte"],
            RestartBtn: ["Restart", "Herstart", "Reanudar", "Reštartuj", "リスタート", "Neustart"],
            HighScoreTitle: ["High Score!", "Hoge score!", "¡Puntaje alto!", "Vysoké skóre!", "ハイスコア！", "High Score!"],
            NamePrompt: ["Name:", "Naam:", "Nombre:", "Meno:", "名前： ", "Name"],
            PostBtn: ["Post!", "Verzend!", "¡Fijar!", "Zverejni!", "掲示！", "Eingeben!"],
            allTimeNotice: ["Yours is an all-time high score! Post your name to the scoreboard!", "Jij hebt de allerhoogste score! Plaats je naam op het scorebord!", "¡Tienes un puntaje alto sin precedentes! ¡Fija tu nombre al marcador!", "To tvoje sa nachádza v kategórii rekordne vysokého skóre! Zverejni svoje meno na tabuli výsledkov!", "過去最高のハイスコアです！スコアボードに名前を掲示してください！ ", "Du hast einen All-Time-High Score geschafft. Schreib Deinen Namen an die Ehrenwand!"],
            recentNotice: ["Yours is a recent high score! Post your name to the scoreboard!", "Jouw score was een van de hoogste! (Plaats je naam op het scorebord!", "¡Tienes un puntaje alto reciente! ¡Fija tu nombre al marcador!", "To tvoje sa nachádza v kategórii aktuálne vysokého skóre! Zverejni svoje meno na tabuli výsledkov!", "最近のハイスコアです！スコアボードに名前を掲示してください", "Du hast einen neuen High Score geschafft. Schreib Deinen Namen an die Ehrenwand!"],
            cutscene0_1: ["Pamela Anderson: I\'d like to thank all of you for being here for the opening of my new vegetarian restaurant, Double Delicious.", "Pamela Anderson: Ik dank jullie voor je aanwezigheid bij de opening van mijn nieuwe vegetarische restaurant Twee Keer Lekkerder.", " Pamela Anderson: Quisiera agradecerles por venir a la inauguración de mi nuevo restaurante vegetariano, Doble Delicioso.", "Pamela Andersonová: Chcela by som sa Vám všetkým poďakovať za to, že ste tu, na otvorení mojej novej reštaurácie, Double Delicious.", "パメラ・アンダーソン：皆さん、私のベジタリアン・レストラン「ダブル･デリシャス」の開店祝いに来ていただき、どうもありがとうございます。 ", "Pamela Anderson: Danke, dass Ihr alle zur Eröffnung meines neuen veganen Restaurants \'Double Delicious\' gekommen seid."],
            cutscene0_2: ["Ronald McDonald: Finally, I\'ve found the perfect toy for my next unhappy meal. I must have Princess Pam ...", "Ronald McDonald: Eindelijk heb ik het perfecte speeltje gevonden voor mijn volgende unhappy meal. Ik moet Prinses Pam hebben …", " Ronald McDonald: Por fin, he encontrado el juguete perfecto para mi próxima cajita infeliz. Debo tener Princesa Pam …", "Ronald McDonald: Konečne som našiel perfektnú hračku pre moje ďalšie unhappy meal. Musím mať princeznu Pam…", "ロナルド・マクドナルド：新しいアンハッピー･ミールにぴったりのおもちゃが、ようやく見つかったぞ。パメラ姫をつかまえなければ・・・。", "Ronald McDonald: Endlich habe ich das perfekte Spielzeug für mein neues Unhappy Meal gefunden. Es muss Prinzessin Pam sein…"],
            cutscene0_3: ["Pamela Anderson: Please help me!", "Pamela Anderson: Help me alsjeblieft!", " Pamela Anderson: ¡Ayúdame por favor!", "Pamela Andersonová: Prosím, pomôžte mi!", "パメラ・アンダーソン：誰か助けて！", "Pamela Anderson: Bitte helft mir!"],
            cutscene0_4: ["Nugget: Looks like we have to save the Princess once again. Chickette, let\'s go!", "Goudhaantje: Het ziet er naar uit dat wij de prinses opnieuw moeten redden. Kom op, Kippie!", "Nugget: Parece que nosotros tenemos que rescatar a la princesa otra vez. ¡Vamos, Chickette!", "Nugget: Vyzerá to tak, že opäť budeme musieť zachrániť princeznu. Chickette, poďme!", "ナゲット：またパメラ姫を助けなくちゃいけないみたい。チッケット、早く行こう！", "Nugget: Sieht ganz so aus, als müssen wir die Prinzessin mal wieder retten. Chickette, los geht\'s!"],
            cutscene0_5: ["Princess Pamela Anderson Kidnapped Again!", "Prinses Pamela Anderson is opnieuw ontvoerd!", "¡La Princesa Pamela Anderson secuestrada otra vez!", "Znovu unesená princezna Pamela Andersonová!", "パメラ・アンダーソン姫、再び誘拐される", "Prinzessin Pamela Anderson wieder gekidnappt!"],
            cutscene0_6: ["Mario: Mama mia! If only I hadn\'t been busy playing soccer, practicing baseball, preparing for the Olympics, making sequels, and grooming my manly mustache …", "Mario: Mama mia! Was ik maar niet zo druk bezig geweest met voetballen, honkbal trainen, voorbereiden op de Olympische Spelen, vervolggames maken, en het kammen van m\'n manlijke snor …", " Mario: ¡Mama mía! Si solamente no había estado ocupado jugando fútbol, practicando béisbol, preparándome para las Olimpiadas, haciendo continuaciones, y arreglando mi bigote varoni …", "Mario: Mama mia! Kiež by som nebol zaneprázdnený hraním futbalu, tréningom bejsbolu, prípravou na Olympiádu, prípravou výsledkov a česaním svojich mužných fúzov.", "マリオ：マンマミーア！サッカーと野球とオリンピックの練習、シリーズの製作、それにこの立派なヒゲの手入れで忙しかったからな・・・", "Mario: Mama mia! Wenn ich nur nicht so mit Fußballspielen, Baseball-Training, der Vorbereitung auf Olympia, dem Produzieren von neuen Spielen und mit dem Wachsen meines Schnurbartes beschäftigt gewesen wäre…"],
            cutscene0_7: ["Mario: I hope I\'m not too late … and that Miyamoto doesn\'t call with another game offer …", "Mario: Ik hoop dat ik niet te laat ben … en dat Miyamoto niet komt met een ander game-aanbod …", "Mario: Espero que no llegue demasiado atrasado… y que Miyamoto no me llame con otra oferta del jueg …", "Mario: Dúfam, že neprichádzam príliš neskoro…a že Miyamoto nevolá s inou ponukou hry…", "マリオ：間に合えばいいんだが・・・あのミヤモトが新しいゲームの話を持ってこないことを願おう", "Mario: Ich hoffe ich komme nicht zu spät…und das Miyamoto nicht schon wieder wegen einem neuen Spiel anruft…"],
            cutscene1_1: ["Mario: No! Those mustachioed chickens have beaten me once again. If only my brother were here to even the mustache odds.", "Mario: Nee! Die snor-kippen hebben me weer verslagen. Was m\'n broer maar hier om het verschil in snorren weer gelijk te maken.", "Mario: ¡No! Esos pollos con bigotes me han vencido otra vez. Si solamente mi hermano estaba aquí para balancear la cantidad de bigotes.", "Mario: Nie! Tie fúzaté kurčatá ma opäť nabili. Kiež by tu bol môj brat, aby sme vyrovnali skóre s fúzami.", "マリオ：何てことだ！また、あのヒゲのニワトリたちに負けちまった。弟がいれば、ヒゲだけでも対等になるのに", "Nein! Diese Schnurrbart-Hühner haben mich schon wieder besiegt. Wenn doch nur mein Bruder hier wäre, dann wäre es auch Schnurrbart-mäßig ausgeglichen."],
            cutscene1_2: ["Luigi: Don\'t stand up when you play with your Wii! Relax with a Wii-Sit from Luigi! No better plastic chair exists! … How about a plastic mustache to wear while you play?", "Luigi: Ga niet staan als met je Wii speelt! Relax met een Wii-zitje van Luigi! Er bestaat geen betere plastic stoel! … Wil je een plastic plaksnor op terwijl je speelt?", "Luigi: ¡No se levante cuando usted juega con su Wii! ¡Relájese con un Wii-Sentar de Luigi! ¡No existe ninguna mejor silla plástica!… ¿Cómo suena un bigote plástico usar mientras que usted juega?", "Luigi: Nestoj, keď hráš so svojím Wii! Relaxuj s Luigiho Wii-Sit! Neexistuje lepšia stolička z umelej hmoty!...A čo tak fúzy z umelej hmoty, kým hráš?", "ルイジ：立ったままじゃなく、座ってウィーが楽しめる！ルイジのウィー・シットでリラックス！最高のプラスチックのいすだよ！・・・ウィー用のプラスチック製のヒゲはいかが？", "Luigi: Steht nicht auf, wenn Ihr mit Eurer Wii spielt! Entspannt Euch auf einem Wii-Stuhl von Luigi! Es gibt keine besseren Plastikstühle als meine! Wie wär\'s mit einem Plastik-Schnurrbart, während Ihr spielt?"],
            cutscene1_3: ["Mario: Princess Pam is in trouble and needs our help!", "Mario: Prinses Pam is in gevaar en ze heeft onze hulp nodig!", " Mario: ¡Princesa Pam está en un apuro y necesita nuestra ayuda!", "Mario: Princezna Pam má problem a potrebuje našu pomoc!", "マリオ：パメラ姫が危ないんだ。助けに行こう！", "Mario: Prinzessin Pam steckt in Schwierigkeiten und braucht unsere Hilfe!"],
            cutscene1_4: ["Luigi: Let\'s ride!", "Luigi: Laten we gaan!", "Luigi: ¡Vayamos!", "Luigi, poďme!", "ルイジ: さあ車で出発しよう!", "Luigi: Auf geht\'s!"],
            cutscene2_1: ["Mario: A quick stop at the track never hurt anybody, right?", "Mario: Eventjes stoppen bij de racebaan kan toch geen kwaad?", "Mario: ¿Una parada rápida en la pista nunca lastimó nadie, verdad?", "Mario: Rýchla zastávka na pretekárskej dráhe neuškodí nikdy nikomu, však?", "マリオ：ちょっと寄ってもいいだろう？", "Mario: Ein kurzer Zwischenstopp auf der Rennbahn hat noch niemandem geschadet, oder?"],
            cutscene2_1B: ["Luigi: I wouldn\'t be so sure …", "Luigi: Daar zou ik maar niet zo zeker van zijn …", "Luigi: No estaré tan seguro…", "Luigi: Nie som si tým istý…", "ルイジ：いいのかな・・・", "Luigi: Da wäre ich mir nicht so sicher…"],
            cutscene2_2: ["Activist: It\'s that Yoshi-abuser, Mario! Did you know that \'retired\' Yoshis can end up in Japanese slaughterhouses, where they are hacked apart for human or Nintendog food?", "Activist: Dat is die Yoshi-mishandelaar, Mario! Weet je dat \'gepensioeneerde\' Yoshis in Japanse slachthuizen terecht kunnen komen, waar ze in stukken worden gehakt voor voedsel voor mensen of Nintendog?", "Activista: ¡Es el abusador de Yoshi, Mario! ¿Sabías que los Yoshis \'retirados\' pueden ser mandado a los mataderos japoneses, dónde se cortan en pedacitos para el alimento humano o de Nintendoperro?", "Aktivista: Mario, to je ten Yoshi-zneužívač! Vedel si, že Yoshiovia sa môžu ocitnúť v \'dôchodkovom veku\' v japonských jatkách, kde sú roztrhaní na kusy pre ľudskú alebo Nintendog potravu.", "活動家：ヨッシーを虐待するマリオだ！「引退」したヨッシーは日本の屠殺場に送られて、こま切れにされて、食べ物やニンテンドッグ・フードにされるんだ", "Activist: Da ist dieser Yoshi-Quäler, Mario! Wusstest Du, dass \'pensionierte\' Yoshis oft in japanischen Schlachthäusern enden, wo sie in Stücke gehackt werden, um als Nintendog Futter zu enden?"],
            cutscene2_3: ["Mario: Maybe Yoshis aren\'t for racing … and we do have a princess to save.", "Mario: Misschien zijn Yoshis niet om er mee te racen … en we hebben nog een prinses te redden.", "Mario: Tal vez Yoshis no son para hacer correr… y tenemos que salvar una princesa.", "Mario: Možno, že Yoshiovia nie sú na preteky…a my musíme zachrániť princeznu.", "マリオ：ほんとにヨッシーはレースに使っちゃいけないのかも・・・おれたちはパメラ姫を助けに行かなくちゃ！", "Vielleicht sind Yoshis doch nicht zum Reiten da… und wir haben eine Prinzessin zu retten! "],
            cutscene2_3B: ["Luigi: Let\'s get out of here!", "Luigi: Laten we maken dat we hier wegkomen!", "Luigi: ¡Vamos!", "Luigi: Poďme odtiaľ preč!", "ルイジ：早く行こう！", "Luigi: Auf geht\'s!"],
            cutscene2_4: ["Mario: Too late again!", "Mario: Al weer te laat!", "Mario: ¡Demasiado atrasado otra vez!", "Mario: Opäť je to príliš neskoro!", "マリオ：またしても遅かった！", "Mario: Schon wieder zu spät!"],
            cutscene3_1: ["Mario: We can never reach Pam in time. We\'re just too busy …", "Mario: We zijn nooit op tijd bij Pam. We zijn gewoon te druk …", "Mario: Nunca podemos alcanzar a Pam a tiempo. Somos demasiado ocupados…", "Mario: Nikdy sa nemôžeme spojiť s Pam načas. Sme jednoducho príliš zaneprázdnení…", "マリオ：おれたち、忙しすぎて、絶対パメラ姫に追い付けないよ。", "Mario: Wir werden Pam niemals rechtzeitig finden. Wir sind einfach zu beschäftig …."],
            cutscene3_1B: ["Luigi: I can think of one person who can always find a princess …", "Luigi: Ik kan  maar een persoon bedenken die altijd een prinses kan vinden …", "Luigi: Puedo pensar en una persona que pueda encontrar siempre a una princesa…", "Luigi: Poznám osobu, ktorá môže vždy nájsť princeznu…", "ルイジ：必ずお姫様を探し出せるやつが１人いるぞ", "Luigi: Mir fällt nur einer ein, der immer eine Prinzessin aufspüren kann…"],
            cutscene3_2: ["Mario: Hey, buddy, we need your help rescuing Princess Pamela.", "Mario: Hoi maatje, we hebben je hulp nodig om Prinses Pamela te bevrijden.", "Mario: Oye, amigo, necesitamos tu ayuda rescatar a Princesa Pamela.", "Mario: Hej, kámoško, potrebujeme Tvoju pomoc, aby sme zachránili princeznu Pamelu.", "マリオ：おい、相棒、パメラ姫救出を手伝ってくれ", "Mario: Hey Kumpel, wir brauchen Deine Hilfe um Prinzessin Pamela zu retten."],
            cutscene3_3: ["Bowser: BUDDY?!?! I\'m lightning in a bottle! I\'m an earthquake in a can! I\'m your WORST ENEMY! You\'ll quake in fear \'til your mustaches fall off!", "Bowser: MAATJE?!?! Ik ben de bliksem in een fles! Ik ben een aardbeving in een blik! Ik ben je GROOTSTE VIJAND! Jullie zullen sidderen van angst tot jullie snorren afvallen!", "Bowser: ¿AMIGO? ¡Soy relámpago en una botella! ¡Soy un terremoto en una lata! ¡Soy tu ENEMIGO PEOR! ¡Temblarán de miedo hasta que se caigan sus bigotes!", "Prehliadač: KÁMOŠKO?!?! Vo fľaši blýskam! Som zemetrasením v plechovke! Som Tvojím NAJHORŠÍM NEPRIATEĽOM! Ty sa budeš triasť od strachu tak, že Ti fúzy odpadnú!", "バウザー：相棒だと？！おれは奇跡を起こす稲妻だ！地震だ！おまえたちの最大の敵だ！おまえたちのヒゲが落ちるほど震え上がらせやる！", "Bowser: KUMPEL? Ich bin ein Blitz in einer Flasche! Ich bin ein Erdbeeben in einer Dose! Ich bin DEIN ERZFEIND! Ihr werdet solange vor Angst schreien, bis Eure Schnurrbärte abfallen!"],
            cutscene3_4: ["Mario: Come on, Koopster, you know if you were still scary I wouldn\'t invite you to all my parties. I\'m gonna have another one soon, by the way …", "Mario: Kom op Koopster, je weet dat als je nog steeds een engerd was ik je niet op al m\'n feestjes zou uitnodigen. Overigens geef ik er binnenkort weer een …", "Mario: Vaya, Koopster, sabes si fueras todavía espantoso yo no te invitaría a todas mis fiestas. Voy a tener otra pronto, a propósito…", "Mario: Poďme, Koopster, vieš, že keby si ešte stále vzbudzoval strach, tak by som Ťa nepozval na všetky moje večierky. Mimochodom, onedlho budem mať jeden…", "マリオ：まあまあ、クッパさん、落ち着いて。おまえが恐かったら、おれは毎回パーティーに招待なんかしないよ。そういえば、また近いうちにパーティーをするから・・・", "Mario: Komm schon, Koopster, Du weißt doch, dass ich Dich nicht zu all meinen Parties einladen würde, wenn Du so schrecklich wärst. Bald steigt übrigens meine nächste Party…"],
            cutscene3_5: ["Luigi: Already? You just had the last one!", "Luigi: Alweer? Je laatste was nog maar net!", "Luigi: ¿Tan pronto? ¡Recién tuviste la última!", "Luigi: Znovu? Veď len pred nedávnom si mal jeden!", "ルイジ：またかい？ついこの間やったばかりなのに。", "Luigi: Schon wieder? Du hast doch gerade eine gemacht!"],
            cutscene3_6: ["Bowser (to himself): When I saw \'Barb Wire\' on Netflix, I knew I had to have Pamela Anderson all to myself. Now\'s my chance. I\'ll show these plumbers who\'s scary! Mwa ha ha!", "Bowser (tegen zichzelf): Toen ik de film Barb Wire zag op Netflix wist ik dat ik Pamela Anderson helemaal voor mezelf moest hebben. Dit is m\'n kans. Ik zal deze loodgieters eens laten zien wie er een engerd is! Mwa ha ha!", "Bowser: Cuando vi el Barb Wire en Netflix, sabía que tuve que tener Pamela Anderson todo solamente para mí. Ahora es mi oportunidad. ¡Demostraré a estos fontaneros quien es espantoso!", "Prehliadač (sám sebe): Keď som videl \'Ostnatý drôt\' na Netflixe, vedel som, že musím mať Pamelu Andersonovú len pre seba. Teraz je tu moja šanca. Ukážem tým inštalatérom, kto tu naháňa strach! Mwa ha ha!", "バウザー（ひとり言）：ネットフリックスで「バーブ・ワイヤ」を見たときからパメラ・アンダーソンを独り占めにしたかったんだ。そのチャンスが来たぞ。この水道屋たちにおれ様の力を見せてやろうじゃないか。ムハハハ！ ", "Bowser (to himself): Als ich \'Barb Wire\' mit Pam damals im Internet geguckt habe, wollte ich sie danach ganz für mich allein haben. Jetzt ist meine Chance gekommen! Ich werde diesen Klemptern zeigen, wer hier wirklich der Schreckliche ist! Ha ha ha ha!"],
            cutscene4_1: ["Nugget: Where else would Ronald be keeping the princess …", "Goudhaantje: Waar anders zou Ronald de prinses kunnen vasthouden …", "Nugget: En que otro lugar guardaría Ronald la princesa…", "Nugget: Kde ešte by mohol Ronald držať princeznu…", "ナゲット：ロナルドはパメラ姫をどこに隠したんだろう・・・", "Nugget: Wo könnte Ronald die Prinzessin noch gefangen halten?"],
            cutscene4_2: ["Both: In his Playland!", "Beide: In zijn Playland!", "Ambos: ¡En su patio de recreo!", "Obaja: V jeho Krajine Hry!", "２人同時に：プレイランドだ！", "In seinem Playland!"],
            cutscene4_3: ["Chickette: We must hurry before she ends up in an unhappy meal!", "Kippie: We moeten opschieten voordat ze in een unhappy meal terecht komt!", "Chickette: ¡Tenemos que apresurarnos antes de que se transformara en una cajita infeliz!", "Chickette: Musíme sa ponáhľať prv než sa ocitne v unhappy meal!", "チッケット：パメラ姫がアンハッピー・ミールになっちゃう前に助けなくちゃ！", "Chickette: Wir müssen uns beeilen, ansonsten endet sie in einem Unhappy Meal!"],
            cutscene5_1: ["Mario: Those other superhero siblings have rescued the Princess again …", "Mario: Die andere superheldhaftige broertjes en zusjes hebben de prinses weer gered  …", "Mario: Esos otros hermanos superhéroes han rescatado a la princesa otra vez…", "Mario: Tí ostatní súrodenci-superhrdinovia znovu zachránili princeznu…", "マリオ：また、あっちのスーパーヒーローきょうだいに先を越された", "Mario: Diese anderen beiden Superhelden-Zwillinge haben mal wieder die Prinzessin gerettet."],
            cutscene5_1B: ["Bowser: Fungah! Foiled again!", "Bowser: Fungah! Weer verslagen!", "Bowser: ¡Funga! ¡Frustrado otra vez!", "Prehliadač: Fungah! Znovu je to zneškodnené!", "バウザー：フンガー！まただめだったか！", "Bowser: Verdammt! Was für \'ne Pleite!"],
            cutscene5_2: ["Phone: Ring, ring, ring", "Telefoon: Tring, tring, tring", "Teléfono: Ring, ring, ring", "Telefón: zvonenie, zvonenie, zvonenie", "電話：リーン、リーン、リーン", "Phone: Ring, Ring, Ring"],
            cutscene5_3: ["Mario: Another offer just came in … a surefire hit: \'New Mario Teaches Typing\'.", "Mario: Er kwam net een andere game-aanbieding binnen … een gegarandeerde hit: \'New Mario Teaches Typing\'.", "Mario: Otra oferta acaba de llegar… un éxito seguro: \'Nuevo Mario enseña teclear\'.", "Mario: Ďalšia ponuka prišla…stopercentný hit: Nový Mario učí písanie na stroji.", "マリオ：また新しい話が来た。「新・タイプの先生マリオ」だって。ヒット確実だ。 ", "Mario: Gerade kam ein neues Angebot herein, das wird definitiv ein Bestseller: \'Mario bringt euch das Tippen bei\'."],
            cutscene5_4: ["Bowser: What people really want is \'Luigi Paint\'!", "Bowser: Wat de mensen echt willen is de game \'Luigi Paint\'!", "Bowser: ¡Lo que le gente realmente quiere es \'Luigi dibuja\'!", "Prehliadač: Čo ľudia naozaj chcú, to je Luigiho Farba!", "バウザー：ほんとにヒットするのは「ルイジ・ペイント」だ！", "Bowser: Was die Kids wirklich wollen ist doch \'Luigi Paint\'!"],
            cutscene5_5: ["Luigi: Yeah, nobody wants more Mario shovelware!", "Luigi: Ja, niemand wil meer ouwe meuk van Mario!", "Luigi: ¡De acuerdo, nadie quiere más \'shovelware\' de Mario!", "Luigi: Mhm, nikto už viac nechce Mariove lopaty!", "ルイジ：そうだ、もうみんなマリオのシャベルウェアには飽き飽きしているよ", "Luigi: Ja genau, keiner will mehr diese Mario-Ramschware"],
            cutscene5_6: ["You have rescued me again and saved millions of chickens from the worst abuses at the hands of McDonald\'s.", "Je hebt me weer bevrijd en miljoenen kippen gered van de ergste mishandelingen uit de handen van McDonald\'s.", "Me han salvado otra vez y salvado millones de pollos de los abusos horribles en las manos de McDonald\'s. ", "Ty si znovu zachránil nielen mňa, ale aj milióny kurčiat, a to pred najhorším týraním McDonaldovými rukami.", "また私を助けてくれてありがとう。そしてマクドナルドのひどい虐待から、何百万羽ものニワトリを助けてくれてありがとう", "Ihr habt mich einmal mehr gerettet und Millionen von Hühnern vor den schlimmsten Misshandlungen durch McDonald’s USA bewahrt."],
            cutscene5_7: ["To play again as me, enter this secret code: PamvsMcCruelty.", "Om weer te kunnen spelen verander de code in: PamVsMcCruelty.", "Para jugar otra vez como yo, entra este código secreto: PamVsMcCruelty.", "Ak chceš hrať v mojom mene, vlož tento tajný kód: PamVsMcCruelty.", "もう１度「私」としてプレーするには、次のシークレット・コードを入力してください：PamVsMcCruelty. ", "Um nochmal zu spielen, gib diesen Geheim-Code ein: PamvsMcCruelty."],
            vid1: ["You\'ve earned a bonus video!", "Je hebt een bonusvideo verdiend!", "¡Has ganado un vídeo adicional!", "Získal si prémiové video.", "ボーナス･ビデオの時間です！", "Du hast Dir ein Bonus-Video verdient!"],
            vid2: ["Game Will Continue In …", "Het spel gaat verder ,,,", "Juego continuará en…", "Hra bude pokračovať o…", "ゲーム継続まで・・・", "Spiel wird fortgesetzt in …"],
            vid3: ["Continue Game", "Speel  door ", "Continuar juego", "Pokračuj v hre", "ゲーム継続", "Spiel fortsetzen"]
        };
        Gameplay.characters = ['nugget', 'chickette', 'pam'];
        Gameplay.gravity0 = 1285; // 1 - 10
        gameplay.Gameplay = Gameplay;
    })(gameplay = nscs.gameplay || (nscs.gameplay = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var input;
    (function (input) {
        class InputController {
            constructor(scene) {
                this.scene = scene;
                this.cursorKeys = this.scene.input.keyboard.createCursorKeys();
                this.cursorKeys.down.on('up', () => { this.cursorKeys.down['-used-'] = false; });
                this.cursorKeys.down['-used-'] = false;
                this.scene.input.keyboard.addCapture([Phaser.Input.Keyboard.KeyCodes.LEFT, Phaser.Input.Keyboard.KeyCodes.RIGHT]);
                this.spaceObj = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE); // Get key object
                this.spaceObj.on('up', () => { this.spaceObj['-used-'] = false; });
                this.spaceObj['-used-'] = false;
                this.escObj = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ESC); // Get key object
                this.escObj.on('up', () => { this.escObj['-used-'] = false; });
                this.escObj['-used-'] = false;
                this.enterObj = scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ENTER); // Get key object
                this.enterObj.on('up', () => { this.enterObj['-used-'] = false; });
                this.enterObj['-used-'] = false;
            }
            spacePressedDownAndReleased() {
                return this.spaceObj.isDown && !this.spaceObj['-used-'];
            }
            spacePressUsed() {
                this.spaceObj['-used-'] = true;
            }
            keyDownPressedDownAndReleased() {
                return this.cursorKeys.down.isDown && !this.cursorKeys.down['-used-'];
            }
            keyDownPressUsed() {
                this.cursorKeys.down['-used-'] = true;
            }
            escPressedDownAndReleased() {
                return this.escObj.isDown && !this.escObj['-used-'];
            }
            escPressUsed() {
                this.escObj['-used-'] = true;
            }
            enterPressedDownAndReleased() {
                return this.enterObj.isDown && !this.enterObj['-used-'];
            }
            enterPressUsed() {
                this.enterObj['-used-'] = true;
            }
        }
        input.InputController = InputController;
    })(input = nscs.input || (nscs.input = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var input;
    (function (input) {
        class InputManager {
            constructor() {
                this.buttons = [];
                this.keyUpUsed = false;
                this.keyDownUsed = false;
                this.isDowButton = {
                    'UP': false,
                    'DOWN': false,
                    'LEFT': false,
                    'RIGHT': false
                };
            }
            static get instance() {
                return this._instance ? InputManager._instance : InputManager._instance = new InputManager();
            }
            isDown(key) {
                return this.isDowButton[key];
            }
            create(scene) {
                if (!game.device.input.touch)
                    return;
                this.scene = scene;
                this.createJoystick(38, 245);
            }
            destroy() {
                if (!game.device.input.touch)
                    return;
                for (let c of this.buttons) {
                    this.scene.children.remove(c);
                }
            }
            createJoystick(x, y) {
                const UP = 'UP', RIGHT = 'RIGHT', DOWN = 'DOWN', LEFT = 'LEFT';
                this.JOYSTICK_UP_ = new Phaser.GameObjects.Image(this.scene, 405, 0, 'arrow');
                this.JOYSTICK_UP_.angle = -90;
                this.JOYSTICK_DOWN_ = new Phaser.GameObjects.Image(this.scene, 330, 0, 'arrow');
                this.JOYSTICK_DOWN_.angle = 90;
                this.JOYSTICK_RIGHT_ = new Phaser.GameObjects.Image(this.scene, 75, 0, 'arrow');
                this.JOYSTICK_RIGHT_.angle = 0;
                this.JOYSTICK_LEFT_ = new Phaser.GameObjects.Image(this.scene, 0, 0, 'arrow');
                this.JOYSTICK_LEFT_.angle = 180;
                this.buttons = [this.JOYSTICK_UP_, this.JOYSTICK_DOWN_, this.JOYSTICK_RIGHT_, this.JOYSTICK_LEFT_];
                for (let c of this.buttons) {
                    this.scene.children.add(c);
                    c.setOrigin(0.5, 0.5);
                    c.setScale(0.7, 0.7);
                    c.alpha = 0.3;
                    c.x += x;
                    c.y += y;
                    c.setScrollFactor(0);
                    c.setInteractive();
                }
                this.JOYSTICK_UP_.on('pointerdown', () => { this.isDowButton[UP] = true; }, this);
                this.JOYSTICK_UP_.on('pointerover', () => { this.isDowButton[UP] = true; }, this);
                this.JOYSTICK_UP_.on('pointerup', () => { this.isDowButton[UP] = false; }, this);
                this.JOYSTICK_UP_.on('pointerout', () => { this.isDowButton[UP] = false; }, this);
                this.JOYSTICK_DOWN_.on('pointerdown', () => { this.isDowButton[DOWN] = true; }, this);
                this.JOYSTICK_DOWN_.on('pointerover', () => { this.isDowButton[DOWN] = true; }, this);
                this.JOYSTICK_DOWN_.on('pointerup', () => { this.isDowButton[DOWN] = false; }, this);
                this.JOYSTICK_DOWN_.on('pointerout', () => { this.isDowButton[DOWN] = false; }, this);
                this.JOYSTICK_RIGHT_.on('pointerdown', () => { this.isDowButton[RIGHT] = true; }, this);
                this.JOYSTICK_RIGHT_.on('pointerover', () => { this.isDowButton[RIGHT] = true; }, this);
                this.JOYSTICK_RIGHT_.on('pointerup', () => { this.isDowButton[RIGHT] = false; }, this);
                this.JOYSTICK_RIGHT_.on('pointerout', () => { this.isDowButton[RIGHT] = false; }, this);
                this.JOYSTICK_LEFT_.on('pointerdown', () => { this.isDowButton[LEFT] = true; }, this);
                this.JOYSTICK_LEFT_.on('pointerover', () => { this.isDowButton[LEFT] = true; }, this);
                this.JOYSTICK_LEFT_.on('pointerup', () => { this.isDowButton[LEFT] = false; }, this);
                this.JOYSTICK_LEFT_.on('pointerout', () => { this.isDowButton[LEFT] = false; }, this);
                this.keyUpUsed = false;
                this.JOYSTICK_UP_.on('pointerup', () => { this.keyUpUsed = false; }, this);
                this.JOYSTICK_UP_.on('pointerout', () => { this.keyUpUsed = false; }, this);
                this.keyDownUsed = false;
                this.JOYSTICK_DOWN_.on('pointerup', () => { this.keyDownUsed = false; }, this);
                this.JOYSTICK_DOWN_.on('pointerout', () => { this.keyDownUsed = false; }, this);
            }
            upPressedDownAndReleased() {
                if (!game.device.input.touch)
                    return false;
                return this.isDown('UP') && !this.keyUpUsed;
            }
            upPressUsed() {
                if (!game.device.input.touch)
                    return;
                this.keyUpUsed = true;
            }
            downPressedDownAndReleased() {
                if (!game.device.input.touch)
                    return false;
                return this.isDown('DOWN') && !this.keyDownUsed;
            }
            downPressUsed() {
                if (!game.device.input.touch)
                    return;
                this.keyDownUsed = true;
            }
        }
        InputManager._instance = null;
        input.InputManager = InputManager;
    })(input = nscs.input || (nscs.input = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var input;
    (function (input) {
        class InputTextField extends Phaser.GameObjects.Container {
            constructor(scene) {
                super(scene);
                this.pokemonNameDiv = null;
                this.inputTextField = null;
                this.inputTextFieldWidth = 160;
                this.inputTextFieldHeight = 30;
                this.inputTextFieldFontSize = 13;
                this.inputTextFieldPosition = { x: 0, y: 0 };
                this.adjustInput = () => {
                    let globalPos = toGlobal(this, this.inputTextFieldPosition);
                    const px = 'px';
                    let pr = 1; //this.scene.game.device.os.desktop ? 1 : Math.min(this.scene.game.device.os.pixelRatio, 3);
                    this.inputTextField.style.width = Math.ceil(this.inputTextFieldWidth / pr / this.scene.game.scale.displayScale.x) + px;
                    this.inputTextField.style.height = this.inputTextFieldHeight + px;
                    this.inputTextField.style.fontSize = this.inputTextFieldFontSize / this.scene.game.scale.displayScale.y + px;
                    let mt = parseInt(this.scene.game.canvas.style.marginTop.split(px)[0]);
                    let ml = parseInt(game.canvas.style.marginLeft.split(px)[0]);
                    this.pokemonNameDiv.style.marginTop = (mt + Math.ceil(globalPos.y / pr / this.scene.game.scale.displayScale.y) - this.inputTextFieldHeight / 2) + px;
                    this.pokemonNameDiv.style.marginLeft = (ml + Math.ceil(globalPos.x / pr / this.scene.game.scale.displayScale.x)) + px;
                };
                this.pokemonNameDiv = document.querySelector('#pamNameDiv');
                this.inputTextField = document.querySelector('#pamInputId');
            }
            initializeInput() {
                this.setInputTextFieldContainerVisible(true);
                this.adjustInput();
                this.scene.game.scale.addListener(Phaser.Scale.Events.RESIZE, this.adjustInput);
            }
            destroyInput() {
                this.setInputTextFieldContainerVisible(false);
                this.scene.game.scale.removeListener(Phaser.Scale.Events.RESIZE, this.adjustInput);
            }
            setInputTextFieldContainerVisible(visible) {
                document.querySelector('.inputContainer').style.display = visible ? 'block' : 'none';
                if (visible) {
                    this.inputTextField.focus();
                }
            }
            getText() {
                return this.inputTextField.value;
            }
            setText(text) {
                this.inputTextField.value = text;
            }
        }
        input.InputTextField = InputTextField;
    })(input = nscs.input || (nscs.input = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var scene;
    (function (scene) {
        class Boot extends Phaser.Scene {
            init() {
                new FitScaleManager(this.game).setup();
            }
            create() {
                this.input.addPointer(1);
                game.scene.remove('Boot');
                game.scene.add('Preloader', nscs.scene.Preloader, true);
            }
        }
        scene.Boot = Boot;
    })(scene = nscs.scene || (nscs.scene = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var scene;
    (function (scene) {
        class MainScene extends Phaser.Scene {
            constructor() {
                super(...arguments);
                this.subWorld = null;
                this.worldNumber = 1;
            }
            create() {
                MainScene.instance = this;
                this.inputController = new nscs.input.InputController(this);
                this.factory = new nscs.gameplay.Factory(this);
                this.currentScreensContainer = new Phaser.GameObjects.Container(this, 0, 0);
                this.children.add(this.currentScreensContainer);
                this.logo_btn = new Phaser.GameObjects.Image(this, 0, 290, 'ui-atlas', 'logo_btn' + '0000').setOrigin(0, 0);
                this.logo_btn.setInteractive({ cursor: 'pointer' });
                this.logo_btn.on('pointerup', () => {
                    window.open("http://www.mccruelty.com", '_blank');
                    this.logo_btn.setFrame('logo_btn' + '0000');
                    sendEvent(petaGA_GameCategory_Game, 'Click', 'New Super Chick Sisters - McCruelty Link Click');
                });
                this.logo_btn.on('pointerout', () => {
                    this.logo_btn.setFrame('logo_btn' + '0000');
                });
                this.logo_btn.on('pointerover', () => {
                    this.logo_btn.setFrame('logo_btn' + '0001');
                });
                this.soundControl_mc = new Phaser.GameObjects.Image(this, 464, 306, 'ui-atlas', 'soundControl_mc' + '0000');
                this.soundControl_mc.setInteractive({ cursor: 'pointer' });
                this.soundControl_mc.on('pointerup', () => {
                    nscs.sound.SoundManager.getInstance().mute();
                    this.soundControl_mc.setFrame(nscs.sound.SoundManager.getInstance().muted ? 'soundControl_mc' + '0009' : 'soundControl_mc' + '0000');
                    if (nscs.sound.SoundManager.getInstance().muted) {
                        sendEvent(petaGA_GameCategory_Game, 'Audio Off', 'New Super Chick Sisters - Audio Off');
                    }
                    else {
                        sendEvent(petaGA_GameCategory_Game, 'Audio On', 'New Super Chick Sisters - Audio On');
                    }
                });
                this.switchScreen(new nscs.screen.SelectLanguageScreen(this));
                this.children.add(this.soundControl_mc);
                this.children.add(this.logo_btn);
                this.updateLogoAndSndBtnVisibility();
                this.logo_btn.setScrollFactor(0);
                this.soundControl_mc.setScrollFactor(0);
                //worlds direct testing
                // this.gameplay = new nscs.gameplay.Gameplay();
                // this.startLevel('1');
            }
            resetGameplay() {
                if (this.gameplay) {
                    this.gameplay.destroy();
                }
                this.setWorldsNumber(1);
                this.gameplay = new nscs.gameplay.Gameplay();
            }
            playAsPam() {
                this.resetGameplay();
                this.gameplay.character = 'pam';
                this.startGame();
            }
            setWorldsNumber(worldNumber, subWorld = null) {
                this.worldNumber = worldNumber;
                this.subWorld = subWorld;
            }
            getWorldNumber() {
                return this.worldNumber;
            }
            playGame() {
                this.showStorySlides(() => {
                    this.startGame();
                });
            }
            startLevel(worldId) {
                this.setWorldsNumber(Math.floor(Number(worldId)));
                this.gameplay.loadWorld(worldId, true, true);
                this.gameplay.gameScreen.showNewGameNewWorldScreen();
                nscs.sound.SoundManager.getInstance().playMusic('soundtrack' + this.worldNumber, true);
            }
            startGame() {
                this.startLevel(this.subWorld != null ? this.subWorld : String(this.worldNumber));
            }
            showStorySlides(onComplete) {
                this.gameplay.destroyPreviousWorlds();
                this.switchScreen(new nscs.screen.StorySlides(this, this.worldNumber, () => {
                    if (this.worldNumber == 3) {
                        this.switchScreen(new nscs.screen.BonusVideoScreen(this, onComplete));
                    }
                    else {
                        onComplete();
                    }
                }), false, true);
            }
            proceedLevelComplete() {
                sendEvent(petaGA_GameCategory_Game, 'Win', 'New Super Chick Sisters - Win World ' + this.worldNumber);
                this.setWorldsNumber(this.gameplay.getNextWorldNumber());
                if (this.worldNumber == 6) {
                    // END OF GAME
                    this.showStorySlides(() => {
                        this.switchScreen(new nscs.screen.MainMenuScreen(this) /*new nscs.screen.HigscoreScreen(this)*/);
                    });
                }
                else {
                    this.playGame();
                }
            }
            update() {
                let screens = this.currentScreensContainer.getAll();
                for (let c of screens) {
                    if (c instanceof nscs.screen.BaseScreen && this.currentScreen != c)
                        c.updateScreen();
                }
                this.currentScreen.updateScreen();
            }
            updateLogoAndSndBtnVisibility() {
                this.logo_btn.visible = (this.currentScreen instanceof nscs.screen.MainMenuScreen
                    ||
                        this.currentScreen instanceof nscs.screen.InGameUI
                    ||
                        this.currentScreen instanceof nscs.screen.GameScreen);
                this.logo_btn.alpha = this.currentScreen instanceof nscs.screen.GameScreen ? 0.6 : 1;
                this.soundControl_mc.visible = !(this.currentScreen instanceof nscs.screen.SelectLanguageScreen);
            }
            switchScreen(newScreen, useTransition = false, destroyOld = true, onMidCallback = null) {
                if (this.currentScreen) {
                    let prevScreen = this.currentScreen;
                    this.currentScreen = newScreen;
                    prevScreen.switchScreen(newScreen, useTransition, destroyOld, () => {
                        if (onMidCallback)
                            onMidCallback();
                        this.updateLogoAndSndBtnVisibility();
                    });
                }
                else {
                    this.currentScreensContainer.add(newScreen);
                    this.currentScreen = newScreen;
                    this.updateLogoAndSndBtnVisibility();
                }
            }
        }
        MainScene.instance = null;
        scene.MainScene = MainScene;
    })(scene = nscs.scene || (nscs.scene = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var scene;
    (function (scene) {
        class Preloader extends Phaser.Scene {
            preload() {
                this.load.atlas(nscs.screen.Preloader.ATLAS, 'assets/imgs/atlas/' + nscs.screen.Preloader.ATLAS + '.png', 'assets/imgs/atlas/' + nscs.screen.Preloader.ATLAS + '.json');
            }
            create() {
                let p = new nscs.screen.Preloader(this);
                this.children.add(p);
                this.load.json('data', 'assets/json/data.json');
                this.load.pack('preloader', 'assets/pack.json');
                this.load.on('progress', (value) => {
                    p.updateProgress(value);
                }, this);
                this.load.on('complete', () => {
                    sendEvent(petaGA_GameCategory_Game, 'Load', 'New Super Chick Sisters - Load');
                    this.nextScene();
                });
                this.load.start();
            }
            nextScene() {
                game.scene.remove('Preloader');
                game.scene.add('MainScene', nscs.scene.MainScene, true);
            }
        }
        scene.Preloader = Preloader;
    })(scene = nscs.scene || (nscs.scene = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class BaseScreen extends Phaser.GameObjects.Container {
            constructor(scene) {
                super(scene);
                if (!(this instanceof screen.GameScreen))
                    this.setScrollFactor(0);
            }
            createBlackShape() {
                return this.createShape('0x000000');
            }
            createShape(color) {
                let transition = new Phaser.GameObjects.Graphics(this.scene);
                transition.setPosition(0, 0);
                transition.fillStyle(color, 1);
                transition.fillRect(0, 0, game.scale.width, game.scale.height);
                transition.setInteractive();
                transition.setScrollFactor(0);
                return transition;
            }
            switchScreen(newScreen, useTransition, destroyOld, onMidCallback) {
                let f = () => {
                    // if (!destroyOld) {
                    if (this instanceof screen.GameScreen) {
                        this.onRemovedFromParent();
                    }
                    // }
                    if (newScreen instanceof screen.GameScreen) {
                        newScreen.onAddedToParent();
                    }
                };
                let parentContainer = this.parentContainer;
                if (useTransition) {
                    if (destroyOld) {
                        this.scene.tweens.killAll();
                        nscs.util.Functions.destroyAllDelayedCalls();
                        // this.scene.time.removeAllEvents();
                    }
                    let transition = this.createBlackShape();
                    this.parentContainer.add(transition);
                    transition.alpha = 0;
                    this.scene.tweens.add({
                        targets: transition,
                        alpha: 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Linear,
                        onComplete: () => {
                            this.scene.tweens.add({
                                targets: transition,
                                alpha: 0,
                                duration: 500,
                                ease: Phaser.Math.Easing.Linear,
                                onComplete: () => {
                                    parentContainer.remove(transition, true);
                                }
                            });
                            f();
                            parentContainer.remove(this, destroyOld);
                            parentContainer.addAt(newScreen, parentContainer.getIndex(transition));
                            if (onMidCallback)
                                onMidCallback();
                        }
                    });
                }
                else {
                    f();
                    parentContainer.remove(this, destroyOld);
                    parentContainer.add(newScreen);
                    if (onMidCallback)
                        onMidCallback();
                }
            }
            updateScreen() {
            }
        }
        screen.BaseScreen = BaseScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class BonusVideoScreen extends screen.BaseScreen {
            constructor(scene, onContinue) {
                super(scene);
                this.isVideoPreloaded = false;
                this.isVideoAllowedToShow = false;
                this.wait_ico = null;
                this.bonusVideoBG = null;
                this.bonusVideoFG = null;
                this.onContinue = onContinue;
                this.bonusVideoBG = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 0.5, game.scale.height / 2 - 0.5, 'stories', 'bonusVideoBG' + '0000');
                this.bonusVideoBG.setOrigin(0.5, 0.5);
                this.add(this.bonusVideoBG);
                this.bonusVideoFG = new Phaser.GameObjects.Image(this.scene, -1, 0, 'stories', 'bonusVideoFG' + '0000');
                this.bonusVideoFG.setOrigin(0, 0);
                this.add(this.bonusVideoFG);
                let MCdonaldsIcon = new Phaser.GameObjects.Image(this.scene, 150, 152, 'stories', 'MCdonaldsIcon' + '0000');
                this.add(MCdonaldsIcon);
                MCdonaldsIcon.y = 500;
                MCdonaldsIcon.scaleY = 0.9;
                this.scene.tweens.add({
                    targets: MCdonaldsIcon,
                    y: 152,
                    scaleY: 1,
                    duration: 350
                });
                let youerned_label = this.scene.add.text(game.scale.width / 2 + 90, 170, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 28,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                youerned_label.setWordWrapWidth(150);
                youerned_label.setShadow(2, 4, '#666666', 4);
                youerned_label.setOrigin(0.5, 0.5);
                this.add(youerned_label);
                nscs.gameplay.Gameplay.setText(youerned_label, 'vid1', false);
                youerned_label.y = -200;
                youerned_label.scaleY = 0.9;
                this.scene.tweens.add({
                    targets: youerned_label,
                    y: 170,
                    scaleY: 1,
                    duration: 350
                });
                this.gamewillcontinue_label = this.scene.add.text(game.scale.width / 2, 300, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 20,
                    "color": "#000000",
                    "align": 'center'
                });
                this.gamewillcontinue_label.setOrigin(0.5, 0.5);
                this.add(this.gamewillcontinue_label);
                if (game.cache.video.has("McCruelt_I_am_Hating_It")) {
                    this.isVideoPreloaded = true;
                }
                else {
                    this.isVideoPreloaded = false;
                    this.scene.load.video('McCruelt_I_am_Hating_It', 'assets/video/McCruelt_I_am_Hating_It.mp4', 'loadeddata', false, false);
                    this.scene.load.once('complete', () => {
                        this.isVideoPreloaded = true;
                        this.tryToShowVideo();
                    });
                    this.scene.load.start();
                }
                nscs.util.Functions.delayedCall(3000, () => {
                    this.scene.tweens.add({
                        targets: MCdonaldsIcon,
                        y: 500,
                        scaleY: 0.9,
                        duration: 950,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.scene.tweens.add({
                        targets: youerned_label,
                        x: 600,
                        angle: -90,
                        scaleY: 0.9,
                        duration: 950,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    nscs.util.Functions.delayedCall(1000, () => {
                        this.wait_ico = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'stories', 'wait_ico' + '0000');
                        this.add(this.wait_ico);
                        this.scene.tweens.add({
                            targets: this.wait_ico,
                            angle: 360,
                            duration: 3000,
                            ease: Phaser.Math.Easing.Linear,
                            repeat: -1
                        });
                        this.isVideoAllowedToShow = true;
                        let repeat = 30;
                        let timerEvent = this.scene.time.addEvent({ delay: 1000, repeat: repeat });
                        timerEvent.callback = () => {
                            this.onTick(timerEvent.repeatCount);
                            if (timerEvent.repeatCount == 0) {
                                this.scene.tweens.killTweensOf(this.wait_ico);
                                this.remove(this.wait_ico);
                                this.remove(this.gamewillcontinue_label);
                                let btnContinue = new Phaser.GameObjects.Container(this.scene, game.scale.width / 2, 290);
                                this.add(btnContinue);
                                let btnContinueGame = new Phaser.GameObjects.Image(this.scene, 0, 0, 'stories', 'btnContinueGame' + '0000');
                                btnContinue.add(btnContinueGame);
                                btnContinueGame.setInteractive({ cursor: 'pointer' });
                                btnContinueGame.once('pointerup', () => {
                                    if (this.onContinue) {
                                        this.onContinue();
                                        this.onContinue = null;
                                        nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                                    }
                                });
                                let continue_label = this.scene.add.text(0, -3, "", {
                                    "fontFamily": "Helvetica Rounded LT Black",
                                    "fontSize": 20,
                                    "color": "#FFFFFF",
                                    "align": 'center'
                                });
                                continue_label.setOrigin(0.5, 0.5);
                                btnContinue.add(continue_label);
                                nscs.gameplay.Gameplay.setText(continue_label, 'vid3');
                                btnContinue.scale = 0.25;
                                this.scene.tweens.add({
                                    targets: btnContinue,
                                    scale: 1,
                                    duration: 500,
                                    ease: Phaser.Math.Easing.Back.Out
                                });
                            }
                        };
                    });
                });
            }
            tryToShowVideo() {
                if (this.isVideoPreloaded && this.isVideoAllowedToShow) {
                    this.showVideo();
                    this.isVideoAllowedToShow = false;
                }
            }
            showVideo() {
                this.video = this.scene.add.video(game.scale.width / 2, game.scale.height / 2, 'McCruelt_I_am_Hating_It');
                this.video.setOrigin(0.5, 0.5);
                this.video.setInteractive( /*{ cursor: 'pointer' }*/);
                this.addAt(this.video, this.getIndex(this.bonusVideoBG) + 1);
                this.add(this.video);
                this.video.play(false);
            }
            onTick(sec) {
                this.tryToShowVideo();
                if (this.video) {
                    this.wait_ico.visible = false;
                    if (this.video.isPaused()) {
                        this.video.setPaused(false);
                    }
                    if (this.video.isMuted() != nscs.sound.SoundManager.getInstance().muted) {
                        this.video.setMute(nscs.sound.SoundManager.getInstance().muted);
                    }
                }
                else {
                    this.wait_ico.visible = true;
                }
                nscs.gameplay.Gameplay.setText(this.gamewillcontinue_label, 'vid2');
                nscs.util.Functions.updateTextFieldPosition(this.gamewillcontinue_label, this.gamewillcontinue_label.text + " " + sec);
            }
        }
        screen.BonusVideoScreen = BonusVideoScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class ChooseCharacterScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                let bg = new Phaser.GameObjects.Graphics(this.scene);
                bg.setPosition(0, 0);
                bg.fillStyle(0x36ACBE, 1);
                bg.fillRect(0, 0, game.scale.width, game.scale.height);
                this.add(bg);
                this.add(new Phaser.GameObjects.Image(this.scene, 54 - 10, 91 - 15, 'ui-atlas', 'circ' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, 175 - 10, 129 - 15, 'ui-atlas', 'circ' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, 299 - 10, 91 - 15, 'ui-atlas', 'circ' + '0000').setOrigin(0, 0));
                let positions = [
                    { x: 54 - 3, y: 91 - 15 }, { x: 175 - 3, y: 129 - 15 }, { x: 299 - 3, y: 91 - 15 }
                ];
                let i = 0;
                for (let p of positions) {
                    let btn = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'ui-atlas', 'nugget_btn' + '0000').setOrigin(0, 0);
                    this.add(btn);
                    let character = nscs.gameplay.Gameplay.characters[i];
                    i++;
                    btn.setInteractive({ cursor: 'pointer' });
                    btn.on('pointerup', () => {
                        if (nscs.gameplay.Gameplay.isPamLocked && character == "pam")
                            return;
                        btn.setFrame('nugget_btn' + '0000');
                        // nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                        nscs.scene.MainScene.instance.gameplay.character = character;
                        nscs.scene.MainScene.instance.playGame();
                        if (character == 'nugget') {
                            sendEvent(petaGA_GameCategory_Game, 'Character Selection', 'New Super Chick Sisters - Character Nugget');
                        }
                        else if (character == 'chickette') {
                            sendEvent(petaGA_GameCategory_Game, 'Character Selection', 'New Super Chick Sisters - Character Chickette');
                        }
                    });
                    btn.on('pointerover', () => {
                        nscs.sound.SoundManager.getInstance().playSound('whistleSND', 2);
                        btn.setFrame('nugget_btn' + '0001');
                    });
                    btn.on('pointerout', () => {
                        btn.setFrame('nugget_btn' + '0000');
                    });
                }
                this.add(new Phaser.GameObjects.Image(this.scene, 54 - 10 + 75, 91 - 15 + 55, 'ui-atlas', 'ANI_Nugget_wholeMC' + '0000').setOrigin(0.5, 0.5).setScale(-1, 1));
                this.add(new Phaser.GameObjects.Image(this.scene, 175 - 10 + 80, 129 - 15 + 35, 'ui-atlas', 'ANI_Chickette_wholeMC' + '0000').setOrigin(0.5, 0.5).setScale(-1, 1));
                this.add(new Phaser.GameObjects.Image(this.scene, 175 + 200, 129 - 25, 'ui-atlas', 'pam_sel' + '0000').setOrigin(0.5, 0.5).setScale(-1, 1));
                this.locked_image = new Phaser.GameObjects.Image(this.scene, 165 + 200, 150, 'ui-atlas', 'pamlocked_btn' + '0000').setOrigin(0.5, 0.5);
                this.add(this.locked_image);
                this.locked_label = this.scene.add.text(162 + 200, 160, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 24,
                    "color": "#006699",
                    "align": 'left'
                });
                this.locked_label.angle = -15;
                this.locked_label.setOrigin(0.5, 0.5);
                this.add(this.locked_label);
                nscs.gameplay.Gameplay.setText(this.locked_label, 'Locked');
                this.add(screen.MainMenuScreen.createEye(120, 120, this.scene));
                this.add(screen.MainMenuScreen.createEye(150, 117, this.scene));
                this.add(screen.MainMenuScreen.createEye(240, 133, this.scene, 2000));
                this.add(screen.MainMenuScreen.createEye(270, 130, this.scene, 2000));
                let pam_mc_eye = scene.add.sprite(358, 80, 'ui-atlas');
                let pam_mc_eye_anim = 'pam_mc_eye_anim';
                if (!scene.anims.exists(pam_mc_eye_anim)) {
                    scene.anims.create({
                        key: pam_mc_eye_anim,
                        frames: scene.anims.generateFrameNames('ui-atlas', {
                            start: 0, end: 337, zeroPad: 4,
                            prefix: 'pam_mc_eye', suffix: ''
                        }),
                        frameRate: 60,
                        repeat: -1
                    });
                }
                pam_mc_eye.play(pam_mc_eye_anim);
                pam_mc_eye.setScale(-1, 1);
                this.add(pam_mc_eye);
                let character0_label = this.scene.add.text(54 - 10 + 65, 91 - 15 + 170, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 14,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                character0_label.setOrigin(0.5, 0.5);
                this.add(character0_label);
                nscs.gameplay.Gameplay.setText(character0_label, 'Nugget');
                let character1_label = this.scene.add.text(175 - 10 + 65, 129 - 15 + 170, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 14,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                character1_label.setOrigin(0.5, 0.5);
                this.add(character1_label);
                nscs.gameplay.Gameplay.setText(character1_label, 'Chickette');
                let character2_label = this.scene.add.text(299 - 10 + 80, 91 - 15 + 175, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 14,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                character2_label.setOrigin(0.5, 0.5);
                character2_label.setWordWrapWidth(100);
                this.add(character2_label);
                nscs.gameplay.Gameplay.setText(character2_label, 'PamLong');
                let ChooseChar3_label = this.scene.add.text(30, 30, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 18,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                ChooseChar3_label.setOrigin(0, 0.5);
                this.add(ChooseChar3_label);
                nscs.gameplay.Gameplay.setText(ChooseChar3_label, 'ChooseChar');
                this.setPamLocked(nscs.gameplay.Gameplay.isPamLocked);
            }
            setPamLocked(locked) {
                this.locked_image.visible = this.locked_label.visible = locked;
            }
            updateScreen() {
                super.updateScreen();
                if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                    nscs.scene.MainScene.instance.inputController.escPressUsed();
                    nscs.scene.MainScene.instance.switchScreen(new nscs.screen.KidFriendlyScreen(this.scene));
                }
            }
        }
        screen.ChooseCharacterScreen = ChooseCharacterScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class GameOverScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                this.bg = new Phaser.GameObjects.Graphics(this.scene);
                this.bg.setPosition(0, 0);
                this.bg.fillStyle(0xFF0000, 1);
                this.bg.fillRect(0, 0, game.scale.width, game.scale.height);
                this.add(this.bg);
                this.add(new Phaser.GameObjects.Image(this.scene, 345, 190, 'ui-atlas', 'burger_shadow' + '0000'));
                let lost_burger = new Phaser.GameObjects.Image(this.scene, 345, 150, 'ui-atlas', 'lost_burger' + '0000');
                this.add(lost_burger);
                this.txt = this.scene.add.text(game.scale.width / 2 - 75, -100, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 28,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                this.txt.setShadow(4, 4, '#000000', 4, true);
                this.txt.setOrigin(0.5, 0.5);
                this.add(this.txt);
                this.txt.setWordWrapWidth(300);
                nscs.gameplay.Gameplay.setText(this.txt, 'GameOver');
                this.ronald_mc = nscs.scene.MainScene.instance.factory.createRonaldSprite();
                this.ronald_mc.setPosition(335, 115);
                this.fg = new Phaser.GameObjects.Graphics(this.scene);
                this.fg.setPosition(0, 0);
                this.fg.fillStyle(0x000000, 1);
                this.fg.fillRect(0, 0, game.scale.width, game.scale.height);
                this.add(this.fg);
                this.scene.tweens.add({
                    targets: this.fg,
                    alpha: 0,
                    duration: 1000,
                    onComplete: () => {
                        this.remove(this.fg);
                        this.scene.tweens.add({
                            targets: this.txt,
                            y: game.scale.height / 2,
                            duration: 1000,
                            ease: Phaser.Math.Easing.Back.Out
                        });
                        this.ronald_mc.play('appear');
                        this.ronald_mc.once('animationcomplete', () => {
                            this.ronald_mc.play('laugh');
                            nscs.sound.SoundManager.getInstance().playSound(Phaser.Utils.Array.GetRandom(['laugh1SND', 'laugh2SND', 'laugh3SND']));
                            this.ronald_mc.once('animationcomplete', () => {
                                this.ronald_mc.play('disappear');
                                this.ronald_mc.once('animationcomplete', () => {
                                    nscs.scene.MainScene.instance.switchScreen(new nscs.screen.MainMenuScreen(this.scene) /*new nscs.screen.HigscoreScreen(this.scene)*/);
                                });
                            });
                        });
                        this.add(this.ronald_mc);
                    }
                });
            }
        }
        screen.GameOverScreen = GameOverScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class GameScreen extends screen.BaseScreen {
            constructor(scene, worldIdName) {
                super(scene);
                this.activeBubbles = [];
                this.tofuMCs = [];
                this.seakittens = [];
                this.recentEnemyKillsNumber = 0;
                this.recentEnemyKillsNumberDelayedCall = null;
                this.enemy4MCArray = [];
                this.shceduleGravitySwitching = false;
                this.isPipeTravelingActive = false;
                this.reusedArray = [];
                this.boss = null;
                this.onRonaldKilled = () => {
                    if (!this.finishFlag)
                        return;
                    this.finishFlag.visible = true;
                    nscs.scene.MainScene.instance.factory.playAnimation(this.finishFlag, "boss-flag-appear");
                    nscs.sound.SoundManager.getInstance().playSound('flagGrowSND');
                };
                this.onBossAttacksPlayer = () => {
                    this.onEnemyOrHazzardContacted();
                };
                this.isFlagReached = false;
                this.finishFlag = null;
                this.ticker = 0;
                this.isPaused = false;
                this.gameplay = nscs.scene.MainScene.instance.gameplay;
                this.worldIdName = worldIdName;
                this.synchronizeGravity();
                this.inGameUI = new screen.InGameUI(this.scene);
                this.inGameUI.setScrollFactor(0);
                // set background
                this.bg = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.bg);
                for (var i = 0; i < 2; i++) {
                    let img = new Phaser.GameObjects.Image(this.scene, i * (730 - 1), 0, "bg-atlas", this.gameplay.levelData['bg'] + '_bg' + '0000').setOrigin(0, 0);
                    this.bg.add(img);
                }
                this.fg = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.fg);
                for (var i = 0; i < 4; i++) {
                    let img = new Phaser.GameObjects.Image(this.scene, i * (730 - 1), 0, "bgfg-atlas", this.gameplay.levelData["bg"] + '_fg' + '0000').setOrigin(0, 0);
                    this.fg.add(img);
                }
                this.bg.setScrollFactor(0);
                this.fg.setScrollFactor(0);
                //tiles
                this.repaintGrid();
                this.spritesBackLayer = this.scene.add.container(0, 0);
                this.add(this.spritesBackLayer);
                this.player = new nscs.character.Player();
                this.player.setWorldPosition(this.gameplay.newX, this.gameplay.newY);
                this.add(this.player.sprite);
                this.playerToGridCollider = this.scene.physics.add.collider(this.gridRender.getAll(), this.player.sprite, (o1, o2) => {
                    this.onContactWithStaticObject(o1 == this.player.sprite ? o2 : o1);
                });
                this.spritesTopLayer = this.scene.add.container(0, 0);
                this.add(this.spritesTopLayer);
                this.add(this.inGameUI);
                this.inGameUI.setScrollFactor(0);
                this.inGameUI.pauseScreen.onResume = () => {
                    this.setPaused(false);
                };
                this.inGameUI.pauseScreen.onQuit = () => {
                    this.gameplay.destroyTimer();
                    nscs.scene.MainScene.instance.switchScreen(new nscs.screen.MainMenuScreen(this.scene) /*new nscs.screen.HigscoreScreen(this.scene)*/, false);
                    nscs.sound.SoundManager.getInstance().stopMusic();
                };
                this.startFollowCamera();
                nscs.input.InputManager.instance.create(this.scene);
                this.scene.game.events.on('prerender', this.onPreRender, this);
            }
            startFollowCamera() {
                // set bounds so the camera won't go outside the game world
                this.scene.cameras.main.setBounds(0, 0, this.gameplay.worldWidth, this.gameplay.worldHeight);
                // make the camera follow the player
                this.scene.cameras.main.startFollow(this.player.sprite, true, 0.75, 0.75, 0, -40);
                this.scene.cameras.main.setRoundPixels(true);
            }
            stopFollowCamera() {
                // make the camera follow the player
                this.scene.cameras.main.stopFollow();
            }
            createShackleBirds() {
                this.shackleBirdContainer = this.scene.add.container(1120, 1110);
                this.addAt(this.shackleBirdContainer, this.getIndex(this.gridRender));
                let anim = 'playing-shackleBirdFlappingMC';
                if (!this.scene.anims.exists(anim)) {
                    this.scene.anims.create({
                        key: anim,
                        frames: this.scene.anims.generateFrameNames('boss-atlas', {
                            start: 0, end: 8, zeroPad: 4,
                            prefix: 'shackleBirdFlappingMC', suffix: ''
                        }),
                        frameRate: 30,
                        repeat: -1
                    });
                }
                for (let i = 0; i < 6; i++) {
                    let shackleBirdFlappingMC = this.scene.add.sprite(775, 100, 'boss-atlas', 'shackleBirdFlappingMC' + '0000');
                    shackleBirdFlappingMC.setOrigin(0.5, 0);
                    let fn = () => {
                        if (Math.random() > 0.75) {
                            shackleBirdFlappingMC.setFrame('shackleEmptyMC0000');
                        }
                        else {
                            shackleBirdFlappingMC.anims.play(anim);
                        }
                    };
                    fn();
                    this.shackleBirdContainer.add(shackleBirdFlappingMC);
                    this.scene.tweens.add({
                        targets: shackleBirdFlappingMC,
                        x: -70,
                        duration: 10000,
                        delay: i * 1650,
                        repeat: -1,
                        onRepeat: fn
                    });
                }
            }
            onSpritesAdded() {
                if (this.finishFlag) {
                    this.finishFlag.visible = this.boss ? false : true;
                }
                if (this.boss) {
                    this.createShackleBirds();
                }
                let gridSprites = this.gridRender.getAll();
                let sprites = this.getAllSprites();
                for (let s of sprites) {
                    if (this.isSpriteGravityAllowed(s)) {
                        if (s.body) {
                            s.body["setAllowGravity"](true);
                            s.setCollideWorldBounds(true);
                            this.scene.physics.add.collider(gridSprites, s);
                            for (let b of sprites) {
                                if (b["spriteType"] == 'B') {
                                    this.scene.physics.add.collider(b, s);
                                }
                            }
                        }
                    }
                }
            }
            addSprite(sprite) {
                if (sprite["libId"] == "bossMC") {
                    this.boss = sprite;
                    this.boss.setup(this.player, 1060, 1885, this.boss.y, this.boss.y + 115, this.onRonaldKilled, this.onBossAttacksPlayer);
                    this.addAt(this.boss, this.getIndex(this.player.sprite));
                    return;
                }
                else if (sprite["libId"] == "flagPoleMC") {
                    this.finishFlag = sprite;
                    this.finishFlag["flagPoleMC"].body.checkCollision.up = this.finishFlag["flagPoleMC"].body.checkCollision.down = false;
                    this.addAt(this.finishFlag, this.getIndex(this.gridRender) + 1);
                    return;
                }
                let topLayerSprites = [
                    'decor84MC', 'decor83MC', 'decor82MC', 'decor81MC', 'decor79MC', 'decor78MC', 'decor80MC', 'decor113MC', 'decor77MC',
                    'decor76MC', 'decor13MC', 'decor12MC', 'decor15MC', 'decor17MC', 'decor16MC', 'decor100MC', 'decor69MC', 'decor68MC',
                    'decor18MC', 'decor14MC', 'decor19MC', 'decor10MC', 'decor26MC', 'decor92MC', 'decor91MC'
                ];
                if (topLayerSprites.indexOf(sprite["libId"]) >= 0) {
                    this.spritesTopLayer.add(sprite);
                }
                else {
                    this.spritesBackLayer.add(sprite);
                }
            }
            showBubbles(x, y, minNum, maxNum, direction, dBase, lifeDistance, duration, onComplete) {
                let num = minNum + Math.round(Math.random() * Math.floor(maxNum - minNum));
                for (let i = 0; i < num; i++) {
                    let fromX = x, fromY = y;
                    if (direction == "left" || direction == "right") {
                        fromY += (Math.random() - 0.5) * dBase;
                    }
                    else if (direction == "up" || direction == "down") {
                        fromX += (Math.random() - 0.5) * dBase;
                    }
                    let toX = fromX, toY = fromY;
                    if (direction == "left") {
                        toX -= lifeDistance;
                    }
                    else if (direction == "right") {
                        toX += lifeDistance;
                    }
                    else if (direction == "up") {
                        toY -= lifeDistance;
                    }
                    else if (direction == "down") {
                        toY += lifeDistance;
                    }
                    let bubble = new Phaser.GameObjects.Image(this.scene, fromX, fromY, 'objects-atlas', 'whiteBubbleMC' + '0000');
                    bubble.setOrigin(0.5, 0.5);
                    bubble.setScale(0.75 + Math.random() * 0.25);
                    bubble['-onLifeEndCallback-'] = () => {
                        if (onComplete)
                            onComplete();
                        if (bubble.parentContainer)
                            bubble.parentContainer.remove(bubble);
                    };
                    this.scene.tweens.add({
                        targets: bubble,
                        x: toX,
                        y: toY,
                        scale: 0,
                        alpha: 0.5,
                        duration: duration,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: bubble['-onLifeEndCallback-'],
                        onStart: () => {
                            bubble.visible = true;
                            this.activeBubbles.push(bubble);
                        },
                        delay: i * 50 + Math.random() * 100
                    });
                    bubble.visible = false;
                    this.addAt(bubble, this.getIndex(this.spritesBackLayer) - 1);
                }
            }
            destroyBubble(b) {
                let ind = this.activeBubbles.indexOf(b);
                if (ind >= 0)
                    this.activeBubbles.splice(ind, 1);
                this.scene.tweens.killTweensOf(b);
                b['-onLifeEndCallback-']();
            }
            showTextPopUp(content) {
                let txt = this.scene.add.text(this.player.sprite.x, this.player.sprite.y, "", {
                    "fontFamily": "AxaxaxRg-Bold",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'center'
                }).setOrigin(0.5, 0.5);
                txt.setStroke('#000000', 2);
                this.add(txt);
                nscs.util.Functions.updateTextFieldPosition(txt, content);
                this.scene.tweens.add({
                    targets: txt,
                    y: txt.y - 75,
                    duration: 1000,
                    onComplete: () => {
                        if (txt.parentContainer)
                            txt.parentContainer.remove(txt);
                    }
                });
                if (content == '1UP') {
                    nscs.sound.SoundManager.getInstance().playSound('1upSND');
                }
            }
            scoreUp(number) {
                this.showTextPopUp(String(number));
            }
            showPickUpHeart(x, y) {
                let heart = new Phaser.GameObjects.Sprite(this.scene, x, y, 'objects-atlas', 'OneUpXMC' + '0000');
                this.scene.tweens.add({
                    targets: heart,
                    y: heart.y - 60,
                    alpha: 0,
                    duration: 1500,
                    ease: Phaser.Math.Easing.Sine.Out,
                    onComplete: () => {
                        if (heart.parentContainer)
                            heart.parentContainer.remove(heart);
                    }
                });
                this.addAt(heart, this.getIndex(this.spritesBackLayer) + 1);
            }
            showPickUpChick(chick, scaleX, x, y) {
                if (!chick) {
                    chick = nscs.scene.MainScene.instance.factory.createConstructedObject("tinyChickMC");
                    chick.setPosition(x, y);
                    chick.scaleX = scaleX;
                }
                this.scene.tweens.add({
                    targets: chick,
                    x: chick.x + (chick.scaleX > 0 ? 1 : -1) * (Math.random() * 35 + 40),
                    y: chick.y - 200 - Math.random() * 20,
                    duration: 2500 + Math.random() * 750,
                    ease: Phaser.Math.Easing.Sine.Out,
                    onComplete: () => {
                        if (chick.parentContainer)
                            chick.parentContainer.remove(chick);
                    }
                });
                this.scene.tweens.add({
                    targets: chick,
                    delay: 1000,
                    duration: 500,
                    alpha: 0
                });
                this.addAt(chick, this.getIndex(this.spritesBackLayer) + 1);
            }
            repaintGrid() {
                this.ladderArray = [];
                this.gridRender = this.scene.add.container(0, 0);
                this.add(this.gridRender);
                this.gridRenderView = this.scene.add.container(0, 0);
                this.add(this.gridRenderView);
                let noPhysics = [
                    [0, 0], [12, 12], [10, 15], [14, 12], [1, 0], [10, 0], [11, 11], [14, 11], [8, 11], [8, 12], [8, 13], [9, 12], [9, 11], [10, 11], [11, 11], [10, 12], [10, 6], [11, 6],
                    [1, 9], [2, 9], [9, 13], [3, 11]
                ];
                let _grid = [];
                const n = 16;
                for (var i = 0; i < this.gameplay.worldTilesY; i++) {
                    let _row = new Array(this.gameplay.worldTilesX);
                    for (let _i = 0; _i < this.gameplay.worldTilesY; _i++)
                        _row[_i] = 0;
                    _grid.push(_row);
                    for (var j = 0; j < this.gameplay.worldTilesX; j++) {
                        if (this.gameplay.grid[i][j] > 0) {
                            var srcx = this.gameplay.grid[i][j] % n;
                            var srcy = Math.floor(this.gameplay.grid[i][j] / n);
                            let cdw = 0;
                            let cdh = 0;
                            if (srcx == 10 && srcy == 0)
                                cdw = -1;
                            else if (srcx == 11 && srcy == 2 || srcx == 12 && srcy == 2 || srcx == 13 && srcy == 2)
                                cdh = -1;
                            if (Number(this.gameplay.ladder_array[this.gameplay.grid[i][j]]) == 1) {
                                let ladder_tile = this.scene.physics.add.sprite(j * this.gameplay.tileWidth, i * this.gameplay.tileHeight, 'texture');
                                ladder_tile.setOrigin(srcx / (n - 1), srcy / (n - 1));
                                ladder_tile.setCrop(srcx * this.gameplay.tileWidth, srcy * this.gameplay.tileHeight, this.gameplay.tileWidth + cdw, this.gameplay.tileHeight + cdh);
                                ladder_tile.setCollideWorldBounds(false);
                                ladder_tile.body.setSize(this.gameplay.tileWidth, this.gameplay.tileHeight);
                                ladder_tile.setImmovable(true);
                                ladder_tile.body["setAllowGravity"](false);
                                ladder_tile.body.setOffset(srcx / (n - 1) * ladder_tile.width, srcy / (n - 1) * ladder_tile.height);
                                this.ladderArray.push(ladder_tile);
                                this.add(ladder_tile);
                                ladder_tile["-grid-i-"] = i;
                                ladder_tile["-grid-j-"] = j;
                            }
                            else {
                                let hasNoPhysics = false;
                                for (let np of noPhysics)
                                    if (srcx == np[0] && srcy == np[1]) {
                                        hasNoPhysics = true;
                                        break;
                                    }
                                if (!hasNoPhysics) {
                                    _row[j] = 1;
                                }
                                let tile = this.scene.add.sprite(j * this.gameplay.tileWidth, i * this.gameplay.tileHeight, 'texture');
                                tile.setOrigin(srcx / (n - 1), srcy / (n - 1));
                                tile.setCrop(srcx * this.gameplay.tileWidth, srcy * this.gameplay.tileHeight, this.gameplay.tileWidth + cdw, this.gameplay.tileHeight + cdh);
                                this.gridRenderView.add(tile);
                            }
                        }
                    }
                }
                this.createGridRenderPhysics(_grid);
            }
            isTileInBlockRects(i, j, rects) {
                for (let r of rects) {
                    if (i >= r["i"] && j >= r["j"] && i < r["i"] + r["h"] && j < r["j"] + r["w"]) {
                        return true;
                    }
                }
                return false;
            }
            createGridRenderPhysics(_grid) {
                let rects = [];
                for (let i = 0; i < _grid.length; i++) {
                    label_1: for (let j = 0; j < _grid[i].length; j++) {
                        let w = 0;
                        let h = 0;
                        if (_grid[i][j] == 1) {
                            if (this.isTileInBlockRects(i, j, rects)) {
                                continue label_1;
                            }
                            w = 1;
                            h = 1;
                            for (let k = i + 1; k < _grid.length; k++) {
                                if (this.isTileInBlockRects(k, j, rects)) {
                                    break;
                                }
                                if (_grid[k][j] != 1)
                                    break;
                                else
                                    h++;
                            }
                            label: for (let l = j + 1; l < _grid[i].length; l++) {
                                for (let k = i; k < i + h; k++) {
                                    if (this.isTileInBlockRects(k, l, rects)) {
                                        break label;
                                    }
                                    if (_grid[k][l] != 1)
                                        break label;
                                }
                                w++;
                            }
                            rects.push({
                                "i": i, "j": j, "w": w, "h": h
                            });
                        }
                    }
                }
                for (let r of rects) {
                    let tile = this.scene.physics.add.sprite(r["j"] * this.gameplay.tileWidth + (r["w"] - 1) * this.gameplay.tileWidth / 2, r["i"] * this.gameplay.tileHeight + (r["h"] - 1) * this.gameplay.tileHeight / 2, null);
                    tile.setCollideWorldBounds(false);
                    tile.setOrigin(0);
                    tile.visible = false;
                    tile.body.setSize(r["w"] * this.gameplay.tileWidth, r["h"] * this.gameplay.tileHeight);
                    tile.setImmovable(true);
                    tile.body["setAllowGravity"](false);
                    this.gridRender.add(tile);
                }
            }
            updateBlock(sprite_mc) {
                this.scene.physics.world.collide(this.player.sprite, sprite_mc, () => {
                    this.onContactWithStaticObject(sprite_mc);
                    if (sprite_mc["displayType"] && sprite_mc["displayType"].toLowerCase().indexOf("solid") >= 0)
                        return;
                    //------------------------------------
                    let crash = () => {
                        let bblock1BreakMC = this.scene.add.sprite(sprite_mc.x, sprite_mc.y, 'objects-atlas', 'bblock1BreakMC' + '0000');
                        bblock1BreakMC.setOrigin(0.5, 1);
                        this.addAt(bblock1BreakMC, this.getIndex(this.spritesBackLayer) + 1);
                        let anim = 'bblock1BreakMC' + "_" + "playingAnimName";
                        if (!this.scene.anims.exists(anim)) {
                            this.scene.anims.create({
                                key: anim,
                                frames: this.scene.anims.generateFrameNames(bblock1BreakMC.texture.key, {
                                    start: 0, end: 11, zeroPad: 4,
                                    prefix: 'bblock1BreakMC', suffix: ''
                                }),
                                frameRate: 60
                            });
                        }
                        bblock1BreakMC.anims.play(anim);
                        bblock1BreakMC.once('animationcomplete', () => { if (bblock1BreakMC.parentContainer)
                            bblock1BreakMC.parentContainer.remove(bblock1BreakMC); });
                        nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, sprite_mc["displayType"] = 'makeSolid');
                        if (sprite_mc.parentContainer)
                            sprite_mc.parentContainer.remove(sprite_mc);
                        nscs.sound.SoundManager.getInstance().playSound('breakBlockSND');
                    };
                    //------------------------------------
                    if (this.gameplay.isGravityFlipped() ?
                        ((this.player.sprite.body.touching.down && sprite_mc.body.touching.up)
                            ||
                                (this.player.sprite.body.touching.up && sprite_mc.body.touching.down && this.player.pounceLanding)) :
                        ((this.player.sprite.body.touching.up && sprite_mc.body.touching.down)
                            ||
                                (this.player.sprite.body.touching.down && sprite_mc.body.touching.up && this.player.pounceLanding))) {
                        if (sprite_mc["displayType"] == "question" || sprite_mc["displayType"] == "masked") {
                            //------------------------------------
                            if (sprite_mc["playLabel"] == "chick") {
                                nscs.scene.MainScene.instance.gameplay.addChick();
                                this.showPickUpChick(null, Math.random() > 0.5 ? 1 : -1, sprite_mc.x, sprite_mc.y);
                            }
                            else if (sprite_mc["playLabel"] == "tofu" || (sprite_mc["playLabel"] == "1up" && (!isNaN(sprite_mc["points"])) && sprite_mc["points"] != 0)) {
                                this.createTofuMC(sprite_mc.x, sprite_mc.y - 15, sprite_mc["playLabel"]);
                            }
                            else if (sprite_mc["playLabel"] == "1up") {
                                this.gameplay.addLife();
                                this.showPickUpHeart(sprite_mc.x, sprite_mc.y - 20);
                            }
                            else if (sprite_mc["playLabel"] == "seakitten") {
                                this.createSeakitten(sprite_mc.x, sprite_mc.y - 20);
                            }
                            //------------------------------------
                            if (!isNaN(sprite_mc["points"]) && sprite_mc["points"] > 0) {
                                this.gameplay.scoreUp(sprite_mc["points"]);
                            }
                            //------------------------------------
                            sprite_mc["hitsLeft"]--;
                            if (sprite_mc["hitsLeft"] <= 0) {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, sprite_mc["displayType"] = 'makeSolid');
                            }
                            else {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'question-wobble');
                                nscs.sound.SoundManager.getInstance().playSound('bumpSND');
                            }
                        }
                        else if (typeof sprite_mc["displayType"] === "undefined") {
                            if (this.gameplay.charSize == "small") {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'wobble');
                                nscs.sound.SoundManager.getInstance().playSound('bumpSND');
                            }
                            else if (this.gameplay.charSize == "big") {
                                // this.player.sprite.setVelocityY(0);
                                crash();
                            }
                        }
                        else if (sprite_mc["displayType"] === "hidden") {
                            if (sprite_mc["hitsLeft"] == 0) {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, sprite_mc["displayType"] = 'hiddenToSolid');
                            }
                            else {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, sprite_mc["displayType"] = 'question');
                            }
                        }
                        // console.log(sprite_mc["hitsLeft"],sprite_mc["playLabel"],sprite_mc["points"], sprite_mc["displayType"])
                    }
                });
            }
            createTofuMC(x, y, playLabel) {
                let tofuMC = this.scene.physics.add.sprite(x, y, 'objects-atlas', 'tofuMC' + '0000');
                tofuMC.setOrigin(0, 1);
                tofuMC.setCollideWorldBounds(false);
                tofuMC.setImmovable(true);
                tofuMC.body["setAllowGravity"](false);
                tofuMC.alpha = 0;
                tofuMC.scaleY = 0;
                this.scene.tweens.add({
                    targets: tofuMC,
                    duration: 500,
                    alpha: 1,
                    scaleY: 1,
                    onComplete: () => {
                        tofuMC['-activated-'] = true;
                    }
                });
                tofuMC["playLabel"] = playLabel;
                this.addAt(tofuMC, this.getIndex(this.spritesBackLayer) + 1);
                this.tofuMCs.push(tofuMC);
                nscs.sound.SoundManager.getInstance().playSound('tofuSND');
            }
            createSeakitten(x, y) {
                let seakitten = this.scene.physics.add.sprite(x, y, 'objects-atlas', 'skMC' + '0000');
                seakitten.setOrigin(0, 1);
                seakitten.setCollideWorldBounds(false);
                seakitten.setImmovable(true);
                seakitten.body["setAllowGravity"](false);
                seakitten.alpha = 0;
                seakitten.scaleY = 0;
                this.scene.tweens.add({
                    targets: seakitten,
                    duration: 500,
                    alpha: 1,
                    scaleY: 1,
                    onComplete: () => {
                        seakitten['-activated-'] = true;
                    }
                });
                this.addAt(seakitten, this.getIndex(this.spritesBackLayer) + 1);
                this.seakittens.push(seakitten);
                nscs.sound.SoundManager.getInstance().playSound('seaKittenSND');
            }
            updateTofu() {
                for (let i = this.tofuMCs.length - 1; i >= 0; i--) {
                    let tofuMC = this.tofuMCs[i];
                    if (!tofuMC['-activated-'])
                        continue;
                    this.scene.physics.world.overlap(this.player.sprite, tofuMC, () => {
                        if (tofuMC["playLabel"] == "1up") {
                            this.gameplay.addLife();
                        }
                        else {
                            this.gameplay.scoreUp(1000);
                            this.player.setCharSize("big");
                            nscs.sound.SoundManager.getInstance().playSound('growBigSND');
                        }
                        this.scene.tweens.add({
                            targets: tofuMC,
                            duration: 500,
                            alpha: 0,
                            scaleY: 0,
                            onComplete: () => {
                                if (tofuMC.parentContiner)
                                    tofuMC.parentContiner.remove(tofuMC);
                            }
                        });
                        this.tofuMCs.splice(i, 1);
                    });
                }
            }
            updateSeakitten() {
                for (let i = this.seakittens.length - 1; i >= 0; i--) {
                    let seakitten = this.seakittens[i];
                    if (!seakitten['-activated-'])
                        continue;
                    this.scene.physics.world.overlap(this.player.sprite, seakitten, () => {
                        this.gameplay.scoreUp(1000);
                        this.player.setCharSize("big");
                        this.player.setSeaKittenise(true);
                        nscs.sound.SoundManager.getInstance().playSound('growBigSND');
                        this.scene.tweens.add({
                            targets: seakitten,
                            duration: 500,
                            alpha: 0,
                            scaleY: 0,
                            onComplete: () => {
                                if (seakitten.parentContiner)
                                    seakitten.parentContiner.remove(seakitten);
                            }
                        });
                        this.seakittens.splice(i, 1);
                    });
                }
            }
            updateChick(sprite_mc) {
                this.scene.physics.world.overlap(this.player.sprite, sprite_mc, () => {
                    nscs.scene.MainScene.instance.gameplay.addChick();
                    if (sprite_mc.parentContainer)
                        sprite_mc.parentContainer.remove(sprite_mc);
                    this.showPickUpChick(sprite_mc);
                    nscs.sound.SoundManager.getInstance().playSound('coinSND');
                });
            }
            onEnemyOrHazzardContacted() {
                if (this.player.fullyActive()) {
                    if (this.gameplay.charSize == "big") {
                        this.player.setCharSize("small");
                        nscs.sound.SoundManager.getInstance().playSound('shrinkSND');
                        this.player.setImmortalBlinking();
                    }
                    else {
                        this.minusOneLife();
                    }
                }
            }
            updateHazzard(sprite_mc) {
                if (this.player.immortalBlinkingTicker != 0)
                    return;
                this.scene.physics.world.collide(this.player.sprite, sprite_mc, () => {
                    this.onEnemyOrHazzardContacted();
                    nscs.sound.SoundManager.getInstance().playSound('spikesSND');
                });
            }
            gainScoreForEnemyKill() {
                if (this.recentEnemyKillsNumberDelayedCall)
                    nscs.util.Functions.destroyDelayedCall(this.recentEnemyKillsNumberDelayedCall);
                this.recentEnemyKillsNumberDelayedCall = nscs.util.Functions.delayedCall(1750, () => { this.recentEnemyKillsNumber = 0; });
                this.recentEnemyKillsNumber++;
                this.gameplay.scoreUp(this.player.pounceLanding ? this.recentEnemyKillsNumber * 750 : this.recentEnemyKillsNumber * 500);
            }
            updateEnemy4MC() {
                let sprite_mc;
                for (sprite_mc of this.enemy4MCArray) {
                    if (sprite_mc["dead"])
                        continue;
                    if (this.gameplay.isGravityFlipped()) {
                        sprite_mc.body["setAllowGravity"](false);
                    } /* else {
                        sprite_mc.body["setAllowGravity"](true);
                    }*/
                    if (sprite_mc.body.velocity.y < 0 && sprite_mc.body.velocity.y > -10) {
                        sprite_mc.setVelocityY(-50);
                    }
                    let d = Phaser.Math.Distance.Between(this.player.sprite.x, this.player.getFootsWorldY(), sprite_mc.x, sprite_mc.y);
                    let ch = this.gridRender.getAll();
                    for (let c of ch) {
                        this.scene.physics.world.collide(sprite_mc, c, () => {
                            if (sprite_mc.body.touching.right || sprite_mc.body.touching.left) {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'bounceSide');
                                if (d < 250)
                                    nscs.sound.SoundManager.getInstance().playSound('fryKidSND');
                            }
                            else if (this.gameplay.isGravityFlipped() ?
                                sprite_mc.body.touching.down || sprite_mc.body.touching.up :
                                sprite_mc.body.touching.up || sprite_mc.body.touching.down) {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'bounce');
                                if (d < 250)
                                    nscs.sound.SoundManager.getInstance().playSound('fryKidSND');
                            }
                        });
                    }
                }
            }
            showDustMC(x, y, scale, angle) {
                let dustMC = this.scene.add.sprite(x, y, 'objects-atlas', 'dustMC' + '0000');
                dustMC.setOrigin(0.5, 0.75);
                let anim = 'dustMC' + "_" + "playingAnimName";
                if (!this.scene.anims.exists(anim)) {
                    this.scene.anims.create({
                        key: anim,
                        frames: this.scene.anims.generateFrameNames(dustMC.texture.key, {
                            start: 0, end: 39, zeroPad: 4,
                            prefix: 'dustMC', suffix: ''
                        }),
                        frameRate: 60
                    });
                }
                dustMC.play(anim);
                dustMC.once('animationcomplete', () => { if (dustMC.parentContainer)
                    dustMC.parentContainer.remove(dustMC); });
                dustMC.setScale(scale);
                dustMC.setAngle(angle);
                this.addAt(dustMC, this.getIndex(this.player.sprite) + 1);
            }
            updateEnemy(sprite_mc) {
                if (sprite_mc["dead"])
                    return;
                let hitTestMethod = "collide";
                if (sprite_mc["libId"] == "enemy3MC") {
                    if (nscs.scene.MainScene.instance.factory.isAnimationComplete(sprite_mc)) {
                        nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, Math.random() > 0.9 ? 'attack' : 'idle');
                    }
                }
                else if (sprite_mc["libId"] == "enemy5MC") {
                    let dist = Phaser.Math.Distance.Between(sprite_mc.x, sprite_mc.y, this.player.sprite.x, this.player.sprite.y);
                    if (!sprite_mc["appeared"]) {
                        if (dist < 250) {
                            sprite_mc["appeared"] = true;
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'appear');
                            nscs.sound.SoundManager.getInstance().playSound('mbJumpSND');
                            nscs.sound.SoundManager.getInstance().playSound('mbRustleSND');
                        }
                    }
                    else {
                        if (dist > 250) {
                            sprite_mc["appeared"] = false;
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'disappear');
                        }
                        if (nscs.scene.MainScene.instance.factory.isAnimationComplete(sprite_mc)) {
                            nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, Math.random() > 0.85 ? 'attack' : 'appeared');
                        }
                    }
                }
                else if (sprite_mc["libId"].indexOf("enemy4MC") == 0) {
                    hitTestMethod = "overlap";
                    if (Math.abs(this.player.sprite.x - sprite_mc.x) < game.scale.width && Math.abs(this.player.sprite.y - sprite_mc.y) < game.scale.height) {
                        if (this.enemy4MCArray.indexOf(sprite_mc) < 0) {
                            this.enemy4MCArray.push(sprite_mc);
                            sprite_mc.setVelocity((Math.random() > 0.5 ? 1 : -1) * (Math.random() * 0.5 + 0.5) * 40, (Math.random() * 0.5 + 0.5) * 100);
                            sprite_mc.setBounce(1, 1);
                            sprite_mc.setCollideWorldBounds(false);
                            sprite_mc.setImmovable(false);
                            sprite_mc.body["setAllowGravity"](true);
                            sprite_mc['-defVelocityLength-'] = sprite_mc.body.velocity.length();
                            this.scene.tweens.add({
                                targets: sprite_mc,
                                angle: Math.random() > 0.5 ? 360 : -360,
                                duration: 5000,
                                repeat: -1,
                                ease: Phaser.Math.Easing.Linear
                            });
                        }
                    }
                }
                if (sprite_mc["libId"] == "enemy5MC" && !sprite_mc["appeared"]) {
                    return;
                }
                this.scene.physics.world[hitTestMethod](this.player.sprite, sprite_mc, () => {
                    // sprite_mc.setImmovable(true);
                    // sprite_mc.body["setAllowGravity"](false);
                    sprite_mc.setVelocity(0, sprite_mc.body.velocity.y);
                    if (this.gameplay.isGravityFlipped() ? this.player.sprite.body.touching.up : this.player.sprite.body.touching.down) {
                        if (this.gameplay.isGravityFlipped() ? sprite_mc.body.touching.down : sprite_mc.body.touching.up) {
                            if (this.player.pounceLanding) {
                                sprite_mc["hitsToKill"] = 0;
                            }
                            else {
                                sprite_mc["hitsToKill"]--;
                            }
                            if (sprite_mc["hitsToKill"] == 0) {
                                sprite_mc["dead"] = true;
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'die');
                                this.gainScoreForEnemyKill();
                                nscs.sound.SoundManager.getInstance().playSound('squashSND');
                                nscs.sound.SoundManager.getInstance().playSound('hairballHitSND');
                            }
                            else {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'hit');
                            }
                            this.player.doAfterJumpOverEnemy();
                        }
                    }
                    if (!sprite_mc["dead"]) {
                        if (this.player.sprite.body.touching.left || this.player.sprite.body.touching.right || this.player.sprite.body.touching.up) {
                            if (sprite_mc.body.touching.left || sprite_mc.body.touching.right || (this.gameplay.isGravityFlipped() ? sprite_mc.body.touching.up : sprite_mc.body.touching.down)) {
                                nscs.scene.MainScene.instance.factory.gotoAndPlay(sprite_mc, 'attack');
                                this.onEnemyOrHazzardContacted();
                            }
                        }
                    }
                });
                if (sprite_mc.y > this.gameplay.waterLevel) {
                    if (!sprite_mc['tickerModer'])
                        sprite_mc['tickerModer'] = Math.ceil(Math.random() * 10) + 30;
                    if (this.ticker % sprite_mc['tickerModer'] == 0 && Math.random() > 0.75) {
                        this.showBubbles(sprite_mc.x, sprite_mc.y, 1, 2, this.gameplay.isGravityFlipped() ? 'down' : 'up', 10, 75 + Math.random() * 50, 1500, null);
                    }
                }
            }
            isSpriteGravityAllowed(sprite_mc) {
                return sprite_mc["libId"] == "decor93MC" || sprite_mc["libId"] == "decor94MC" || sprite_mc["libId"] == "decor95MC" || sprite_mc["libId"] == "enemy3MC";
            }
            updateDecor(sprite_mc) {
                if (sprite_mc["libId"] == 'decor96MC' && this.gameplay.inWater) {
                    let dx = this.player.sprite.x - sprite_mc.x;
                    let dy = this.player.sprite.y - sprite_mc.y;
                    let d = Math.sqrt(dx * dx + dy * dy);
                    sprite_mc.scaleY = this.player.sprite.x < sprite_mc.x ? -1 : 1;
                    sprite_mc.rotation = Math.atan2(dy, dx);
                    let sprite_mcY = sprite_mc.y;
                    if (d < 300 && d > 75) {
                        sprite_mc.x += (this.player.sprite.x - sprite_mc.x) / 60;
                        sprite_mcY += (this.player.sprite.y - sprite_mcY) / 60;
                    }
                    if (sprite_mc.y > this.gameplay.waterLevel) {
                        if (this.ticker % 45 == 0 && Math.random() > 0.5) {
                            this.showBubbles(sprite_mc.x, sprite_mc.y, 1, 3, this.gameplay.isGravityFlipped() ? 'down' : 'up', 10, 75 + Math.random() * 50, 1000, null);
                        }
                    }
                    if (this.isPointInWater(sprite_mc.x, sprite_mcY - 20)) {
                        sprite_mc.y = sprite_mcY;
                    }
                }
                if (!sprite_mc["decorType"])
                    return;
                if (sprite_mc["decorType"] == 'protestor' && sprite_mc["speech"]) {
                    if (!sprite_mc['exlamationXMC-created']) {
                        sprite_mc['exlamationXMC-created'] = true;
                        let exlamationXMC = new Phaser.GameObjects.Image(this.scene, 0, 0, 'decor-atlas', 'exlamationXMC' + '0000');
                        let updatePosition = () => {
                            exlamationXMC.setPosition(sprite_mc.x + sprite_mc.scaleX * 20, sprite_mc.y + (0.5 - sprite_mc.originY) * sprite_mc.height + (13) * (this.gameplay.gravityDir));
                            exlamationXMC.flipY = this.gameplay.isGravityFlipped();
                        };
                        updatePosition();
                        sprite_mc['exlamationXMC'] = exlamationXMC;
                        exlamationXMC.setOrigin(0, 1);
                        this.addAt(exlamationXMC, this.getIndex(this.spritesBackLayer) + 1);
                        exlamationXMC.scale = 0;
                        this.scene.tweens.add({
                            targets: exlamationXMC,
                            duration: 1000,
                            scale: 1.5,
                            repeat: -1,
                            onUpdate: () => {
                                sprite_mc['exlamationXMC'].scaleX = (sprite_mc.scaleX > 0 ? 1 : -1) * sprite_mc['exlamationXMC'].scaleX;
                                updatePosition();
                            }
                        });
                        this.scene.tweens.add({
                            targets: exlamationXMC,
                            duration: 1000,
                            alpha: 0,
                            repeat: -1,
                            ease: Phaser.Math.Easing.Expo.In
                        });
                    }
                    let scaleX = 1;
                    if (sprite_mc.hasOwnProperty('lookingLeft'))
                        scaleX = sprite_mc['lookingLeft'] ? 1 : -1;
                    if (!this.isSpriteGravityAllowed(sprite_mc)) {
                        if (this.player.sprite.x < sprite_mc.x) {
                            scaleX *= 1;
                        }
                        else {
                            scaleX *= -1;
                        }
                    }
                    sprite_mc.scaleX = scaleX;
                    let overlap = this.scene.physics.world.overlap(this.player.sprite, sprite_mc);
                    if (overlap) {
                        if (!sprite_mc["speaking"]) {
                            sprite_mc["speaking"] = true;
                            this.inGameUI.showSpeechDialog(this.scene.cameras.main.getScroll(sprite_mc.x, sprite_mc.y).x, nscs.gameplay.Gameplay.getText('activist' + sprite_mc["speech"]));
                            nscs.sound.SoundManager.getInstance().playSound('whistleSND');
                        }
                        else {
                            this.inGameUI.updateSpeechDialog(this.scene.cameras.main.getScroll(this.player.sprite.x, this.player.sprite.y).x);
                        }
                    }
                    else {
                        if (sprite_mc["speaking"]) {
                            sprite_mc["speaking"] = false;
                            this.inGameUI.hideSpeechDialog();
                        }
                    }
                }
                else if (sprite_mc["decorType"].indexOf('pipe') == 0) {
                    let overlap = this.scene.physics.world.overlap(this.player.sprite, sprite_mc);
                    if (overlap) {
                        this.onContactWithStaticObject(sprite_mc);
                        let inputController = nscs.scene.MainScene.instance.inputController;
                        let l = (inputController.cursorKeys.left.isDown || nscs.input.InputManager.instance.isDown('LEFT'))
                            && sprite_mc.body.touching.right && this.player.sprite.body.touching.left;
                        let r = (inputController.cursorKeys.right.isDown || nscs.input.InputManager.instance.isDown('RIGHT'))
                            && sprite_mc.body.touching.left && this.player.sprite.body.touching.right;
                        if ((sprite_mc["decorType"] == 'pipeDown' && (this.gameplay.isGravityFlipped() ?
                            /*inputController.cursorKeys.up.isDown && */ sprite_mc.body.touching.down && this.player.sprite.body.touching.up :
                            (inputController.cursorKeys.down.isDown || nscs.input.InputManager.instance.isDown('DOWN'))
                                && sprite_mc.body.touching.up && this.player.sprite.body.touching.down))
                            ||
                                (sprite_mc["decorType"] == 'pipeUp' && (this.gameplay.isGravityFlipped() ?
                                    (inputController.cursorKeys.down.isDown || nscs.input.InputManager.instance.isDown('DOWN'))
                                        && sprite_mc.body.touching.up && this.player.sprite.body.touching.down :
                                    /*inputController.cursorKeys.up.isDown && */ sprite_mc.body.touching.down && this.player.sprite.body.touching.up))
                            ||
                                (sprite_mc["decorType"] == 'pipeSide' && (l || r))) {
                            let inDirection;
                            if (sprite_mc["decorType"] == 'pipeDown')
                                inDirection = 'down';
                            else if (sprite_mc["decorType"] == 'pipeUp')
                                inDirection = 'up';
                            else if (l)
                                inDirection = 'left';
                            else if (r)
                                inDirection = 'right';
                            this.pipeTravel(sprite_mc["pipeRoute"], inDirection);
                        }
                    }
                }
                else if (sprite_mc["decorType"] == 'bounce' || sprite_mc["decorType"] == 'uberBounce') {
                    let overlap = this.scene.physics.world.overlap(this.player.sprite, sprite_mc);
                    if (overlap) {
                        this.player.doBounceJump();
                        nscs.scene.MainScene.instance.factory.playAnimation(sprite_mc);
                        nscs.sound.SoundManager.getInstance().playSound('bouncerSND');
                    }
                }
                else if (sprite_mc["decorType"] == 'recovery') {
                    if (!sprite_mc['-active-']) {
                        if (this.scene.physics.world.overlap(this.player.sprite, sprite_mc)) {
                            sprite_mc['-active-'] = true;
                        }
                    }
                }
                else if (sprite_mc["decorType"] == 'switch') {
                    if (sprite_mc["switchType"] == "gravity") {
                        if (this.player.pounceLanding) {
                            sprite_mc.body.checkCollision.right = sprite_mc.body.checkCollision.left = false;
                            if (this.scene.physics.world.collide(this.player.sprite, sprite_mc)) {
                                if (this.gameplay.isGravityFlipped() ?
                                    this.player.sprite.body.touching.up && sprite_mc.body.touching.down :
                                    this.player.sprite.body.touching.down && sprite_mc.body.touching.up) {
                                    this.shceduleGravitySwitching = true;
                                    this.onContactWithStaticObject(sprite_mc);
                                }
                            }
                        }
                    }
                }
                else if (sprite_mc["decorType"] && sprite_mc["decorType"].substr(0, 3) == 'fan') {
                    if (this.scene.physics.world.overlap(this.player.sprite, sprite_mc)) {
                        if (sprite_mc["decorType"] == 'fanUp') {
                            this.player.fanUp = true;
                        }
                        else {
                            if (sprite_mc["decorType"] == 'fanLeft') {
                                this.player.fanLeft = true;
                            }
                            else if (sprite_mc["decorType"] == 'fanRight') {
                                this.player.fanRight = true;
                            }
                        }
                    }
                    //bubbles
                    let startX = sprite_mc.x;
                    let startY = sprite_mc.y;
                    if (sprite_mc["decorType"] == 'fanUp') {
                        startX += 50;
                        startY += 5;
                    }
                    else if (sprite_mc["decorType"] == 'fanLeft') {
                        startX += 5;
                        startY += 55;
                    }
                    else if (sprite_mc["decorType"] == 'fanRight') {
                        startX += 75;
                        startY += 55;
                    }
                    if (!sprite_mc.hasOwnProperty('-activeBubbles-')) {
                        sprite_mc['-activeBubbles-'] = 0;
                    }
                    if (!sprite_mc.hasOwnProperty('-ticker-')) {
                        sprite_mc['-ticker-'] = 0;
                    }
                    if (sprite_mc['-ticker-'] == 0) {
                        if (sprite_mc['-activeBubbles-'] < 5) {
                            let directionMap = {
                                'fanUp': 'up',
                                'fanLeft': 'left',
                                'fanRight': 'right'
                            };
                            let num = 1 + Math.round(Math.random() * Math.floor(3 - 1));
                            sprite_mc['-activeBubbles-'] += num;
                            this.showBubbles(startX, startY, num, num, directionMap[sprite_mc["decorType"]], 50, 150 + Math.random() * 50, 750, () => {
                                sprite_mc['-activeBubbles-']--;
                            });
                        }
                    }
                    sprite_mc['-ticker-']++;
                    sprite_mc['-ticker-'] %= 10;
                }
            }
            synchronizeGravity() {
                this.scene.physics.world.gravity.set(0, this.gameplay.calculateGravity());
            }
            switchGravity() {
                this.gameplay.gravityDir *= -1;
                this.synchronizeGravity();
                this.player.updateBodyFlipY();
                this.player.updateBodyOffset();
                this.player.playForcedFlyAnimation();
                let sprites = this.getAllSprites();
                for (let sprite_mc of sprites) {
                    if (this.isSpriteGravityAllowed(sprite_mc)) {
                        sprite_mc.setImmovable(false);
                        if (this.gameplay.isGravityFlipped()) {
                            sprite_mc.flipY = true;
                            sprite_mc.body.offset.y = sprite_mc.body.offset['-yFlipped-'];
                        }
                        else {
                            sprite_mc.flipY = false;
                            sprite_mc.body.offset.y = sprite_mc.body.offset['-y-'];
                        }
                    }
                }
                this.showWhiteSplashScreen();
                nscs.sound.SoundManager.getInstance().playSound('gravitySND');
            }
            pipeTravel(pipeRoute, inDirection) {
                if (this.isPipeTravelingActive)
                    return;
                // init
                var newWorldId = null;
                var enterAniAxis = 'down';
                var newX = 0;
                var newY = 0;
                switch (pipeRoute) {
                    ////////////////// LEVEL 1 PIPES ///////////////////
                    // shortcut
                    case '1-1':
                        newX = 1316;
                        newY = 287;
                        enterAniAxis = 'left';
                        break;
                    // shortcut
                    case '1-2':
                        newX = 2175;
                        newY = 1231;
                        enterAniAxis = 'down';
                        break;
                    // shortcut
                    case '1-3':
                        newX = 2239;
                        newY = 206;
                        enterAniAxis = 'down';
                        break;
                    ////////////////// LEVEL 2 PIPES ///////////////////
                    // shortcut
                    case '2-1':
                        newX = 608;
                        newY = 431;
                        enterAniAxis = 'down';
                        break;
                    // shortcut
                    case '2-2':
                        newX = 545;
                        newY = 1407;
                        enterAniAxis = 'up';
                        break;
                    // to part 2 of level 2
                    case '2-3':
                        newWorldId = '2.1';
                        newX = 99;
                        newY = 846;
                        enterAniAxis = 'down';
                        break;
                    // to part 3 of level 2
                    case '2-4':
                        newWorldId = '2.2';
                        newX = 1244;
                        newY = 1275;
                        enterAniAxis = 'right';
                        break;
                    /////////////////////////// LEVEL 3 PIPES ///////////////////////////
                    // shortcut
                    case '3-1':
                        newX = 735;
                        newY = 687;
                        enterAniAxis = 'down';
                        break;
                    // shortcut
                    case '3-2':
                        newX = 255;
                        newY = 639;
                        enterAniAxis = 'up';
                        break;
                    /////////////////////////// LEVEL 4 PIPES ////////////////////////////
                    // level 4 hidden level
                    case '4-1':
                        newWorldId = '4.1';
                        newX = 1370;
                        newY = 176;
                        enterAniAxis = 'down';
                        break;
                    // hidden level shortcut
                    case '4-2':
                        newX = 1376;
                        newY = 718;
                        enterAniAxis = 'down';
                        break;
                    // return to level 4 from hidden level
                    case '4-3':
                        newWorldId = '4';
                        newX = 1535;
                        newY = 1214;
                        enterAniAxis = 'up';
                        break;
                    // level 5 shortcut
                    case '5-1':
                        newX = 383;
                        newY = 687;
                        enterAniAxis = 'down';
                        break;
                    // level 5 hidden level ###
                    case '5-2':
                        newX = 2143;
                        newY = 623;
                        enterAniAxis = 'down';
                        break;
                    // to final boss level
                    case '5-3':
                        newX = 1214;
                        newY = 847;
                        newWorldId = '5.1';
                        enterAniAxis = 'down';
                        break;
                }
                let doNotResetTimerFlag = true;
                // accomodate for height difference:
                if (enterAniAxis == 'down' && newY)
                    newY += 16;
                let dSize = this.gameplay.charSize == 'small' ? 35 : 40;
                if (enterAniAxis == "left")
                    newX += dSize;
                else if (enterAniAxis == "right")
                    newX -= dSize;
                this.player.goInOutPipe(inDirection, dSize, () => {
                    this.showBlackFGFading(() => {
                        if (newWorldId) {
                            nscs.scene.MainScene.instance.gameplay.loadWorld(newWorldId, false, false, true);
                            let newGameScreen = nscs.scene.MainScene.instance.gameplay.gameScreen;
                            newGameScreen.player.setWorldPosition(newX, newY);
                            newGameScreen.isPipeTravelingActive = true;
                            newGameScreen.player.goInOutPipe(enterAniAxis, dSize, () => {
                                newGameScreen.isPipeTravelingActive = false;
                                newGameScreen.player.resetPipeGoing();
                            });
                            this.isPipeTravelingActive = false;
                        }
                        else {
                            this.player.setWorldPosition(newX, newY);
                            this.isPipeTravelingActive = true;
                            this.player.goInOutPipe(enterAniAxis, dSize, () => {
                                this.isPipeTravelingActive = false;
                            });
                            this.player.resetPipeGoing();
                        }
                    });
                });
                nscs.sound.SoundManager.getInstance().playSound('pipeSND');
            }
            fetchRecoveryPoints() {
                this.recoverySprites = [];
                let ch = this.getAllSprites();
                for (let c of ch) {
                    if (c["decorType"] == 'recovery') {
                        this.recoverySprites.push(c);
                    }
                }
            }
            findClosestActiveRecoveryPoint() {
                let minDist = Number.MAX_VALUE;
                let closest = { x: this.gameplay.newX, y: this.gameplay.newY };
                for (let r of this.recoverySprites) {
                    if (r['-active-']) {
                        let d = Phaser.Math.Distance.Between(this.player.sprite.x, this.player.sprite.y, r.x, r.y);
                        if (d < minDist) {
                            minDist = d;
                            closest = r;
                        }
                    }
                }
                return closest;
            }
            getAllSprites() {
                this.reusedArray.splice(0, this.reusedArray.length);
                this.reusedArray = this.reusedArray.concat(this.spritesBackLayer.getAll()).concat(this.spritesTopLayer.getAll());
                return this.reusedArray;
            }
            onFlagReached() {
                if (this.isFlagReached)
                    return;
                nscs.scene.MainScene.instance.factory.playAnimation(this.finishFlag, this.boss ? "boss-flag-reached" : "normal-flag-reached");
                nscs.sound.SoundManager.getInstance().playSound('flagHitSND');
                this.player.isFlagReached = true;
                this.isFlagReached = true;
                this.gameplay.calculateTotalScore();
                this.inGameUI.tweenScore(this.gameplay.score, 3000);
                this.inGameUI.tweenTimer(0, 3000);
                this.gameplay.destroyTimer();
                nscs.util.Functions.delayedCall(4000, () => {
                    nscs.scene.MainScene.instance.proceedLevelComplete();
                });
                nscs.sound.SoundManager.getInstance().playSound('levelCompleteSND');
            }
            checkFlagReached() {
                if (!this.finishFlag)
                    return;
                if (!this.finishFlag.visible)
                    return;
                let collide = this.scene.physics.world.collide(this.player.sprite, this.finishFlag["flagPoleMC"]);
                if (collide) {
                    this.onFlagReached();
                }
            }
            updateSprites() {
                let ch = this.getAllSprites();
                for (let sprite_mc of ch) {
                    let spriteType = sprite_mc["spriteType"];
                    if (spriteType == 'E') {
                        this.updateEnemy(sprite_mc);
                    }
                    else if (spriteType == 'H') {
                        this.updateHazzard(sprite_mc);
                    }
                    else if (spriteType == 'C') {
                        this.updateChick(sprite_mc);
                    }
                    else if (spriteType == 'D') {
                        this.updateDecor(sprite_mc);
                    }
                    else if (spriteType == 'B') {
                        this.updateBlock(sprite_mc);
                    }
                }
            }
            onContactWithStaticObject(staticObject) {
                if (this.gameplay.isGravityFlipped() ?
                    this.player.sprite.body.touching.up && staticObject.body['touching'].down :
                    this.player.sprite.body.touching.down && staticObject.body['touching'].up) {
                    this.player.contactDownWithStaticObject = true;
                }
                if (this.player.sprite.body.touching.left && staticObject.body['touching'].right) {
                    this.player.contactLeftWithStaticObject = true;
                }
                if (this.player.sprite.body.touching.right && staticObject.body['touching'].left) {
                    this.player.contactRightWithStaticObject = true;
                }
            }
            updateLadder() {
                let inputController = nscs.scene.MainScene.instance.inputController;
                //ladder blocks
                let contactWithLadding = false;
                for (let l of this.ladderArray) {
                    let i = l["-grid-i-"];
                    let j = l["-grid-j-"];
                    let overlaps = this.scene.physics.world.overlap(this.player.sprite, l);
                    if (overlaps) {
                        if (i == 0 || Number(this.gameplay.ladder_array[this.gameplay.grid[i - 1][j]]) != 1) {
                            if (this.gameplay.isGravityFlipped() ?
                                this.player.sprite.body.touching.up && l.body['touching'].down && !(inputController.cursorKeys.up.isDown || nscs.input.InputManager.instance.isDown('UP')) :
                                this.player.sprite.body.touching.down && l.body['touching'].up && !(inputController.cursorKeys.down.isDown || nscs.input.InputManager.instance.isDown('DOWN'))) {
                                if (this.scene.physics.world.collide(this.player.sprite, l)) {
                                    this.onContactWithStaticObject(l);
                                }
                            }
                        }
                        let dx = this.player.sprite.x - l['x'];
                        if (dx < 25 && dx > 9) {
                            contactWithLadding = true;
                        }
                    }
                }
                if (contactWithLadding) {
                    if (!this.player.isPlayerLadding) {
                        if ((inputController.cursorKeys.up.isDown || nscs.input.InputManager.instance.isDown('UP')) || (inputController.cursorKeys.down.isDown || nscs.input.InputManager.instance.isDown('DOWN'))) {
                            this.player.isPlayerLadding = true;
                        }
                    }
                }
                else {
                    this.player.isPlayerLadding = false;
                }
            }
            showFallingCharacter(onComplete) {
                this.gameplay.pause();
                this.remove(this.player.sprite, false);
                this.addAt(this.player.sprite, this.getIndex(this.spritesTopLayer) + 1);
                this.scene.tweens.add({
                    targets: this.player.sprite,
                    y: this.player.sprite.y - (this.gameplay.isGravityFlipped() ? 200 : 125),
                    duration: 500,
                    ease: Phaser.Math.Easing.Sine.Out,
                    onComplete: () => {
                        let prevFlipY = this.player.sprite.flipY;
                        this.player.sprite.flipY = false;
                        this.scene.tweens.add({
                            targets: this.player.sprite,
                            y: this.player.sprite.y + game.scale.height,
                            duration: 750,
                            ease: Phaser.Math.Easing.Sine.In,
                            onComplete: () => {
                                this.player.sprite.flipY = prevFlipY;
                                onComplete();
                            }
                        });
                    }
                });
                nscs.sound.SoundManager.getInstance().playSound('dyingSND');
            }
            showGameOverScreen() {
                this.gameplay.destroyTimer();
                let gos = new nscs.screen.GameOverScreen(this.scene);
                nscs.scene.MainScene.instance.switchScreen(gos, true);
                nscs.sound.SoundManager.getInstance().stopMusic();
                nscs.sound.SoundManager.getInstance().playSound('gameoverSND');
            }
            onTimeout() {
                this.inGameUI.timeover_mc.visible = true;
                this.player.setTempDead(true);
                this.stopFollowCamera();
                this.showFallingCharacter(() => {
                    this.showGameOverScreen();
                });
            }
            tryMinusOneLife() {
                if (this.player.fullyActive() && !this.isFlagReached) {
                    this.minusOneLife();
                }
            }
            showNewGameNewWorldScreen() {
                this.inGameUI.showNewWorldScreen();
                nscs.util.Functions.delayedCall(2000, () => {
                    this.showBlackFGFading(() => {
                        this.inGameUI.hideNewWorldScreen();
                    });
                });
                nscs.sound.SoundManager.getInstance().playSound('gamestartSND');
            }
            minusOneLife() {
                this.gameplay.minusLife();
                this.player.minusOneLife();
                let closest = this.findClosestActiveRecoveryPoint();
                this.stopFollowCamera();
                this.showFallingCharacter(() => {
                    if (this.gameplay.lives == 0) {
                        sendEvent(petaGA_GameCategory_Game, 'Die', 'New Super Chick Sisters - Die World ' + nscs.scene.MainScene.instance.getWorldNumber());
                        this.showGameOverScreen();
                    }
                    else {
                        this.inGameUI.showNewWorldScreen();
                        nscs.util.Functions.delayedCall(2000, () => this.showBlackFGFading(() => {
                            this.remove(this.player.sprite, false);
                            this.addAt(this.player.sprite, this.getIndex(this.spritesTopLayer));
                            this.player.respawn(closest['x'], closest['y']);
                            this.startFollowCamera();
                            this.inGameUI.hideNewWorldScreen();
                            this.gameplay.resume();
                        }));
                    }
                });
            }
            showBlackFGFading(onMid) {
                this.showFGFading(onMid, 250, 500, 0x000000);
            }
            showWhiteSplashScreen() {
                this.showFGFading(null, 40, 120, 0xFFFFFF);
            }
            showFGFading(onMid, druationIn, durationOut, color) {
                let transition = this.createShape(color);
                this.inGameUI.add(transition);
                transition.alpha = 0;
                this.scene.tweens.add({
                    targets: transition,
                    alpha: 1,
                    duration: druationIn,
                    ease: Phaser.Math.Easing.Linear,
                    onComplete: () => {
                        if (onMid)
                            onMid();
                        this.scene.tweens.add({
                            targets: transition,
                            alpha: 0,
                            duration: durationOut,
                            ease: Phaser.Math.Easing.Linear,
                            onComplete: () => {
                                this.inGameUI.remove(transition, true);
                            }
                        });
                    }
                });
            }
            onPreRender(renderer, time, delta) {
                if (!this.parentContainer)
                    return;
                this.player.updateSeaKitten();
            }
            onRemovedFromParent() {
                // this.stopFollowCamera();
                // this.playerToGridCollider.active = false;
            }
            onAddedToParent() {
                // this.playerToGridCollider.active = true;
                this.startFollowCamera();
                this.player.setup();
            }
            destroy(fromScene) {
                this.scene.game.events.off('prerender', this.onPreRender, this);
                this.setPaused(false);
                if (this.shackleBirdContainer) {
                    for (let s of this.shackleBirdContainer.getAll()) {
                        this.scene.tweens.killTweensOf(s);
                    }
                }
                this.scene.cameras.resetAll();
                if (this.recentEnemyKillsNumberDelayedCall) {
                    nscs.util.Functions.destroyDelayedCall(this.recentEnemyKillsNumberDelayedCall);
                    this.recentEnemyKillsNumberDelayedCall = null;
                }
                super.destroy(fromScene);
                nscs.input.InputManager.instance.destroy();
            }
            generatePlayerWaterBubbles() {
                this.showBubbles(this.player.sprite.x, this.player.getFootsWorldY() - 5 * this.gameplay.gravityDir, 1, 4, this.gameplay.isGravityFlipped() ? 'down' : 'up', 10, 75 + Math.random() * 50, 1000, null);
            }
            updateBubbles() {
                if (!this.gameplay.inWater)
                    return;
                if (this.ticker % 15 == 0 && Math.random() > 0.6) {
                    if (Math.abs(this.player.sprite.body.velocity.x) > Math.abs(this.gameplay.xSpeed) * 0.5 || Math.random() > 0.75) {
                        this.generatePlayerWaterBubbles();
                    }
                }
                for (let i = this.activeBubbles.length - 1; i >= 0; i--) {
                    if (!this.isPointInWater(this.activeBubbles[i].x, this.activeBubbles[i].y)) {
                        this.destroyBubble(this.activeBubbles[i]);
                    }
                }
            }
            updateBoss() {
                if (!this.boss)
                    return;
                this.boss.updateBoss();
            }
            isPointInWater(x, y) {
                let inWater = y > this.gameplay.waterLevel;
                if (this.gameplay.waterRects) {
                    for (let r of this.gameplay.waterRects) {
                        if ((x > r['p1'].x && y > r['p1'].y) && (x < r['p2'].x && y > r['p2'].y)
                            &&
                                (x > r['p4'].x && y < r['p4'].y) && (x < r['p3'].x && y < r['p3'].y)) {
                            inWater = true;
                            break;
                        }
                    }
                }
                return inWater;
            }
            updateInWater() {
                let prevInWater = this.gameplay.inWater;
                this.gameplay.inWater = this.isPointInWater(this.player.sprite.x, this.player.getFootsWorldY());
                if (prevInWater != this.gameplay.inWater) {
                    this.gameplay.updateWaterPhysics();
                    this.synchronizeGravity();
                    if (this.gameplay.inWater) {
                        this.generatePlayerWaterBubbles();
                        nscs.sound.SoundManager.getInstance().playSound('splashdownSND');
                        this.player.sprite.body.velocity.y /= 5;
                    }
                    else {
                        this.player.sprite.body.velocity.y *= 2.2;
                    }
                }
            }
            updateScreen() {
                super.updateScreen();
                this.updateEnemy4MC();
                if (this.player.tempDead)
                    return;
                this.updateBG();
                this.ticker++;
                this.updateTofu();
                this.updateSeakitten();
                this.updateLadder();
                this.updateSprites();
                this.player.update();
                this.updateBoss();
                if (this.player.fallenBelowTheWorld) {
                    this.tryMinusOneLife();
                }
                this.updateInWater();
                this.checkFlagReached();
                if (this.shceduleGravitySwitching) {
                    this.shceduleGravitySwitching = false;
                    this.switchGravity();
                }
                this.updateBubbles();
                this.updatePause();
            }
            updatePause() {
                let esc = nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased();
                if (esc) {
                    this.setPaused(!this.isPaused);
                    nscs.scene.MainScene.instance.inputController.escPressUsed();
                }
            }
            setPaused(paused) {
                this.isPaused = paused;
                if (this.isPaused) {
                    this.scene.physics.pause();
                    this.scene.anims.pauseAll();
                    this.scene.tweens.pauseAll();
                    this.scene.time.paused = true;
                    this.inGameUI.pauseScreen.showPauseGame();
                    nscs.sound.SoundManager.getInstance().fadeMusic(null, 500);
                }
                else {
                    this.scene.physics.resume();
                    this.scene.anims.resumeAll();
                    this.scene.tweens.resumeAll();
                    this.scene.time.paused = false;
                    this.inGameUI.pauseScreen.hidePauseGame();
                    nscs.sound.SoundManager.getInstance().revertMusic(500);
                }
            }
            updateBG() {
                let offx = this.player.sprite.x - 240;
                let offy = this.player.getFootsWorldY() - ((this.gameplay.gravityDir > 0) ? 181 : 135);
                if (offx < 0)
                    offx = 0;
                if (offx > this.gameplay.worldWidth - 480)
                    offx = this.gameplay.worldWidth - 480;
                if (offy < 0)
                    offy = 0;
                if (offy > this.gameplay.worldHeight - 320)
                    offy = this.gameplay.worldHeight - 320;
                this.bg.setPosition(-offx / 5, -offy / 5);
                this.fg.setPosition(-offx / 2, -offy / 2);
            }
        }
        screen.GameScreen = GameScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class HigscoreScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                this.bg = new Phaser.GameObjects.Container(this.scene, 0, -200, [
                    new Phaser.GameObjects.Image(this.scene, 0, 50, 'bg-atlas', 'bg1_bg0000').setOrigin(0, 0),
                    new Phaser.GameObjects.Image(this.scene, 728, 50, 'bg-atlas', 'bg1_bg0000').setOrigin(0, 0),
                ]);
                this.add(this.bg);
                this.bg.x = 0;
                this.scene.tweens.add({
                    targets: this.bg,
                    x: -728,
                    duration: 40000,
                    ease: Phaser.Math.Easing.Linear,
                    repeat: -1
                });
                this.hs_top_bg = new Phaser.GameObjects.Container(this.scene, 240, 60, [
                    new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'hs_top_bg0000')
                ]);
                this.add(this.hs_top_bg);
                let hs_label = this.scene.add.text(0, -3, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 35,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                hs_label.setOrigin(0.5, 0.5);
                this.hs_top_bg.add(hs_label);
                nscs.gameplay.Gameplay.setText(hs_label, 'HighScoresTitle');
                this.btnCancel = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.btnCancel);
                this.btnCancel.add(this.btnCancel['-img-'] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'btn_back' + '0000'));
                let cancel_label = this.scene.add.text(0, -5, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 19,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                cancel_label.setOrigin(0.5, 0.5);
                this.btnCancel.add(cancel_label);
                nscs.gameplay.Gameplay.setText(cancel_label, 'CancelBtn');
                this.btnRetry = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.btnRetry);
                this.btnRetry.add(this.btnRetry['-img-'] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'btn_back' + '0000'));
                let retry_label = this.scene.add.text(0, -5, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 19,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                retry_label.setOrigin(0.5, 0.5);
                this.btnRetry.add(retry_label);
                nscs.gameplay.Gameplay.setText(retry_label, 'RetryBtn');
                this.txt = this.scene.add.text(game.scale.width / 2, 0, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 13,
                    "color": "#00436F",
                    "align": 'center'
                });
                this.txt.setOrigin(0.5, 0.5);
                this.add(this.txt);
                this.txt.setLineSpacing(5);
                this.txt.setWordWrapWidth(275);
                this.btnCancel['-img-'].setInteractive({ cursor: 'pointer' });
                this.btnCancel['-img-'].once('pointerup', () => {
                    nscs.scene.MainScene.instance.switchScreen(new nscs.screen.MainMenuScreen(this.scene));
                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                });
                this.btnRetry['-img-'].setInteractive({ cursor: 'pointer' });
                this.btnRetry['-img-'].on('pointerup', () => {
                    this.switchState(true);
                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                });
                this.switchState(true);
            }
            switchState(loading) {
                if (loading) {
                    this.btnCancel.x = game.scale.width / 2;
                    this.btnCancel.y = 210;
                    this.btnRetry.visible = false;
                    this.txt.y = 160;
                    nscs.gameplay.Gameplay.setText(this.txt, 'HighScoresConnecting');
                    this.hs_top_bg.visible = false;
                    nscs.util.Functions.delayedCall(5000, () => {
                        if (!this.parentContainer)
                            return;
                        this.switchState(false);
                    });
                }
                else {
                    this.btnCancel.x = game.scale.width / 2 - 90;
                    this.btnCancel.y = 250;
                    this.btnRetry.x = game.scale.width / 2 + 90;
                    this.btnRetry.y = 250;
                    this.btnRetry.visible = true;
                    this.txt.y = 150;
                    nscs.gameplay.Gameplay.setText(this.txt, 'HighScoresUnreachable');
                    this.hs_top_bg.visible = true;
                }
            }
        }
        screen.HigscoreScreen = HigscoreScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class InGameUI extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                this.speechDialog = null;
                this.bg = new Phaser.GameObjects.Graphics(this.scene);
                this.bg.setPosition(0, 0);
                this.bg.fillStyle(0x000000, 1);
                this.bg.fillRect(0, 0, game.scale.width, game.scale.height);
                this.add(this.bg);
                this.bg.visible = false;
                //---------------------topUI---------------------//
                this.topUI = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.topUI);
                this.charName_txt = this.scene.add.text(9, 9, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'left',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.charName_txt.setOrigin(0, 0.5);
                this.topUI.add(this.charName_txt);
                this.score_txt = this.scene.add.text(9, 27, "0000000", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'left',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.score_txt.setOrigin(0, 0.5);
                this.topUI.add(this.score_txt);
                let x_txt = this.scene.add.text(170, 27, "x", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'left',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                x_txt.setOrigin(0.5, 0.5);
                this.topUI.add(x_txt);
                this.topUI.add(new Phaser.GameObjects.Image(this.scene, 145, 27, 'objects-atlas', 'tinyChickMC0000'));
                this.chicks_txt = this.scene.add.text(185, 27, "00", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'left',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.chicks_txt.setOrigin(0, 0.5);
                this.topUI.add(this.chicks_txt);
                this.World_txt = this.scene.add.text(305, 9, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'center',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.World_txt.setOrigin(0.5, 0.5);
                this.topUI.add(this.World_txt);
                nscs.gameplay.Gameplay.setText(this.World_txt, 'World');
                this.world_txt = this.scene.add.text(305, 27, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'center',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.world_txt.setOrigin(0.5, 0.5);
                this.topUI.add(this.world_txt);
                this.Time_txt = this.scene.add.text(470, 9, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'right',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.Time_txt.setOrigin(1, 0.5);
                this.topUI.add(this.Time_txt);
                nscs.gameplay.Gameplay.setText(this.Time_txt, 'Time');
                this.timer_txt = this.scene.add.text(470, 27, "0", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'right',
                    "stroke": "#000000",
                    "strokeThickness": 2
                });
                this.timer_txt.setOrigin(1, 0.5);
                this.topUI.add(this.timer_txt);
                //---------------------newWorldScreen_mc---------------------//
                this.newWorldScreen_mc = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.newWorldScreen_mc);
                let World_txt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2 - 25, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 25,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                World_txt.setOrigin(0.5, 0.5);
                this.newWorldScreen_mc.add(World_txt);
                nscs.gameplay.Gameplay.setText(World_txt, 'World');
                this.newWorldScreen_mc["World_txt"] = World_txt;
                let charIcon_mc = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 35, game.scale.height / 2 + 25, 'ui-atlas', 'charIcon_mc' + '0000');
                this.newWorldScreen_mc['charIcon_mc'] = charIcon_mc;
                this.newWorldScreen_mc.add(charIcon_mc);
                this.gotoAndStop_charIcon_mc(nscs.scene.MainScene.instance.gameplay.character);
                this.newWorldScreen_mc.add(this.scene.add.text(game.scale.width / 2, game.scale.height / 2 + 25, "x", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 18,
                    "color": "#FFFFFF",
                    "align": 'center'
                }).setOrigin(0.5, 0.5));
                let lives_txt = this.scene.add.text(game.scale.width / 2 + 20, game.scale.height / 2 + 25, "0", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 18,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                lives_txt.setOrigin(0, 0.5);
                this.newWorldScreen_mc.add(lives_txt);
                this.newWorldScreen_mc["lives_txt"] = lives_txt;
                this.newWorldScreen_mc.visible = false;
                //pause
                this.pauseScreen = new nscs.screen.PauseScreen(this.scene);
                this.add(this.pauseScreen);
                //---------------------timeover_mc---------------------//
                this.timeover_mc = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.timeover_mc);
                let bg = new Phaser.GameObjects.Graphics(this.scene);
                bg.setPosition(0, 0);
                bg.fillStyle(0x000000, 0.4);
                bg.fillRect(0, 0, game.scale.width, game.scale.height);
                this.timeover_mc.add(bg);
                let TimeOver_txt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 33,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                TimeOver_txt.setOrigin(0.5, 0.5);
                TimeOver_txt.setStroke('#000000', 3);
                this.timeover_mc.add(TimeOver_txt);
                nscs.gameplay.Gameplay.setText(TimeOver_txt, 'TimeOver');
                this.timeover_mc['TimeOver_txt'] = TimeOver_txt;
                this.timeover_mc.visible = false;
            }
            setScore(scores) {
                this.score_txt.setText(nscs.util.Functions.pad(scores, 7, 0));
            }
            setChicks(chicks) {
                this.chicks_txt.setText(nscs.util.Functions.pad(chicks, 2, 0));
            }
            setCharacterName(characterType, lives) {
                nscs.gameplay.Gameplay.setText(this.charName_txt, characterType);
                this.charName_txt.setText(this.charName_txt.text + " x " + lives);
            }
            showNewWorldScreen() {
                nscs.gameplay.Gameplay.setText(this.newWorldScreen_mc["World_txt"], 'World');
                nscs.util.Functions.updateTextFieldPosition(this.newWorldScreen_mc["World_txt"], this.newWorldScreen_mc["World_txt"].text + " " + this.world_txt.text);
                nscs.util.Functions.updateTextFieldPosition(this.newWorldScreen_mc["lives_txt"], this.charName_txt.text.split(" x ")[1]);
                this.newWorldScreen_mc.visible = true;
                this.bg.visible = true;
                return this;
            }
            hideNewWorldScreen() {
                this.newWorldScreen_mc.visible = false;
                this.bg.visible = false;
                return this;
            }
            gotoAndStop_charIcon_mc(label) {
                let labels_map = {
                    'chickette': 'charIcon_mc' + '0000',
                    'nugget': 'charIcon_mc' + '0009',
                    'pam': 'charIcon_mc' + '0019'
                };
                this.newWorldScreen_mc['charIcon_mc'].setFrame(labels_map[label]);
                return this;
            }
            showSpeechDialog(x, textContent) {
                this.hideSpeechDialog();
                this.speechDialog = new Phaser.GameObjects.Container(this.scene, game.scale.width / 2, 136);
                this.add(this.speechDialog);
                this.speechDialog['startX'] = x;
                let bubblex_mc = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'bubblex_mc' + '0000');
                bubblex_mc.setOrigin(0.5, 1);
                this.speechDialog.add(bubblex_mc);
                this.speechDialog["bubblex_mc"] = bubblex_mc;
                let mouthPiece_mc = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'mouthPiece_mc' + '0000');
                mouthPiece_mc.setOrigin(0.5, 1);
                this.speechDialog.add(mouthPiece_mc);
                this.speechDialog["mouthPiece_mc"] = mouthPiece_mc;
                let barMask = new Phaser.GameObjects.Graphics(this.scene);
                let p = this.scene.cameras.main.getWorldPoint(this.speechDialog.x, this.speechDialog.y);
                barMask.setPosition(p.x, p.y);
                barMask.fillStyle(0xFFFFFF, 1);
                barMask.fillRect(-400 / 2, -mouthPiece_mc.height, 400, mouthPiece_mc.height);
                mouthPiece_mc.setMask(barMask.createGeometryMask());
                mouthPiece_mc['barMask'] = barMask;
                this.prevBarMaskPosX = barMask.x;
                this.speechDialog.alpha = 0.5;
                barMask.scale = this.speechDialog.scale = 0;
                this.scene.tweens.add({
                    targets: [this.speechDialog, barMask],
                    duration: 500,
                    scale: 1,
                    alpha: 1,
                    ease: Phaser.Math.Easing.Back.Out
                });
                this.add(this.speechDialog);
                let tf = this.scene.add.text(-222, -120, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#000000",
                    "align": 'left'
                });
                tf.setOrigin(0, 0);
                tf.setWordWrapWidth(455);
                this.speechDialog.add(tf);
                let textTyper = new nscs.util.TextTyper(this.scene, tf, null);
                textTyper.typeText(textContent);
                this.speechDialog['textTyper'] = textTyper;
            }
            updateSpeechDialog(x) {
                let p = this.scene.cameras.main.getWorldPoint(this.speechDialog.x, this.speechDialog.y);
                this.speechDialog["mouthPiece_mc"]['barMask'].setPosition(this.prevBarMaskPosX + (p.x - this.prevBarMaskPosX) * 2, p.y);
                this.prevBarMaskPosX = p.x;
                this.speechDialog["mouthPiece_mc"].x = this.speechDialog['startX'] - x;
            }
            hideSpeechDialog() {
                if (this.speechDialog) {
                    this.speechDialog['textTyper'].stop();
                    this.remove(this.speechDialog);
                    this.speechDialog = null;
                }
            }
            tweenTextField(txt, to, duration, render = null) {
                txt['-to-'] = parseInt(txt.text);
                if (isNaN(txt['-to-']))
                    txt['-to-'] = 0;
                if (!render)
                    render = () => {
                        nscs.util.Functions.updateTextFieldPosition(txt, String(Math.round(txt['-to-'])));
                    };
                let ticker = 0;
                this.scene.tweens.add({
                    targets: txt,
                    '-to-': to,
                    duration: duration,
                    ease: Phaser.Math.Easing.Linear,
                    onComplete: render,
                    onUpdate: () => {
                        if (ticker++ % 2 == 0)
                            nscs.sound.SoundManager.getInstance().playSound('tickerSND');
                        render();
                    }
                });
            }
            tweenScore(to, duration) {
                this.tweenTextField(this.score_txt, to, duration, () => {
                    this.setScore(Math.round(this.score_txt['-to-']));
                });
            }
            tweenTimer(to, duration) {
                this.tweenTextField(this.timer_txt, to, duration);
            }
        }
        screen.InGameUI = InGameUI;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class InstructionScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                this.alreadySkipped = false;
                this.skip = () => {
                    if (this.alreadySkipped)
                        return;
                    this.alreadySkipped = true;
                    nscs.scene.MainScene.instance.switchScreen(new nscs.screen.KidFriendlyScreen(this.scene));
                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                };
                this.bg = new Phaser.GameObjects.Image(this.scene, -1, -1, 'ui-atlas', 'bg_story' + '0000');
                this.bg.setOrigin(0, 0);
                this.add(this.bg);
                this.bg.setInteractive({ cursor: 'pointer' });
                this.bg.once('pointerup', this.skip);
                this.nextBtn = new Phaser.GameObjects.Image(this.scene, 330, 290, 'ui-atlas', 'btn_next_story' + '0000');
                this.add(this.nextBtn);
                this.nextBtn.setInteractive({ cursor: 'pointer' });
                this.nextBtn.once('pointerup', this.skip);
                let label_next = this.scene.add.text(this.nextBtn.x, this.nextBtn.y - 5, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 22,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                label_next.setOrigin(0.5, 0.5);
                this.add(label_next);
                nscs.gameplay.Gameplay.setText(label_next, 'NextBtn');
                let label_Instruct1 = this.scene.add.text(30, 25, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                label_Instruct1.setWordWrapWidth(290);
                this.add(label_Instruct1);
                nscs.gameplay.Gameplay.setText(label_Instruct1, 'Instruct1');
                let label_Instruct2 = this.scene.add.text(160, 180, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                label_Instruct2.setWordWrapWidth(290);
                this.add(label_Instruct2);
                nscs.gameplay.Gameplay.setText(label_Instruct2, 'Instruct2');
                let lost_burger = new Phaser.GameObjects.Image(this.scene, 400, 120, 'ui-atlas', 'lost_burger' + '0000');
                this.add(lost_burger);
                this.ronald_mc = this.scene.add.sprite(lost_burger.x - 10, lost_burger.y - 35, 'ui-atlas', 'ronald_mc0000');
                let ronald_mc_anims = {
                    'appear': { start: 0, end: 37 },
                    'disappear': { start: 38, end: 70 },
                    'disappeared': { start: 71, end: 83 },
                    'hit': { start: 84, end: 255 },
                    'idle': { start: 256, end: 798 },
                    'laugh': { start: 799, end: 884 },
                    'midLaugh': { start: 826, end: 884 }
                };
                for (let an in ronald_mc_anims) {
                    if (!this.scene.anims.exists(an)) {
                        this.scene.anims.create({
                            key: an,
                            frames: this.scene.anims.generateFrameNames('ui-atlas', {
                                start: ronald_mc_anims[an]['start'], end: ronald_mc_anims[an]['end'], zeroPad: 4,
                                prefix: 'ronald_mc', suffix: ''
                            }),
                            frameRate: 60
                        });
                    }
                }
                this.ronald_mc.play('idle');
                this.add(this.ronald_mc);
                let eyes_mc = new Phaser.GameObjects.Image(this.scene, this.ronald_mc.x - 13, this.ronald_mc.y - 30, 'ui-atlas', 'eyes_mc' + '0000');
                this.add(eyes_mc);
                let eyes_mc_anim = () => {
                    if (eyes_mc.frame.name == 'eyes_mc' + '0000') {
                        nscs.util.Functions.delayedCall(250, eyes_mc_anim);
                        eyes_mc.setFrame('eyes_mc' + '0001');
                    }
                    else {
                        nscs.util.Functions.delayedCall(Math.ceil(Math.random() * 3) * 1000, eyes_mc_anim);
                        eyes_mc.setFrame('eyes_mc' + '0000');
                    }
                };
                eyes_mc_anim();
                let fn = () => {
                    this.dc = nscs.util.Functions.delayedCall(Math.ceil(Math.random() * 3) * 1000, fn);
                    if (Math.random() > 0.85) {
                        this.ronald_mc.play('laugh');
                        nscs.sound.SoundManager.getInstance().playSound(Phaser.Utils.Array.GetRandom(['laugh1SND', 'laugh2SND', 'laugh3SND']));
                        eyes_mc.visible = false;
                    }
                    else {
                        this.ronald_mc.play('idle');
                        eyes_mc.visible = true;
                    }
                };
                fn();
            }
            destroy(fromScene) {
                nscs.util.Functions.destroyDelayedCall(this.dc);
                super.destroy(fromScene);
            }
            updateScreen() {
                super.updateScreen();
                if (!this.alreadySkipped) {
                    if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                        nscs.scene.MainScene.instance.inputController.escPressUsed();
                        nscs.scene.MainScene.instance.switchScreen(new screen.MainMenuScreen(this.scene));
                    }
                }
            }
        }
        screen.InstructionScreen = InstructionScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class KidFriendlyScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                this.alreadyChoosen = false;
                this.add(new Phaser.GameObjects.Image(this.scene, -1, -1, 'ui-atlas', 'kidFriendly_bg' + '0000').setOrigin(0, 0));
                let normalBtn = new Phaser.GameObjects.Image(this.scene, 240, 93, 'ui-atlas', 'hs_top_bg' + '0000');
                normalBtn.setScale(0.95, 1);
                normalBtn.alpha = 0.01;
                this.add(normalBtn);
                let kidFriendly = new Phaser.GameObjects.Image(this.scene, 240, 245, 'ui-atlas', 'hs_top_bg' + '0000');
                kidFriendly.setScale(0.95, 1);
                kidFriendly.alpha = 0.01;
                this.add(kidFriendly);
                let normal_label = this.scene.add.text(100, 90, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 22,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                normal_label.setOrigin(0, 0.5);
                this.add(normal_label);
                nscs.gameplay.Gameplay.setText(normal_label, 'StartGameBtn');
                let kid_label = this.scene.add.text(130, 237, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 22,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                kid_label.setOrigin(0, 0.5);
                this.add(kid_label);
                nscs.gameplay.Gameplay.setText(kid_label, 'StartKidFriendlyGameBtn');
                if (kid_label.width > 300)
                    kid_label.setScale(300 / kid_label.width);
                normalBtn.setInteractive({ cursor: 'pointer' });
                normalBtn.once('pointerup', () => {
                    this.nextScreen();
                });
                normalBtn.on('pointerover', () => {
                    nscs.sound.SoundManager.getInstance().playSound('whistleSND', 2);
                });
                kidFriendly.setInteractive({ cursor: 'pointer' });
                kidFriendly.once('pointerup', () => {
                    this.nextScreen();
                });
                kidFriendly.on('pointerover', () => {
                    nscs.sound.SoundManager.getInstance().playSound('whistleSND', 2);
                });
            }
            nextScreen() {
                if (this.alreadyChoosen)
                    return;
                this.alreadyChoosen = true;
                nscs.scene.MainScene.instance.switchScreen(new nscs.screen.ChooseCharacterScreen(this.scene));
                nscs.sound.SoundManager.getInstance().playSound('winnerSND');
            }
            updateScreen() {
                super.updateScreen();
                if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                    nscs.scene.MainScene.instance.inputController.escPressUsed();
                    nscs.scene.MainScene.instance.switchScreen(new nscs.screen.InstructionScreen(this.scene));
                }
            }
        }
        screen.KidFriendlyScreen = KidFriendlyScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class MainMenuScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                this.onPamCancel = () => {
                    this.setPamCodeEnterVisible(false);
                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                };
                this.onPamOK = () => {
                    let code = nscs.util.Functions.trim(this.code_txt.getText().toLowerCase());
                    this.setPamCodeEnterVisible(false);
                    let nextWorldNo = -1;
                    switch (code) {
                        // jump to level 1:
                        case 'test1':
                            nextWorldNo = 1;
                            break;
                        // jump to level 2:
                        case 'test2':
                            nextWorldNo = 2;
                            break;
                        // jump to level 2-1:
                        case 'test21':
                            nextWorldNo = 2.1;
                            break;
                        // jump to level 2-2:
                        case 'test22':
                            nextWorldNo = 2.2;
                            break;
                        // jump to level 3:
                        case 'test3':
                            nextWorldNo = 3;
                            break;
                        // jump to level 4:
                        case 'test4':
                            nextWorldNo = 4;
                            break;
                        // jump to level 4:
                        case 'test41':
                            nextWorldNo = 4.1;
                            break;
                        // jump to level 2:
                        case 'test5':
                            nextWorldNo = 5;
                            break;
                        case 'test51':
                            nextWorldNo = 5.1;
                            break;
                        // unlock pam:
                        case 'pamvsmccruelty':
                            nscs.gameplay.Gameplay.isPamLocked = false;
                            nscs.scene.MainScene.instance.playAsPam();
                            nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                            sendEvent(petaGA_GameCategory_Game, 'Enter Code', 'New Super Chick Sisters - Enter Code PamVsMcCruelty');
                            return;
                    }
                    if (nextWorldNo != -1) {
                        nscs.scene.MainScene.instance.resetGameplay();
                        nscs.scene.MainScene.instance.setWorldsNumber(Math.floor(nextWorldNo), String(nextWorldNo));
                        nscs.scene.MainScene.instance.switchScreen(new nscs.screen.KidFriendlyScreen(this.scene));
                        nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                    }
                };
                this.bg = new Phaser.GameObjects.Container(this.scene, 0, -200, [
                    new Phaser.GameObjects.Image(this.scene, 0, 0, 'bg-atlas', 'bg1_bg0000').setOrigin(0, 0),
                    new Phaser.GameObjects.Image(this.scene, 728, 0, 'bg-atlas', 'bg1_bg0000').setOrigin(0, 0),
                ]);
                this.add(this.bg);
                this.bg.x = -730;
                this.scene.tweens.add({
                    targets: this.bg,
                    x: 0,
                    duration: 40000,
                    ease: Phaser.Math.Easing.Linear,
                    repeat: -1
                });
                this.add(new Phaser.GameObjects.Image(this.scene, -200, 240, 'ui-atlas', 'menu_bg_grass' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, 57, 10, 'ui-atlas', 'bg_mc' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, -17, -15, 'ui-atlas', 'scs_logo' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, 260, 140, 'ui-atlas', 'ANI_Chickette_wholeMC' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, 350, 172, 'ui-atlas', 'ANI_Nugget_wholeMC' + '0000').setOrigin(0, 0));
                let scs_logo_blink = this.scene.add.sprite(275, 90, 'ui-atlas');
                scs_logo_blink.setScale(2);
                let scs_logo_blink_anim = 'scs_logo_blink_anim';
                if (!this.scene.anims.exists(scs_logo_blink_anim)) {
                    this.scene.anims.create({
                        key: scs_logo_blink_anim,
                        frames: this.scene.anims.generateFrameNames('ui-atlas', {
                            start: 0, end: 327, zeroPad: 4,
                            prefix: 'scs_logo_blink', suffix: ''
                        }),
                        frameRate: 60,
                        repeat: -1
                    });
                }
                scs_logo_blink.play(scs_logo_blink_anim);
                this.add(scs_logo_blink);
                this.buttons = [];
                let btnStr = ['NewGameBtn', 'EnterCodeBtn' /*, 'HighScoresBtn'*/];
                let i = 0;
                let btnsY = 195 + 16;
                for (let str of btnStr) {
                    let btn = new Phaser.GameObjects.Container(this.scene, 145, btnsY + i * 33);
                    this.buttons.push(btn);
                    let label = this.scene.add.text(-50, -10, "", {
                        "fontFamily": "Helvetica Rounded LT Black",
                        "fontSize": 16,
                        "color": "#000000",
                        "align": 'left'
                    });
                    btn.add(label);
                    nscs.gameplay.Gameplay.setText(label, str);
                    this.add(btn);
                    btn.setSize(130, 37);
                    btn.setInteractive({ cursor: 'pointer' });
                    btn[str == btnStr[0] ? 'once' : 'on']('pointerup', () => {
                        if (str == 'NewGameBtn') {
                            nscs.scene.MainScene.instance.resetGameplay();
                            nscs.scene.MainScene.instance.switchScreen(new nscs.screen.InstructionScreen(scene));
                            nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                            sendEvent(petaGA_GameCategory_Game, 'New Game', 'New Super Chick Sisters - New Game');
                        }
                        else if (str == 'EnterCodeBtn') {
                            this.setPamCodeEnterVisible(true);
                        }
                        else if (str == 'HighScoresBtn') {
                            nscs.scene.MainScene.instance.switchScreen(new nscs.screen.HigscoreScreen(this.scene));
                            nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                            sendEvent(petaGA_GameCategory_Game, 'Click', 'New Super Chick Sisters - High Scores');
                        }
                    });
                    btn.on('pointerover', () => {
                        this.scene.tweens.add({
                            targets: this.chick_mc,
                            y: btn.y,
                            duration: 650,
                            ease: Phaser.Math.Easing.Back.Out
                        });
                        nscs.sound.SoundManager.getInstance().playSound('coinSND', 0.5);
                    });
                    i++;
                }
                this.chick_mc = this.chick_mc = nscs.scene.MainScene.instance.factory.createConstructedObject("tinyChickMC");
                this.chick_mc.setOrigin(0.5, 0.5);
                this.chick_mc.setPosition(70, btnsY);
                this.add(this.chick_mc);
                this.add(MainMenuScreen.createEye(290, 205, this.scene));
                this.add(MainMenuScreen.createEye(320, 205, this.scene));
                this.add(MainMenuScreen.createEye(370, 224, this.scene));
                this.add(MainMenuScreen.createEye(395, 227, this.scene));
                this.enterCodeContainer = new Phaser.GameObjects.Container(this.scene, 150, 235);
                this.add(this.enterCodeContainer);
                this.enterCodeContainer.visible = false;
                let e = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'enterCode_bg' + '0000');
                this.enterCodeContainer.add(e);
                e.setInteractive();
                let enterCode_btn_cancel = new Phaser.GameObjects.Image(this.scene, -50, 33, 'ui-atlas', 'enterCode_btn' + '0000');
                this.enterCodeContainer.add(enterCode_btn_cancel);
                enterCode_btn_cancel.alpha = 0.01;
                let cancel_label = this.scene.add.text(enterCode_btn_cancel.x, enterCode_btn_cancel.y, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 15,
                    "color": "#333333",
                    "align": 'left'
                });
                cancel_label.setOrigin(0.5, 0.5);
                this.enterCodeContainer.add(cancel_label);
                nscs.gameplay.Gameplay.setText(cancel_label, 'CancelBtn');
                let enterCode_btn_ok = new Phaser.GameObjects.Image(this.scene, 65, 33, 'ui-atlas', 'enterCode_btn' + '0000');
                this.enterCodeContainer.add(enterCode_btn_ok);
                enterCode_btn_ok.alpha = 0.01;
                let ok_label = this.scene.add.text(enterCode_btn_ok.x, enterCode_btn_ok.y, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 15,
                    "color": "#333333",
                    "align": 'left'
                });
                ok_label.setOrigin(0.5, 0.5);
                this.enterCodeContainer.add(ok_label);
                nscs.gameplay.Gameplay.setText(ok_label, 'OKBtn');
                let pam_label = this.scene.add.text(0, -40, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 13,
                    "color": "#333333",
                    "align": 'center'
                });
                if (nscs.gameplay.Gameplay.currentLanguage == "ES" || nscs.gameplay.Gameplay.currentLanguage == "SK") {
                    pam_label.y = -49;
                }
                pam_label.setOrigin(0.5, 0);
                this.enterCodeContainer.add(pam_label);
                pam_label.setWordWrapWidth(200);
                nscs.gameplay.Gameplay.setText(pam_label, 'EnterCodePrompt');
                let enterCode_txtinputbg = new Phaser.GameObjects.Image(this.scene, 0, 8, 'ui-atlas', 'enterCode_txtinputbg' + '0000');
                this.enterCodeContainer.add(enterCode_txtinputbg);
                enterCode_btn_cancel.setInteractive({ cursor: 'pointer' });
                enterCode_btn_cancel.on('pointerup', this.onPamCancel);
                enterCode_btn_cancel.on('pointerover', () => {
                    nscs.sound.SoundManager.getInstance().playSound('whistleSND');
                });
                enterCode_btn_ok.setInteractive({ cursor: 'pointer' });
                enterCode_btn_ok.on('pointerup', this.onPamOK);
                enterCode_btn_ok.on('pointerover', () => {
                    nscs.sound.SoundManager.getInstance().playSound('whistleSND');
                });
                this.code_txt = new nscs.input.InputTextField(this.scene);
                this.code_txt.setPosition(-80, enterCode_txtinputbg.y);
                this.enterCodeContainer.add(this.code_txt);
            }
            setPamCodeEnterVisible(visible) {
                this.enterCodeContainer.visible = visible;
                for (let b of this.buttons)
                    b.visible = !visible;
                this.chick_mc.visible = !visible;
                if (visible) {
                    this.code_txt.initializeInput();
                }
                else {
                    this.code_txt.destroyInput();
                }
                this.code_txt.setText('');
            }
            static createEye(x, y, scene, delay = 0) {
                let blinking_eye = scene.add.sprite(x, y, 'ui-atlas', 'blinking_eye0000');
                let blinking_eye_anim = 'blinking_eye_anim';
                if (!scene.anims.exists(blinking_eye_anim)) {
                    scene.anims.create({
                        key: blinking_eye_anim,
                        frames: scene.anims.generateFrameNames('ui-atlas', {
                            start: 0, end: 260, zeroPad: 4,
                            prefix: 'blinking_eye', suffix: ''
                        }),
                        frameRate: 60,
                        repeat: -1
                    });
                }
                nscs.util.Functions.delayedCall(delay, () => {
                    if (!blinking_eye.parentContainer || blinking_eye.parentContainer.parentContainer)
                        return;
                    blinking_eye.play(blinking_eye_anim);
                });
                return blinking_eye;
            }
            updateScreen() {
                super.updateScreen();
                if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                    if (this.enterCodeContainer.visible) {
                        this.setPamCodeEnterVisible(false);
                    }
                    else {
                        nscs.scene.MainScene.instance.switchScreen(new screen.SelectLanguageScreen(this.scene));
                    }
                    nscs.scene.MainScene.instance.inputController.escPressUsed();
                }
                else if (nscs.scene.MainScene.instance.inputController.enterPressedDownAndReleased() && this.enterCodeContainer.visible) {
                    nscs.scene.MainScene.instance.inputController.enterPressUsed();
                    requestAnimationFrame(this.onPamOK);
                }
            }
        }
        screen.MainMenuScreen = MainMenuScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class PauseScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                //---------------------pause---------------------//
                let bg = new Phaser.GameObjects.Graphics(this.scene);
                bg.setPosition(0, 0);
                bg.fillStyle(0x000000, 0.4);
                bg.fillRect(0, 0, game.scale.width, game.scale.height);
                this.add(bg);
                let GamePaused_txt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2 - 25, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 33,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                GamePaused_txt.setOrigin(0.5, 0.5);
                GamePaused_txt.setStroke('#000000', 5);
                this.add(GamePaused_txt);
                nscs.gameplay.Gameplay.setText(GamePaused_txt, 'Paused');
                let _QuitBtn = new Phaser.GameObjects.Image(this.scene, 139, 194, 'ui-atlas', 'btn_next_story' + '0000');
                this.add(_QuitBtn);
                let QuitBtn_txt = this.scene.add.text(_QuitBtn.x, _QuitBtn.y - 5, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 19,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                QuitBtn_txt.setOrigin(0.5, 0.5);
                this.add(QuitBtn_txt);
                nscs.gameplay.Gameplay.setText(QuitBtn_txt, 'QuitBtn');
                let _ResumeBtn = new Phaser.GameObjects.Image(this.scene, 354, 194, 'ui-atlas', 'btn_next_story' + '0000');
                this.add(_ResumeBtn);
                let Resume_txt = this.scene.add.text(_ResumeBtn.x, _ResumeBtn.y - 5, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 19,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                Resume_txt.setOrigin(0.5, 0.5);
                this.add(Resume_txt);
                nscs.gameplay.Gameplay.setText(Resume_txt, 'ResumeBtn');
                _QuitBtn.setInteractive({ cursor: 'pointer' });
                _QuitBtn.on('pointerup', () => {
                    this.onQuit();
                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                });
                _QuitBtn.on('pointerover', () => {
                    nscs.sound.SoundManager.getInstance().playSound('whistleSND');
                });
                _QuitBtn.setScrollFactor(0);
                _ResumeBtn.setInteractive({ cursor: 'pointer' });
                _ResumeBtn.on('pointerup', () => {
                    this.onResume();
                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');
                });
                _ResumeBtn.on('pointerover', () => {
                    nscs.sound.SoundManager.getInstance().playSound('whistleSND');
                });
                _ResumeBtn.setScrollFactor(0);
                this.hidePauseGame();
            }
            showPauseGame() {
                this.visible = true;
            }
            hidePauseGame() {
                this.visible = false;
            }
        }
        screen.PauseScreen = PauseScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class Preloader extends Phaser.GameObjects.Container {
            constructor(scene) {
                super(scene);
                this.add(new Phaser.GameObjects.Image(this.scene, 125, 161, Preloader.ATLAS, 'loaded_mc' + '0000').setOrigin(0, 0));
                this.add(new Phaser.GameObjects.Image(this.scene, 125, 140, Preloader.ATLAS, 'loadingtxt' + '0000').setOrigin(0, 0));
                let preloader_burger = new Phaser.GameObjects.Sprite(this.scene, 305, 130, Preloader.ATLAS, 'preloader_burger' + '0000');
                let preloader_burger_playing = 'preloader_burger_playing';
                this.scene.anims.create({
                    key: preloader_burger_playing,
                    frames: this.scene.anims.generateFrameNames(Preloader.ATLAS, {
                        start: 0, end: 69, zeroPad: 4,
                        prefix: 'preloader_burger', suffix: ''
                    }),
                    frameRate: 24, repeat: -1
                });
                preloader_burger.anims.play(preloader_burger_playing);
                this.add(preloader_burger);
                this.bar = new Phaser.GameObjects.Image(this.scene, 125, 161, Preloader.ATLAS, 'preloader_bar' + '0000');
                this.bar.setOrigin(0, 0);
                this.add(this.bar);
                this.barMask = new Phaser.GameObjects.Graphics(this.scene);
                this.barMask.setPosition(this.bar.x, this.bar.y);
                this.barMask.fillStyle(0xFFFFFF, 1);
                this.barMask.fillRect(0, 0, this.bar.width, this.bar.height);
                this.bar.setMask(this.barMask.createGeometryMask());
            }
            updateProgress(progress) {
                this.barMask.scaleX = progress;
            }
        }
        Preloader.ATLAS = 'preloader-atlas';
        screen.Preloader = Preloader;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class SelectLanguageScreen extends screen.BaseScreen {
            constructor(scene) {
                super(scene);
                this.add(new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', '_selectLanguageBG_' + '0000').setOrigin(0, 0));
                this.buttons = {};
                let i = 0;
                for (let lang in SelectLanguageScreen.LANGUAGUES) {
                    let btn = new Phaser.GameObjects.Container(this.scene, 125, 60 + i * 39);
                    let label = this.scene.add.text(-50, -10, "", {
                        "fontFamily": "Helvetica Rounded LT Black",
                        "fontSize": 18,
                        "color": "#5495A4",
                        "align": 'left'
                    });
                    btn.add(label);
                    btn['label'] = label;
                    nscs.util.Functions.updateTextFieldPosition(label, SelectLanguageScreen.LANGUAGUES[lang]);
                    this.add(btn);
                    btn.setSize(190, 37);
                    btn.setInteractive({ cursor: 'pointer' });
                    btn.on('pointerup', () => {
                        nscs.gameplay.Gameplay.currentLanguage = lang;
                        nscs.scene.MainScene.instance.switchScreen(new screen.MainMenuScreen(this.scene));
                        let gaEventLabelMap = {
                            "DE": 'New Super Chick Sisters - Language German',
                            "EN": 'New Super Chick Sisters - Language English',
                            "ES": 'New Super Chick Sisters - Language Spanish',
                            "JA": 'New Super Chick Sisters - Language Japanese',
                            "NL": 'New Super Chick Sisters - Language Dutch',
                            "SK": 'New Super Chick Sisters - Language Slovak'
                        };
                        sendEvent(petaGA_GameCategory_Game, 'Language Selection', gaEventLabelMap[lang]);
                    });
                    btn.on('pointerout', () => {
                    });
                    btn.on('pointerover', () => {
                        this.prevLabel.setColor("#5495A4");
                        this.prevLabel = label;
                        label.setColor("#FFFFFF");
                        this.hi_mc.setFrame(this.hi_mc["framesMap"][lang]);
                        this.scene.tweens.add({
                            targets: this.chick_mc,
                            y: btn.y,
                            duration: 650,
                            ease: Phaser.Math.Easing.Back.Out
                        });
                    });
                    this.buttons[lang] = btn;
                    i++;
                }
                this.hi_mc = new Phaser.GameObjects.Image(this.scene, 315, 80, 'ui-atlas', 'hi_mc' + '0000');
                this.hi_mc["framesMap"] = {
                    "EN": 'hi_mc' + '0000',
                    "NL": 'hi_mc' + '0004',
                    "ES": 'hi_mc' + '0009',
                    "SK": 'hi_mc' + '0014',
                    "JA": 'hi_mc' + '0019',
                    "DE": 'hi_mc' + '0024'
                };
                this.add(this.hi_mc);
                this.chick_mc = nscs.scene.MainScene.instance.factory.createConstructedObject("tinyChickMC");
                this.chick_mc.setOrigin(0.5, 0.5);
                this.add(this.chick_mc);
                //def english
                this.prevLabel = this.buttons[nscs.gameplay.Gameplay.currentLanguage]['label'];
                this.prevLabel.setColor("#FFFFFF");
                requestAnimationFrame(() => { this.chick_mc.setPosition(50, this.buttons[nscs.gameplay.Gameplay.currentLanguage].y); });
            }
        }
        SelectLanguageScreen.LANGUAGUES = {
            "DE": 'Deutsch',
            "EN": 'English',
            "ES": 'Español',
            "JA": '日本語',
            "NL": 'Nederland',
            "SK": 'Slovenčina'
        };
        screen.SelectLanguageScreen = SelectLanguageScreen;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
///<reference path="BaseScreen.ts"/>
var nscs;
(function (nscs) {
    var screen;
    (function (screen) {
        class StorySlides extends screen.BaseScreen {
            constructor(scene, storyIndex, onComplete) {
                super(scene);
                this.delayedCalls = [];
                this.add(this.createGraphicsRect());
                this.slidesContainter = new Phaser.GameObjects.Container(this.scene, 0, 0);
                this.add(this.slidesContainter);
                this.btnNext = new Phaser.GameObjects.Image(this.scene, 464 - 26, 303, 'stories', 'btn_change_slide' + '0000');
                this.add(this.btnNext);
                this.btnPrev = new Phaser.GameObjects.Image(this.scene, 464 - 26 - 22, 303, 'stories', 'btn_change_slide' + '0000');
                this.btnPrev.setScale(-1, 1);
                this.add(this.btnPrev);
                this.text = this.scene.add.text(15, 250, "", {
                    "fontFamily": "Helvetica Rounded LT Black",
                    "fontSize": 12,
                    "color": "#FFFFFF",
                    "align": 'left'
                });
                this.text.setWordWrapWidth(440);
                this.text.setOrigin(0, 0);
                this.add(this.text);
                this.textTyper = new nscs.util.TextTyper(this.scene, this.text, () => {
                    this.delayedCalls.push(nscs.util.Functions.delayedCall(2000, () => this.showNextSlide()));
                });
                this.slides = StorySlides.STORY_DATA[storyIndex];
                this.slidesNum = StorySlides.STORY_DATA[storyIndex].length;
                this.slideIndex = -1;
                this.showNextSlide();
                let outAlpha = 0.65;
                this.btnNext.alpha = outAlpha;
                this.btnNext.setInteractive({ cursor: 'pointer' });
                this.btnNext.on('pointerup', () => {
                    this.showNextSlide();
                });
                this.btnNext.on('pointerover', () => {
                    this.btnNext.alpha = 1;
                });
                this.btnNext.on('pointerout', () => {
                    this.btnNext.alpha = outAlpha;
                });
                this.btnPrev.alpha = outAlpha;
                this.btnPrev.setInteractive({ cursor: 'pointer' });
                this.btnPrev.on('pointerup', () => {
                    this.showPrevSlide();
                });
                this.btnPrev.on('pointerover', () => {
                    this.btnPrev.alpha = 1;
                });
                this.btnPrev.on('pointerout', () => {
                    this.btnPrev.alpha = outAlpha;
                });
                this.onComplete = onComplete;
            }
            createGraphicsRect() {
                let r = new Phaser.GameObjects.Graphics(this.scene);
                r.setPosition(0, 0);
                r.fillStyle(0x000000, 1);
                r.fillRect(0, 0, game.scale.width, game.scale.height);
                return r;
            }
            showNextSlide() {
                if (this.slideIndex >= this.slidesNum - 1) {
                    if (this.onComplete) {
                        nscs.sound.SoundManager.getInstance().fadeMusic(null, 1500);
                        let onComplete = this.onComplete;
                        let fg = this.createGraphicsRect();
                        this.add(fg);
                        fg.alpha = 0;
                        this.scene.tweens.add({
                            targets: fg,
                            'alpha': 1,
                            duration: 1500,
                            onComplete: onComplete
                        });
                        this.onComplete = null;
                    }
                    return;
                }
                this.slideIndex++;
                let slide;
                if (this.slidesContainter.length > this.slideIndex) {
                    slide = this.slidesContainter.getAt(this.slideIndex);
                }
                else {
                    slide = new Phaser.GameObjects.Image(this.scene, 0, 0, 'stories', this.slides[this.slideIndex]['image'] + '0000');
                    slide.setOrigin(0, 0);
                    slide.setInteractive({ cursor: 'pointer' });
                    slide.on('pointerup', () => {
                        this.showNextSlide();
                    });
                }
                this.slidesContainter.add(slide);
                let prevSlide = null;
                if (this.slideIndex - 1 >= 0) {
                    prevSlide = this.slidesContainter.getAt(this.slideIndex - 1);
                    if (prevSlide.frame.name != slide.frame.name) {
                        this.scene.tweens.add({
                            targets: prevSlide,
                            'alpha': 0,
                            duration: 500
                        });
                    }
                    else {
                        this.scene.tweens.killTweensOf(prevSlide);
                        prevSlide.alpha = 0;
                    }
                }
                if (!prevSlide || prevSlide.frame.name != slide.frame.name) {
                    slide.alpha = 0;
                    this.scene.tweens.add({
                        targets: slide,
                        'alpha': 1,
                        duration: 500
                    });
                }
                else {
                    this.scene.tweens.killTweensOf(slide);
                    slide.alpha = 1;
                }
                this.typeText();
                if (this.slides[this.slideIndex]['soundtrack']) {
                    nscs.sound.SoundManager.getInstance().fadeMusic(this.slides[this.slideIndex]['soundtrack'], 500, true);
                }
            }
            typeText() {
                this.textTyper.typeText(nscs.gameplay.Gameplay.getText(this.slides[this.slideIndex]['text']));
            }
            showPrevSlide() {
                let currSlide = this.slidesContainter.getAt(this.slideIndex);
                if (this.slideIndex < 1) {
                    this.typeText();
                    return;
                }
                this.slideIndex--;
                let prevSlide = this.slidesContainter.getAt(this.slideIndex);
                if (prevSlide.frame.name != currSlide.frame.name) {
                    this.scene.tweens.add({
                        targets: prevSlide,
                        'alpha': 1,
                        duration: 500
                    });
                    this.scene.tweens.add({
                        targets: currSlide,
                        'alpha': 0,
                        duration: 500
                    });
                }
                else {
                    prevSlide.alpha = 1;
                    currSlide.alpha = 0;
                }
                this.typeText();
            }
            destroy(fromScene) {
                for (let dc of this.delayedCalls) {
                    nscs.util.Functions.destroyDelayedCall(dc);
                }
                this.delayedCalls = [];
                this.textTyper.stop();
                super.destroy(fromScene);
            }
            updateScreen() {
                super.updateScreen();
                if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                    nscs.scene.MainScene.instance.inputController.escPressUsed();
                    nscs.scene.MainScene.instance.switchScreen(new nscs.screen.ChooseCharacterScreen(this.scene));
                    nscs.sound.SoundManager.getInstance().fadeMusic(null, 500);
                }
                else if (nscs.scene.MainScene.instance.inputController.spacePressedDownAndReleased()) {
                    nscs.scene.MainScene.instance.inputController.spacePressUsed();
                    this.showNextSlide();
                }
            }
        }
        StorySlides.STORY_DATA = {
            1: [
                {
                    image: 'story_1_1',
                    text: 'cutscene0_1',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_1_2',
                    text: 'cutscene0_2',
                    soundtrack: 'soundtrackCSDoom'
                },
                {
                    image: 'story_1_3',
                    text: 'cutscene0_3',
                    soundtrack: 'soundtrackCSDoom'
                },
                {
                    image: 'story_1_3',
                    text: 'cutscene0_4',
                    soundtrack: 'soundtrackCSDoom'
                },
                {
                    image: 'story_1_4',
                    text: 'cutscene0_6',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_1_5',
                    text: 'cutscene0_7',
                    soundtrack: 'soundtrackCS1'
                }
            ],
            2: [
                {
                    image: 'story_2_1',
                    text: 'cutscene1_1',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_2_2',
                    text: 'cutscene1_2',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_2_3',
                    text: 'cutscene1_3',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_2_4',
                    text: 'cutscene1_4',
                    soundtrack: 'soundtrackCS1'
                }
            ],
            3: [
                {
                    image: 'story_3_1',
                    text: 'cutscene2_1',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_3_1',
                    text: 'cutscene2_1B',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_3_2',
                    text: 'cutscene2_2',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_3_2',
                    text: 'cutscene2_3',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_3_2',
                    text: 'cutscene2_3B',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_3_3',
                    text: 'cutscene2_4',
                    soundtrack: 'soundtrackCS1'
                }
            ],
            4: [
                {
                    image: 'story_4_1',
                    text: 'cutscene3_1',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_4_1',
                    text: 'cutscene3_1B',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_4_2',
                    text: 'cutscene3_2',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_4_3',
                    text: 'cutscene3_3',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_4_2',
                    text: 'cutscene3_4',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_4_2',
                    text: 'cutscene3_5',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_4_3',
                    text: 'cutscene3_6',
                    soundtrack: 'soundtrackCS1'
                }
            ],
            5: [
                {
                    image: 'story_5_1',
                    text: 'cutscene4_1',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_5_1',
                    text: 'cutscene4_2',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_5_1',
                    text: 'cutscene4_3',
                    soundtrack: 'soundtrackCS1'
                }
            ],
            6: [
                {
                    image: 'story_6_1',
                    text: 'cutscene5_1',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_6_1',
                    text: 'cutscene5_1B',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_6_1',
                    text: 'cutscene5_2',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_6_2',
                    text: 'cutscene5_3',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_6_2',
                    text: 'cutscene5_4',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_6_3',
                    text: 'cutscene5_5',
                    soundtrack: 'soundtrackCS1'
                },
                {
                    image: 'story_6_4',
                    text: 'cutscene5_6',
                    soundtrack: 'soundtrackCS2'
                },
                {
                    image: 'story_6_5',
                    text: 'cutscene5_7',
                    soundtrack: 'soundtrackCS2'
                },
            ]
        };
        screen.StorySlides = StorySlides;
    })(screen = nscs.screen || (nscs.screen = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var sound;
    (function (sound) {
        class SoundManager {
            constructor(scene) {
                this.music = null;
                this.sounds = [];
                this.muted = false;
                this.currentMusic = "";
                this.scene = scene;
            }
            static getInstance() {
                if (!SoundManager._instance) {
                    SoundManager._instance = new SoundManager(game.scene.getAt(0));
                }
                return SoundManager._instance;
            }
            playMusic(filename, loop = false) {
                if (this.currentMusic == filename) {
                    return;
                }
                this.stopMusic();
                this.music = this.scene.sound.add(filename);
                this.music["filename"] = filename;
                this.music.loop = loop;
                this.music.play();
                this.music.setVolume(this.muted ? 0 : 1);
                this.currentMusic = filename;
            }
            stopMusic() {
                this.currentMusic = "";
                if (this.music)
                    this.music.stop();
            }
            mute() {
                if (this.muted) {
                    this.muted = false;
                    if (this.music)
                        this.revertMusic(1000);
                }
                else {
                    this.muted = true;
                    if (this.music)
                        this.fadeMusic(null, 1000);
                }
            }
            playSound(filename, volume = 1) {
                let snd = filename;
                try {
                    let s = this.scene.sound.add(snd);
                    s["filename"] = filename;
                    s.play();
                    if (this.muted) {
                        s.setVolume(0);
                    }
                    else {
                        s.setVolume(volume);
                    }
                    this.sounds.push(s);
                }
                catch (_a) {
                }
            }
            stopSound() {
                for (let s of this.sounds)
                    s.stop();
            }
            fadeMusic(to, time, loop = false) {
                if (this.currentMusic == to)
                    return;
                if (this.music) {
                    let _music = this.music;
                    this.scene.tweens.add({
                        targets: _music,
                        "volume": 0,
                        duration: time,
                        ease: Phaser.Math.Easing.Linear,
                        onComplete: () => {
                            if (to)
                                _music.stop();
                        }
                    });
                    if (to) {
                        this.music = null;
                        this.currentMusic = null;
                    }
                }
                if (!to)
                    return;
                this.playMusic(to, loop);
                this.music.setVolume(0);
                if (!this.muted) {
                    this.scene.tweens.add({
                        targets: this.music,
                        "volume": 1,
                        duration: time,
                        ease: Phaser.Math.Easing.Linear
                    });
                }
            }
            revertMusic(time) {
                if (this.music) {
                    let _music = this.music;
                    this.scene.tweens.add({
                        targets: _music,
                        "volume": this.muted ? 0 : 1,
                        duration: time,
                        ease: Phaser.Math.Easing.Linear
                    });
                }
            }
        }
        SoundManager._instance = null;
        sound.SoundManager = SoundManager;
    })(sound = nscs.sound || (nscs.sound = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var util;
    (function (util) {
        class Functions {
            static rewriteWordWrapping() {
                (function (setWordWrapWidth) {
                    Phaser.GameObjects.Text.prototype.setWordWrapWidth = function (t, e) {
                        if (!this.hasOwnProperty('-wordWrapWidth-')) {
                            this['-wordWrapWidth-'] = t;
                        }
                        if (typeof e === "undefined")
                            e = true;
                        // Now, call the original method
                        return setWordWrapWidth.apply(this, [t, e]);
                    };
                })(Phaser.GameObjects.Text.prototype.setWordWrapWidth);
            }
            static updateTextFieldPosition(textField, setText = null) {
                if (!textField.hasOwnProperty('-fontSize-')) {
                    let fontSize = Number(textField.style.fontSize.split('px')[0]);
                    textField["-fontSize-"] = fontSize;
                    textField.setFontSize(fontSize * Functions.SCALE_UP_TEXT_FIELDS);
                    textField.setScale(1 / Functions.SCALE_UP_TEXT_FIELDS);
                    if (textField['-wordWrapWidth-']) {
                        textField.setWordWrapWidth(textField['-wordWrapWidth-'] * Functions.SCALE_UP_TEXT_FIELDS);
                    }
                }
                if (!textField.hasOwnProperty('-strokeThickness-')) {
                    if (textField.style.stroke) {
                        textField["-strokeThickness-"] = textField.style.strokeThickness;
                        textField.setStroke(textField.style.stroke, textField.style.strokeThickness * Functions.SCALE_UP_TEXT_FIELDS);
                    }
                }
                if (!textField.hasOwnProperty('-originX-')) {
                    textField["-originX-"] = textField.originX;
                    textField.originX = 0;
                }
                if (!textField.hasOwnProperty('-originY-')) {
                    textField["-originY-"] = textField.originY;
                    textField.originY = 0;
                }
                if (!textField.hasOwnProperty('-def-x-')) {
                    textField['-def-x-'] = textField.x;
                }
                if (!textField.hasOwnProperty('-def-y-')) {
                    textField['-def-y-'] = textField.y;
                }
                if (setText) {
                    textField.setText(setText);
                }
                textField.x = Math.round(textField['-def-x-'] - textField.width * textField.scaleX * textField["-originX-"]);
                textField.y = Math.round(textField['-def-y-'] - textField.height * textField.scaleY * textField["-originY-"]);
            }
            static delayedCall(delay, callback, args, callbackScope) {
                let scene = game.scene.getAt(0);
                if (scene) {
                    let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
                    Functions.delayedCalls.push(dc);
                    return dc;
                }
                let t = setTimeout(callback, delay);
                Functions.delayedCalls.push(t);
                return t;
            }
            static pauseAllDelayedCalls() {
                for (let dc of Functions.delayedCalls) {
                    if (dc instanceof Phaser.Time.TimerEvent) {
                        dc.paused = true;
                    }
                }
            }
            static resumeAllDelayedCalls() {
                for (let dc of Functions.delayedCalls) {
                    if (dc instanceof Phaser.Time.TimerEvent) {
                        dc.paused = false;
                    }
                }
            }
            static destroyAllDelayedCalls() {
                for (let dc of Functions.delayedCalls) {
                    if (dc instanceof Phaser.Time.TimerEvent) {
                        dc.remove(false);
                    }
                    else {
                        clearTimeout(dc);
                    }
                }
                Functions.delayedCalls = [];
            }
            static destroyDelayedCall(dc) {
                let ind = Functions.delayedCalls.indexOf(dc);
                if (ind >= 0) {
                    Functions.delayedCalls.splice(ind, 1);
                }
                if (dc instanceof Phaser.Time.TimerEvent) {
                    dc.remove(false);
                }
                else {
                    clearTimeout(dc);
                }
            }
            static capitalise(str) {
                let newstr = '';
                let words = str.split(' ');
                for (let w = 0; w < words.length; w++) {
                    let word = words[w];
                    word = word.substr(0, 1).toUpperCase() + word.substr(1);
                    newstr += (newstr) ? ' ' : '';
                    newstr += word;
                }
                return newstr;
            }
            static trim(str) {
                let newline = '\n';
                while (str.substr(0, 1) == ' ') {
                    str = str.substr(1);
                }
                while (str.substr(0, 1) == newline) {
                    str = str.substr(1);
                }
                while (str.substr(0, 1) == '    ') {
                    str = str.substr(0, -1);
                }
                while (str.substr(-1, 1) == ' ') {
                    str = str.substr(0, -1);
                }
                while (str.substr(-1, 1) == newline) {
                    str = str.substr(0, -1);
                }
                while (str.substr(-1, 1) == '    ') {
                    str = str.substr(0, -1);
                }
                return str;
            }
            static DetectPhaserRenderMode() {
                /*var ua = window.navigator.userAgent;
                var isIE = ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0;
                var isOldIPhone = (ua.indexOf('iPhone ') > -1 && window.screen.width <= 414 && window.screen.height <= 736);
                var isFirefox = ua.toLowerCase().indexOf('firefox') > -1;
                var isAndroid = ua.toLowerCase().indexOf("android") > -1;
                if (isIE) return Phaser.CANVAS;
                if (isFirefox) return Phaser.WEBGL;
                return isOldIPhone || isAndroid ? Phaser.CANVAS : Phaser.AUTO;*/
                return Phaser.AUTO;
            }
            ;
            static pad(n, width, z) {
                z = z || '0';
                n = n + '';
                return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
            }
            ;
        }
        Functions.SCALE_UP_TEXT_FIELDS = 3;
        Functions.delayedCalls = [];
        util.Functions = Functions;
    })(util = nscs.util || (nscs.util = {}));
})(nscs || (nscs = {}));
var nscs;
(function (nscs) {
    var util;
    (function (util) {
        class TextTyper {
            constructor(scene, textField, onComplete = null) {
                this.typeCounter = 0;
                this.typeString = "";
                this.advanceLetter = () => {
                    if (!this.textField.parentContainer)
                        return;
                    var nextSpace = NaN;
                    var prevSpace = NaN;
                    var prevHeight = NaN;
                    this.typeCounter++;
                    if (this.typeCounter <= this.typeString.length) {
                        // GameWorld.soundManager.playSound("dialog");
                        nextSpace = this.typeString.indexOf(" ", this.typeCounter);
                        if (nextSpace == -1) {
                            nextSpace = this.typeString.length;
                        }
                        prevSpace = Math.max(0, this.typeString.lastIndexOf(" ", this.typeCounter));
                        nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, this.typeCounter));
                        prevHeight = this.textField.height;
                        nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, nextSpace));
                        if (prevHeight != this.textField.height && (this.typeString.indexOf("\n", prevSpace) >= nextSpace || this.typeString.indexOf("\n", prevSpace) == -1)) {
                            nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, prevSpace) + "\n" + this.typeString.substr(prevSpace + 1, this.typeCounter - (prevSpace + 1)));
                        }
                        else {
                            nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, this.typeCounter));
                        }
                    }
                    else {
                        nscs.util.Functions.updateTextFieldPosition(this.textField, this.typeString.substr(0, this.typeString.length));
                        this.stop();
                        if (this.onComplete)
                            this.onComplete();
                    }
                };
                this.scene = scene;
                this.textField = textField;
                this.onComplete = onComplete;
            }
            typeText(newString, speed = 1 / 35) {
                nscs.util.Functions.updateTextFieldPosition(this.textField, "");
                this.typeCounter = 0;
                this.typeString = newString;
                this.stop();
                this.typeTimer = this.scene.time.addEvent({
                    delay: 1 / speed,
                    callback: this.advanceLetter,
                    callbackScope: this,
                    loop: true
                });
            }
            setText(newText) {
                this.typeCounter = this.typeString.length;
                nscs.util.Functions.updateTextFieldPosition(this.textField, newText);
                this.stop();
            }
            isDone() {
                return /*this.lines.length == 0 && */ this.typeCounter >= this.typeString.length;
            }
            stop() {
                if (this.typeTimer) {
                    this.typeTimer.remove();
                    this.typeTimer = null;
                }
            }
        }
        util.TextTyper = TextTyper;
    })(util = nscs.util || (nscs.util = {}));
})(nscs || (nscs = {}));
